export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "酒店知识库",
    "tip": "管理当前酒店的常见问题和答案。",
    "created": "创建时间",
    "updated": "更新时间",
    "to": "至",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "question": "问题",
    "answer": "答案",
    "tags": "标签",
    "questionSearch": "输入问题关键词",
    "tagSearch": "输入标签关键词",
    "search": "查询",
    "reset": "重置",
    "create": "新增",
    "batchDelete": "批量删除",
    "loadFailed": "加载失败，请重试",
    "notFilled": "未填写",
    "actions": "操作",
    "view": "查看全文",
    "edit": "编辑",
    "delete": "删除",
    "details": "知识详情",
    "missingTitle": "历史内容缺失",
    "missingView": "当前记录的问题或答案未填写，编辑保存前必须补全。",
    "missingForm": "问题或答案未填写，保存前必须补全。",
    "noDetails": "暂无详情",
    "close": "关闭",
    "enterQuestion": "请输入问题",
    "enterAnswer": "请输入答案",
    "answerPlaceholder": "请输入答案，支持多行文本",
    "tagPlaceholder": "输入标签后按回车添加",
    "tagTip": "按回车添加标签，标签不按逗号或空格拆分。标签总长度最多512个字符。",
    "cancel": "取消",
    "save": "保存",
    "chooseHotel": "请先选择酒店",
    "empty": "暂无数据",
    "editTitle": "编辑知识",
    "createTitle": "新增知识",
    "tagRequired": "请至少添加一个标签",
    "tagText": "标签必须为文本，请删除后重新添加",
    "tagBlank": "标签不能为空白，请删除后重新添加",
    "tagsTooLong": "标签内容过长，请精简标签后重试",
    "questionTooLong": "问题不能超过512个字符",
    "answerTooLong": "答案不能超过5000个字符",
    "invalidRecord": "记录信息异常，请重新打开编辑",
    "editSuccess": "编辑成功",
    "createSuccess": "新增成功",
    "deleteLimit": "单次最多删除100条",
    "confirmBatch": "确认删除当前页选中的 {count} 条知识吗？删除后无法恢复。",
    "confirmOne": "确认删除该条知识吗？删除后无法恢复。",
    "deleteConfirm": "删除确认",
    "confirmDelete": "确认删除",
    "deleteSuccess": "删除成功",
    "dataChanged": "数据已变化，请刷新列表后查看"
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "AI用量统计",
    "priceConfig": "房型定价配置",
    "dateRange": "日期范围",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "scene": "通知类型",
    "all": "全部",
    "callStatus": "调用状态",
    "callStatusLabel": "调用状态说明",
    "running": "执行中",
    "success": "成功",
    "failed": "失败",
    "tokenStatus": "用量数据",
    "tokenStatusLabel": "用量数据说明",
    "known": "已获取",
    "unknownUsage": "未获取",
    "query": "查询",
    "reset": "重置",
    "categoryError": "通知类型加载失败",
    "retry": "重新加载",
    "chooseHotel": "请先选择当前酒店",
    "dailyUsage": "每日 AI 用量",
    "noCallsFiltered": "所选条件下暂无调用记录。",
    "statisticsError": "用量统计加载失败",
    "loadingTrend": "正在加载趋势…",
    "details": "调用明细",
    "detailsError": "调用明细加载失败",
    "loading": "正在加载…",
    "noCalls": "暂无调用记录",
    "waiting": "等待查询",
    "callTime": "调用时间",
    "usage": "AI 用量",
    "requestInfo": "请求信息",
    "requestId": "请求 ID：",
    "requestDetails": "请求详情",
    "totalUsage": "AI 总用量",
    "callCount": "调用次数",
    "successCount": "调用成功次数",
    "unknownCount": "用量未知次数",
    "today": "今天",
    "last7": "近 7 天",
    "last30": "近 30 天",
    "thisMonth": "本月",
    "pending": "待统计",
    "unknown": "未知",
    "usageLabel": "用量：",
    "callCountLabel": "调用次数：",
    "unknownCountLabel": "用量未知次数：",
    "missingUsage": "存在未获取统计的调用",
    "usageAxis": "用量",
    "description": "统计当前酒店已记录的 AI 调用用量，不包含未关联酒店的聊天记录。日期按北京时间统计。",
    "callStatusHelp": "执行中、成功、失败均指平台调用状态；成功不表示通知已生成。",
    "usageHelp": "已获取：已有具体用量，包含零用量。未获取：有调用记录但用量未知，未计入总用量；与调用成功或失败无关。",
    "invalidDates": "请选择有效日期范围，开始日期不得晚于结束日期，且不能晚于北京时间今天"
  },
  navbar: {
    searchHotel: '搜索酒店名',
    nightAudit: '夜审',
    nightAuditWarning: '酒店正在执行夜审，请稍后重试',
    groupBooking: '团队预订',
  },
  common: {
    logo: 'Logo',
    bundleSale: '包栋',
    splitTax: '拆分税金',
    taxIncluded: '价内税',
    taxExcluded: '价外税',
    businessFeeUnit: '业务单位',
    fixedAmount: '固定金额',
    percentage: '百分比',
    pleaseEnter: '请输入',
    confirmCheckInOutTime: '您预订的是 {checkIn} 入住的房间，离店时间为 {checkOut}，请确认入离时间',
    tax: '税',
    expenseWithTax: '消费（含税）',
    totalProductPrice: '商品总价',
    expenseWithoutTax: '消费金额（不含税）',
    roomFeeWithoutTax: '房费金额（不含税）',
    salesAmountWithoutTax: '销售金额（不含税）',
    taxIncludedPrice: '税价',
    title: '轻赢宝酒店管理系统',
    billingCycleType: '账期类型',
    weeklySettlement: '周结算',
    monthlySettlement: '月结算',
    accountReceivablePayment: 'AR账支付',
    noResults: '没有找到相关酒店信息',
    shiftHandover: '交班',
    salesClerk: '营业员',
    currentShift: '当前班次',
    requestFailed: '请求失败',
    confirmModify: '确认修改',
    operationSuccess: '操作成功！',
    individualBooking: '散客预订',
    longBooking: '长包房预订',
    cashPay: '现付',
    cashPayment: '现付账',
    doorCard: '门卡',
    more: '更多',
    success: '成功',
    close: '关闭',
    loadingEllipsis: '加载中...',
    cancel: '取消',
    printReport: '打印',
    printTime: '打印时间',
    businessDay: '营业日期',
    operationDate: '操作日期',
    subject: '科目',
    amount: '金额',
    save: '保存',
    yuan: '元',
    confirm: '确认',
    nextStep: '下一步',
    all: '全部',
    immediateQuery: '查询',
    action: '操作',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    inputYuan: '请输入(元)',
    yes: '是',
    no: '否',
    remark: '备注',
    delete: '删除',
    oneHour: '一小时',
    twoHours: '二小时',
    threeHours: '三小时',
    fourHours: '四小时',
    fiveHours: '五小时',
    sixHours: '六小时',
    sevenHours: '七小时',
    eightHours: '八小时',
    saveSuccess: '保存成功',
    notice: '提示',
    status: '状态',
    cancelled: '已取消',
    booked: '已预订',
    hardLoading: '拼命加载中',
    startDate: '开始日期',
    endDate: '结束日期',
    Deadline: '截止日期',
    name2: '姓名',
    roomNumber: '房间号',
    checkInDate3: '入住日期',
    checkOutDate3: '离店日期',
    unitPrice3: '单价',
    quantity: '数量',
    addBook: '添加账套',
    bookName: '账套名称',
    accountOfConsumption: '消费科目',
    details3: '详情',
    id: '编号',
    commodityDetail: '商品明细',
    externalDocumentNumber: '外部单据号',
    accountOfPayment2: '付款科目',
    strikeABalance: '冲账',
    pleaseFillInRemarks2: '请填写备注',
    search: '搜索',
    nationality: '国籍',
    sex: '性别',
    male: '男',
    female: '女',
    nation: '民族',
    contactInformation2: '联系方式',
    dateOfBirth: '出生日期',
    documentType: '证件类型',
    address2: '住址',
    documentNumber: '证件号码',
    validityOfVisa: '签证有效期',
    visaType: '签证类型',
    visaNumber: '签证号码',
    pleaseEnterYourIdNumber: '请输入证件号码',
    pleaseEnterTheCorrectIdNumber4: '请输入正确的证件号码',
    pleaseFillInYourName2: '请填写姓名',
    pleaseSelectDocumentType: '请选择证件类型',
    dontWorryAboutGoldMembers2: '轻住黄金会员',
    goEasyOnThePlatinumMembers2: '轻住白金会员',
    lightOnDiamondMembers2: '轻住钻石会员',
    unregisteredMember: '未注册会员',
    ok2: '确定',
    issuingAuthority: '发证机关',
    idPhoto: '身份证头像',
    qingzhuGroup: '轻住集团',
    mobilePhoneNumber: '手机号',
    view: '查看',
    activated: '已激活',
    nonmember: '非会员',
    coupon: '优惠券',
    ranking5: '排名',
    hotelName4: '酒店名称',
    isNotSet: '未设置',
    yu: '余',
    noVacancy: '满房',
    consumption: '消费',
    refund: '退款',
    iGotIt2: '知道了',
    startANightTrial: '开始夜审',
    operator: '操作员',
    handledBy: '操作人',
    to: '至',
    currentBusinessDay: '当前营业日',
    ok: '确 定',
    morningShift2: '早班',
    middleShift2: '中班',
    nightShift2: '晚班',
    pleaseEnterYourName: '请输入姓名',
    selectAll: '全选',
    pleaseEnterContent: '请输入内容',
    serialNumber: '序号',
    address: '地址',
    signatureOfAuthorizer: '批准人签字',
    signature3: '签名',
    roomType: '房型',
    dayRate: '当日房价',
    checkInTime: '入住时间',
    checkOutTime: '离店时间',
    settlementAmount: '结算金额',
    hotelAddress: '酒店地址',
    selectDate: '选择日期',
    selectionTime: '选择时间',
    cancelCard: '注销卡',
    thisCardIsEmptyPleaseMakeABusinessCardFirst: '此卡为空卡，请先制卡',
    logoutSuccessful: '注销成功',
    cardCancellationFailure: '注销卡失败',
    contactSupport: '请联系技术支持检查硬件服务是否可用',
    submit: '提交',
    contactPerson6: '联系人',
    contactNumber2: '联系电话',
    merchant3: '商家',
    Submitsuccessfully: '提交成功',
    smallProgram: '小程序',
    technicalSupport: '技术支持',
    roomBillCheck: '房费账单核对',
    financialAssistant: '财务助手',
    settlementCycle: '结算周期',
    refundSuccessful: '退款成功',
    beingRefunded: '退款中',
    refundFailure: '退款失败',
    channel: '渠道',
    cloakroom: '关房',
    infiniteQuantity: '无限量',
    compute: '计算',
    dateOfSale: '售卖日期',
    originalPrice: '原价',
    pleaseEnterTheOriginalPrice: '请输入原价',
    member: '会员',
    salesAmount: '销售金额',
    amountOfConsumption: '消费金额',
    protocolUnit: '协议单位',
    subjectDesc: '科目描述',
    qzOrderNo: '轻住订单号',
    checkInType: '入住类型',
    checkInOutDate: '入离日期',
    channelOrderNo: '渠道单号',
    pleaseEnterTheCorrectPhoneNumber3: '请输入正确手机号',
    logs: '日志',
    walkIn: '散客步入',
    businessCardPrintingSuccess: '制卡成功',
    exportSuccessfully2: '导出成功',
    exportFailure: '导出失败',
    other: '其他',
    toBeProcessed: '待处理',
    completed: '已完成',
    commonProduct: '普通产品',
    freeRoomProducts: '免费房产品',
    makeACard: '制卡',
    day: '日',
    points2: '分',
    sunday: '周日',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    lose: '失败',
    since: '起',
    amountTotal: '合计',
    total: '总计',
    tradeName: '商品名称',
    itemType: '物品类型',
    orderStatus: '订单状态',
    orderNumber: '订单号',
    anonymousUser: '匿名用户',
    commentTime: '评论时间',
    merchantReply: '商家回复',
    recoveryTime: '回复时间',
    recover: '回复',
    pleaseWriteAResponseOfAtLeast10Words: '请至少填写10字以上的回复',
    replyTextMinimum10Words: '回复文字最少10个字',
    negativeComment: '差评',
    cancel2: '取 消',
    commentTemplateManagement: '评论模板管理',
    modifiedSuccessfully: '修改成功',
    hygiene: '卫生',
    service: '服务',
    facility: '设施',
    position: '位置',
    appeal: '申诉',
    successfullyDeleted: '删除成功',
    replySuccessfully2: '回复成功',
    theMobilePhoneNumberFormatIsIncorrect5: '手机号码格式错误',
    none4: '暂无',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen: '暂未开通此功能，如需开通请点击开通',
    noCommentsYet: '暂无评论',
    picture: '图片',
    guestName: '客人姓名',
    handle: '处理',
    edit: '修改',
    type: '类型',
    salesman: '销售员',
    successfulOperation: '操作成功',
    pleaseEnterTheCompanyName2: '公司名称',
    customerType: '客户类型',
    effective: '有效',
    inVain: '无效',
    valid: '有效',
    forbidden: '禁用',
    enable: '启用',
    companyName2: '公司名称',
    favorable2: '优惠',
    day2: '天',
    telephone: '电话',
    pleaseEnterThePhoneNumber: '请输入电话号码',
    mailbox: '邮箱',
    accountName: '账户名称',
    startTime: '开始时间',
    endTime: '结束时间',
    beingSubmitted: '提交中',
    pleaseSelectGender: '请选择性别',
    confirmDeletion: '确认删除',
    letMeThinkItOver: '我再想想',
    theSizeOfTheUploadedPictureCannotExceed: '上传图片大小不能超过',
    identificationCard2: '身份证',
    editor: '编辑',
    topLine: '上线',
    downline: '下线',
    validity: '有效期',
    fullDayRoom: '全日房',
    hourlyRoom: '钟点房',
    append3: '添加',
    immediatelyReduce3: '立减',
    activityName2: '活动名称',
    sort: '分类',
    on: '开启',
    amountOfGift2: '赠送金额',
    pleaseFillIn2: '请填写',
    pleaseSelectADate: '请选择日期',
    roomFeeConsumption: '房费消费',
    selectFile: '选择文件',
    uploadFailure: '上传失败',
    uploadSuccessfully: '上传成功',
    print: '打印',
    dateRange: '日期',
    reupload: '重新上传',
    printBill: '打印账单',
    cardNumber: '卡号',
    paymentMethod: '付款方式',
    payMethod: '支付方式',
    balance: '余额',
    membershipCardNumber: '会员卡号',
    birthday: '生日',
    tradingHours: '交易时间',
    enterAMaximumOf50Characters: '最多输入50个字',
    membersMobileNumber: '会员手机号',
    time: '时间',
    modifyInformation: '修改信息',
    lengthOfStay: '入住天数',
    roomListNumber: '房单号',
    roomTypeName: '房型名称',
    settleAccounts: '结账',
    accountNumber: '入账账号',
    paymentRecord: '付款记录',
    paymentAmount: '付款金额',
    paymentVerificationCode: '支付验证码',
    enterInAnAccount: '入账',
    pleaseSelectACollectionSet: '请选择应收账套',
    pleaseSelectTheAccountNumber: '请选择入账账号',
    pleaseSelectAPaymentMethod: '请选择付款方式',
    vipSignature: '贵宾签字',
    amountNotWrittenOff3: '未核销金额',
    availableCredit3: '可用额度',
    maximumAmount4: '最高额度',
    whetherItIsValidOrNot: '是否有效',
    enabledSuccessfully: '启用成功',
    disableSuccessfully: '禁用成功',
    roomNumberName: '房号-姓名',
    payment2: '付款',
    operatingTime: '操作时间',
    classes: '班次',
    transfer: '转账',
    accountOutstanding2: '未结账',
    accountClosed: '已结账',
    rolledOut: '已转出',
    haveStruckOff: '已冲账',
    noRoomChargeIsGenerated: '不生成房费',
    date3: '日期',
    itemName4: '物品名称',
    pleaseEnterRemarks2: '请输入备注',
    entryAndDepartureTime: '入离时间',
    roomRate: '房价',
    preAuthorizationAmount: '预授权金额',
    room: '房间',
    settlement: '结算',
    pleaseSelectMemberInformation: '请选择会员信息',
    pleaseFillInThePaymentVerificationCode: '请填写支付验证码',
    accountNumber3: '账号',
    successfulEntry: '入账成功',
    externalOrderNumber: '外部单号',
    transferTo: '转入',
    beAuthorized: '已授权',
    haveAlreadySettled: '已结算',
    authorizationMode: '授权方式',
    authorizedAmount: '授权金额',
    authorizationTime: '授权时间',
    productType: '产品类型',
    pleaseEnterTheChannelNumber: '请输入渠道单号',
    derive: '导出',
    unwritten: '未核销',
    cancelled3: '已核销',
    lehuiScanTheCode: '乐惠-扫码',
    amountOnAccount3: '挂账金额',
    billingTime5: '挂账时间',
    nameOfGuest3: '入住人姓名',
    roomNumber3: '房间号',
    people: '人',
    nameOfExpenseItem: '费用项名称',
    viewDetails: '查看详情',
    bankOfDeposit: '开户行',
    bankCardNumber4: '银行卡号',
    toBeConfirmed2: '待确认',
    rejected: '已驳回',
    adjustmentAmount: '调整金额',
    meituan: '美团',
    totalOrderAmount: '订单总金额',
    lightSettlementWithMerchants: '轻住与商家结算',
    membershipDistribution: '会员分润',
    crossStoreRebate: '跨店返佣',
    avoidCommissionSubsidies: '轻住佣金补贴',
    membershipIncentiveSettlement: '会员激励结算',
    theUnitedStatesGroupDirectlyConnected: '美团直连',
    flyingPigsConnectDirectly: '飞猪直连',
    fullNameOfTheBank4: '开户行全称',
    accountBankAbbreviation4: '开户行简称',
    theLocationOfTheBank4: '开户行所在地',
    pleaseEnterYourFullBankName2: '请输入开户行全称',
    pleaseSelectBankAbbreviation2: '请选择开户行简称',
    pleaseSelectYourBankLocation2: '请选择开户行所在地',
    pleaseEnterYourBankCardNumber2: '请输入银行卡号',
    modificationTime2: '修改时间',
    bankExample: '举例：中国工商银行XX支行',
    companyNameNote: '注：如对公则填写公司名称',
    causeOfFailure: '失败原因',
    pleaseEnterYourPhoneNumber: '请输入手机号',
    downloadStatement: '下载对账单',
    operationLog: '操作日志',
    ctripDirectConnection: '携程直连',
    directConnectionInTheSameDirection: '同程直连',
    flyingPig: '飞猪',
    ctrip: '携程',
    roomNight: '间夜',
    pictureUpload: '图片上传',
    aSinglePictureMustNotBeLargerThan: '单张图片不得大于',
    checkInRoomType2: '入住房型',
    checkInPerson: '入住人',
    hotelSellingPrice: '酒店卖价',
    effectiveDate3: '生效日期',
    viewExamples: '查看示例',
    underReview: '审核中',
    billingType: '开票类型',
    invoiceTitle2: '发票抬头',
    pleaseEnterTheInvoiceTitle2: '请输入发票抬头',
    invoiceHasBeenIssued: '已开票',
    haveBeenCancelled: '已作废',
    paymentStatus: '支付状态',
    preferentialPrice: '优惠价',
    gateRate: '门市价',
    availableRoom: '现空房',
    orderableNumber: '可订数',
    numberOfRoomsReserved: '预订间数',
    breakfast: '早餐',
    copyOf: '份',
    dailyRate: '每日房价',
    typeOfTouristSource3: '客源类型',
    namephoneNumbermembershipNumber: '姓名/手机号/会员号',
    selectTimePoint5: '选择时间点',
    externalChannel3: '外部渠道',
    retentionTime3: '保留时间',
    contactName2: '联系人姓名',
    numberOfDays: '天数',
    pleaseSelectAProtocolUnit3: '请选择协议单位',
    pleaseEnterTheNameOfTheExternalChannel2: '请填写外部渠道名称',
    pleaseFillInTheMembershipInformation3: '请填写会员信息',
    pleaseFillInTheReservationName2: '请填写预订人姓名',
    pleaseFillInTheReservationNumber2: '请填写预订人手机号',
    theAmountCanOnlyBeEnteredInNumbers2: '金额只能输入数字',
    noMemberInformationFound: '未查询到相关会员信息',
    noProtocolUnitIsQueried2: '未查询到相关协议单位信息',
    bulkRepricing: '批量改价',
    totalRoomRate6: '总房价',
    trialCalculationOfHousePrice3: '房价试算',
    free: '免费',
    between: '间',
    upgradeRoomType: '升级房型',
    printOrNot: '是否打印',
    predepartureTime2: '预离时间',
    rooms: '间数',
    averageHousePrice: '平均房价',
    arrivalTime: '预抵时间',
    creationTime: '创建时间',
    advancedSearch: '高级搜索',
    simpleSearch: '简单搜索',
    price: '价格',
    orderTaking: '接单',
    sellingPrice: '卖价',
    floorPrice: '底价',
    channelName2: '渠道名称',
    bookingSuccessful2: '预订成功',
    checkedIn2: '已入住',
    cancelSuccessfully2: '取消成功',
    sorting: '排序',
    invoiceNumber2: '发票号',
    taxIdentificationNumber: '纳税识别号',
    emailAddress: '电子邮箱',
    eTicket: '电子专票',
    eTicket2: '电子普票',
    paperTicket: '纸质专票',
    paperTicket2: '纸质普票',
    void: '作废',
    teamType: '团队类型',
    teamName: '团队名称',
    markUpAmount: '加价金额',
    productName: '产品名称',
    lengthOfStay2: '入住时长',
    hours: '小时',
    checkIn: '办理入住',
    changeRooms: '更换房间',
    rowHouse: '排房',
    printCheckInSlip: '打印入住单',
    proceedWith: '继续办理',
    rowHouseSuccess2: '排房成功',
    toCheckIn: '待入住',
    checkedOut: '已退房',
    onAccount: '已挂账',
    basicInformation: '基础信息',
    prepayment: '预付',
    originalHouseType: '原房型',
    seeMore: '查看更多',
    thisRoomSupportsSmartDoorLocks: '该房间支持智能门锁',
    listingStatus: '房单状态',
    checkin: '入住',
    preionization2: '预离',
    weekTitle: '星期',
    thePriceActuallyPaidByTheGuest: '客人实际支付价',
    late3: '晚',
    late4: '日离',
    nonCancellable2: '不可取消',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    lightweightDistribution: '轻住分销',
    liveAndTravelLightly: '轻住商旅',
    jingdongDirectLink: '京东直连',
    baiduMapDirectConnection: '百度地图直连',
    tiktokDirectConnection: '抖音直连',
    ctripSingleStore: '携程单店',
    agoda: 'Agoda',
    meituanHomestay: '美团民宿',
    tujiaHomestay: '途家民宿',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: '前可取消',
    partialWriteOff: '部分核销',
    tookEffect: '已生效',
    loseEffectiveness: '失效',
    joinAHouse3: '加入联房',
    bookingInformation: '预订信息',
    pleaseSelectARoom3: '请选择房间',
    houseInformation: '联房信息',
    thereIsNoRowHouse: '间未排房',
    reasonsForChangingRooms3: '换房原因',
    numberOfRooms7: '房间总数',
    typeOfOperation3: '操作类型',
    exchangeAndUpgradeReport2: '换房及升级报表',
    noDataAvailable2: '暂无数据',
    pleaseSelectABusinessDayRange2: '请选择营业日范围',
    exportReport: '导出',
    accountName3: '科目名称',
    aMaximumOf31DaysCanBeQueried: '时间段最多支持31天查询',
    naturalDay2: '自然日',
    otherConsumption3: '其他消费',
    aggregateConsumption3: '总消费',
    aggregateConsumptionTaxIncluded: '总消费（含税）',
    materialType: '物品类型',
    materialName: '物品名称',
    storageTypeSell: '售卖',
    materialCode: '物品编码',
    materialUnit: '规格单位',
    inStorageNum: '入库数量',
    outStorageNum: '出库数量',
    selectTime: '请选择时间',
    floor: '楼层',
    lumpSumPayment3: '总付款',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay: '大于半日房价的不足全日房价的记全日',
    businessDate: '营业日期',
    calculationFormula: '计算公式',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight: '人工加收房费间夜计算：半日房费0.5间夜，全日房费1间夜',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate: '半日房费：加收金额小于等于房价一半',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn: '全日房费：加收金额大于等于房价，金额超过房价2倍，记2间夜，以此类推',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights: '出租间夜数：不包含免费房、自用房间夜数',
    subtotal: '小计',
    totalOccupancy3: '总房数',
    lettingRate: '出租率',
    inResidenceDate: '在住日期',
    bookingDate: '预订日期',
    exposureNumber2: '曝光人数',
    numberOfVisitors3: '浏览人数',
    onlineChannel3: '线上渠道',
    reasonForDeactivation: '停用原因',
    downTime: '停用时间',
    enterAMaximumOf20Characters: '最多输入20个字',
    checkInInformation: '入住信息',
    numberOfRooms6: '房间数',
    totalPrice: '总价',
    paymentInformation2: '付款信息',
    pleaseSelectAProduct: '请选择产品',
    viewOrderDetails: '查看订单详情',
    automaticallyJumpToOrderDetails: '自动跳转至订单详情',
    addHoming3: '添加同住',
    getVerificationCode: '获取验证码',
    pleaseSelectTheNumberOfRoomsFirst: '请先选择预订间数',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms: '预订间数不能大于可订数',
    pleaseEnterAmount: '请输入金额',
    makeAReservation: '办理预订',
    increaseRoomType: '增加房型',
    deleteRoomType: '删除房型',
    store: '门店',
    meituanDirectNew: '美团直连新',
    outOfService: '停用',
    smokeFreeOrNot: '是否无烟',
    roomOrientation: '房间朝向',
    windowCondition: '窗户情况',
    windowed: '有窗',
    windowless: '无窗',
    innerFenestra: '内窗',
    roomCharacteristics: '房间特征',
    airAndClean: '空净',
    airViscus: '空脏',
    dendrojing: '住净',
    astriction: '住脏',
    continuousStaySpecial: '连住特惠',
    orderEarlyAndReduceMore: '早订多减',
    discountValue: '折',
    select: '选择',
    becameInvalid: '已失效',
    dateOfOperation: '操作日期',
    promotionalAllocation: '促销配置',
    promotionManagement: '促销管理',
    operationContent2: '操作内容',
    turnOnAutomaticDeferral: '开启自动延价',
    productSetup: '产品设置',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan: '价格不得低于20元，不得高于99998000元',
    iKnow: '我知道了',
    dataSpecification: '数据说明',
    settings: '设置',
    restrictSales: '限售',
    pleaseEnterPrice: '请输入价格',
    modificationFailure: '修改失败',
    deletionFailure: '删除失败',
    product: '产品',
    pleaseSelectChannel: '渠道',
    standardProduct: '标准产品',
    bindingSuccessful: '绑定成功',
    lobby: '大厅',
    inventoryQuantity: '库存数量',
    uploadPictures: '上传图片',
    currentlyLimitedTo10Images: '当前限制10张图片',
    pictureSizeMustBeLargerThan: '图片尺寸需大于',
    warn3: '警告',
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck: '当前页面输入内容不符合规范，请检查',
    layer: '层',
    untie: '解绑',
    cipher5: '密码',
    pleaseEnterYourAccountNumber: '请输入账号',
    pleaseEnterPassword4: '请输入密码',
    obtainTheSmsVerificationCode: '获取短信验证码',
    disposition: '配置',
    passwordType: '密码类型',
    setANewPassword: '设置新密码',
    pleaseEnterYourNewPassword: '请输入新密码',
    confirmPassword: '确认密码',
    pleaseEnterYourPasswordAgain: '请再次输入密码',
    electronicPriceBoard: '电子房价牌',
    operationInstruction: '操作说明',
    cardholder: '持卡人',
    contact: '联系人',
    pleaseEnterTheCardholderName: '请输入持卡人姓名',
    cardholderNameIsRequired: '持卡人姓名必填',
    theCardholderNameMustBe2To5CharactersLong: '持卡人姓名必须为2到5个字符',
    remarksRequired: '备注必填',
    selectCardType: '选择卡类型',
    windowType2: '窗型',
    suspensionOfSale: '停售',
    enterMaterialName: '输入物品名称',
    modifyTarget: '修改目标',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth: '建议目标值根据去年同期数据变化趋势结合上月实际数据进行预估',
    dayUnit: '{day}天',
    checkInOperator: '入住操作员',
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    week: {
      mon: '星期一',
      tue: '星期二',
      wed: '星期三',
      thu: '星期四',
      fri: '星期五',
      sat: '星期六',
      sun: '星期日',
    },
    pleaseSelectStatus: '产品状态',
    pleaseSelectPre: '显示预售',
    pleaseSelectEb: 'EB产品',
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    th: 'ไทย',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  activitySign: {
    eventDate: '活动日期',
    alreadyRegistered: '已报名',
    signUpActivity: '可报名活动',
    noRegistrationIsAvailable: '暂无可报名活动',
    registeredActivity: '已报名活动',
    thereAreNoRegisteredActivities: '暂无已报名活动',
    thereAreNoCanceledEvents: '暂无已取消活动',
    signUp: '报名',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: '消费日期',
  },
  componentsCostprinta4template: {
    totalConsumption: '消费合计',
    dateOfConsumption: '消费日期',
    feeName: '费用名称',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: '该商品库存仅剩',
    thereIsNotEnoughStockOfThisCommodity: '该商品库存不足',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: '修改账套成功',
    bookModification: '修改账套',
    pleaseEnterABookName: '请输入账套名称',
    pleaseSelectTheConsumerCategory: '请选择消费类目',
    newAccountSuccessfully: '新增账套成功',
  },
  componentsRecorddetail: {
    memberInfo: '会员姓名/卡号',
  },
  componentsRushbalance: {
    successfulWriteOff: '冲账成功',
  },
  componentsShoppinggoods: {
    onlyAvailable: '仅显示有货',
    commodityCategory: '商品类别',
    pleaseEnterTheProductName: '请输入商品名称',
    noDataIsQueried: '未查询到数据',
    name3: '名称',
    purchaseQuantity: '购买数量',
    vendibility: '可售',
    allGoods: '全部商品',
  },
  componentsAddroomer: {
    addLabel: '新增标签',
    noCustomerProfile: '该入住人暂无客户档案',
    guestSaveFailedRetry: '入住人保存失败，请重试',
    changeOccupancy: '修改入住人',
    increaseOccupancy: '增加入住人',
    validityPeriod: '证件有效期',
    startDate: '起始日期',
    addGuest: '添加住客',
    atLeastOneGuest: '至少保留一个住客',
    guest: '住客',
    enterGuestName: '请输入{name}的姓名',
    enterValidPhone: '请输入住客{name}的正确手机号',
    selectDocumentType: '请选择{name}的证件类型',
    enterDocumentNumber: '请输入{name}的证件号码',
  },
  componentsAnnouncement: {
    noticeBoard: '公告栏',
  },
  componentsIdentifyMembers: {
    memberInformation: '会员信息',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation: '请填写客人手机号，快速识别身份信息',
    guestsCanUpgradeToAHigherLevelMembership: '客人可升级更高级别的会员',
    l: '升',
    unnamed: '未实名',
    inRealName: '已实名',
    points: '积分',
    memberRightsAndInterests: '会员权益',
    patron: '客人',
    unfold: '展开',
    unactivated: '未激活',
    membershipSalesCopy: '会员销售文案',
    bookingDiscount: '订房折扣',
    costPerformance: '购卡性价比',
    memberPoints: '会员积分',
    lateCheckOut: '延迟退房',
    copywritingType: '文案类型',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers: '客人在“轻住酒店预订”小程序实名认证后，可领取18元无门槛生日礼券或参与专享优惠活动',
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits: '客人在“轻住酒店预订”小程序首次登录即可激活会员身份并享受专属会员权益',
    lightStayMemberLevelNonMember: '轻住会员等级：非会员',
    lightStayMembershipLevel: '轻住会员等级',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: '员工·上周售卡排行榜',
    dragLeftAndRightToViewTheTable: '左右拖动查看表格',
    hotelLastWeeksCardSalesList: '酒店·上周售卡排行榜',
    cardSalesRanking: '售卡排行榜',
    employee2: '员工',
    numberOfCardsSold: '售卡数量',
    amountOfCommission: '提成金额',
  },
  detailcomponentsOnecarddialog: {
    waitingGuestToSwipeCard: '等待客人刷卡',
    paymentInProcess: '支付中',
    guestPaymentSuccess: '客人支付成功',
    guestPaymentFailedPleaseInitiatePaymentAgain: '客人支付失败，请重新发起收款',
  },
  customerPSearch: {
    singleStoreMembershipLevel: '会员等级',
    enterYourNamePhoneNumberAndCardNumber: '输入姓名、手机号、卡号查询',
  },
  customerPTable: {
    topUp: '充值',
    gift: '赠送',
    viewMembers2: '查看会员',
    modifyMembership2: '修改会员',
    storedValueDeduction: '储值扣减',
    integralChange2: '积分变更',
    integralQuery2: '积分查询',
    storedValueQuery2: '储值查询',
    rechargeAllAccumulatedRechargeAmounts: '充值：所有充值累计金额',
    giftAllAccumulatedGiftAmounts: '赠送：所有赠送累计金额',
    consumptionAllAccumulatedConsumptionAmounts: '消费：所有消费累计金额',
    refundAllAccumulatedRefundAmounts: '退款：所有退款累计金额',
    distributionSettings: '分销设置',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: '当前营业日为',
    startTheNightTrial: '开始执行夜审',
    theNightTrialIsInProgressAndCannotBeClosed: '夜审正在进行中不可以关闭',
    immediateFeedback: '立即反馈',
    nightAuditCompleted: '夜审完成',
    nightTrialInProgress: '夜审中',
    nightTrialNewsNotice2: '夜审消息通知',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport: '夜审失败,请您按照提示处理后再执行夜审。如遇问题可反馈给技术支持',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: '夜审消息通知',
    procedure: '步骤',
    mistake: '错误',
    carryOut: '执行',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve: '夜审失败遇到问题可以在早上8点后，尽快联系技术支持协助解决',
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully: '时发生错误，夜审停止，请仔细确认后',
  },
  componentsOpenPageLayout: {
    backToHomePage: '返回首页',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: '请选择班次',
    hello: '，你好!',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: '没有找到该选项',
  },
  printsettingHalfprint: {
    test: '测试',
    print: '打 印',
    trisection: '三等分',
    printInThirds: '三等分打印',
    printInHalf: '二等分打印',
  },
  printsettingPrint: {
    print: '打 印',
  },
  printsettingSmallprint: {
    feeName: '费用名称',
    totalConsumption: '消费合计',
  },
  hardwareIdcardbtn: {
    readIdentityCard: '读取身份证',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: '请将门卡放置于读卡器上',
    effectiveTime: '生效时间',
    failureTime: '失效时间',
    readCard: '读卡',
    failedToObtainTheLockInformationProcedure: '获取门锁信息失败',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting: '该卡不是宾客卡，请重新制卡',
    wheatDoorLockPlugInReadCard: '麦田门锁插件读卡',
    the: '的',
    wheatDoorLockPlugInCancellationCard: '麦田门锁插件注销卡',
    cardReadingFailure: '读卡失败',
  },
  componentsFeedback: {
    selectAttachment: '选择附件',
    viewFeedbackLog: '查看反馈记录',
    commitFailure: '提交失败',
    problemFeedback3: '问题反馈',
    pleaseEnterTheContactName4: '请输入联系人姓名',
    pleaseEnterAContactNumber3: '请输入联系电话',
    uploadAttachment2: '上传附件',
    pleaseEnterADetailedDescriptionOfTheProblem2: '请输入问题详细描述',
    theUploadedFilesCannotExceed: '上传文件不能超过',
    aMaximumOfFiveFilesCanBeUploaded2: '最多支持上传5个文件',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb: '最多支持上传5个文件，单个文件大小不超过20M,支持格式',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact: '请说明问题并输入QQ号方便联系',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: '轻赢宝小程序',
    scanCodeUsingASmallProgram: '扫码使用小程序',
    realTimeControlOfRoomStatus: '房态实时管控',
    onlineOneClickPriceAdjustment: '在线一键调价',
    memberDevelopmentTools: '会员发展工具',
    moreFeaturesComingOnline: '更多功能上线中',
    hotelOperationCarefulAssistant: '酒店经营·贴心管家',
  },
  componentsGethelp: {
    getHelp: '获取帮助',
  },
  componentsGoappshop: {
    applicationMarket: '应用市场',
  },
  componentsJointrain: {
    attendTraining: '参加培训',
  },
  componentsLeftcontent: {
    hotelOperationsManager: '酒店运营经理',
    cityOperationsManager: '城市运营经理',
    customerServiceHotline: '客服热线',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: '培训课程火爆开讲',
    getDetailedTrainingNoticesAndMaterials: '获取详细培训通知和材料',
    followThelightStaySystemServicePublicAccount: '关注「轻住系统服务」公众号',
    basicCourseIntroductorySeries: '基础课：入门串讲',
    mondayAndWednesday1430Start: '每周一、周三14:30开始',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures: '进阶课：复杂场景+常见问题+近期新功能',
    friday1430Start: '每周五14:30开始',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: '财务对账老系统',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill: '轻住佣金补贴已经移至会员激励，请到会员激励下进行账单的确认',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: '财务对账老系统',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill: '轻住佣金补贴已经移至会员激励，请到会员激励下进行账单的确认',
  },
  merchantPSearchqu: {
    enterHotelName: '输入酒店名称',
  },
  payIndex: {
    toBePaid: '待支付',
    pleaseScanQrCodeToCompletePayment: '请扫二维码完成支付',
    canBeClosedAfter: '后可以关闭',
    paymentSuccess: '支付成功',
    automaticShutdownInSeconds: '秒后自动关闭',
    automaticPageRefresh: '自动刷新页面',
    duringThePayment: '支付中',
    paymentAnomaly: '支付异常',
    ifThePaymentIsAbnormalContactTechnicalSupport: '支付异常，请联系技术支持处理',
    paymentFailure: '支付失败',
    payOff: '支付关闭',
    waitForTheUserToScanTheCode: '等待用户扫码',
    currentStatusOfLehuiPayment: '当前乐惠支付的状态',
    theGunScannedTheCodeSuccessfully: '扫枪扫码成功',
    theUserHasPaidSuccessfully: '用户已支付成功',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage: '用户未支付，可在财务页面中重新入帐',
  },
  sellCalctable: {
    maximumPromotion: '最大幅度促销',
    nonMemberSellingPricebrestimatedSettlementPrice: '非会员卖价<br>/预估结算价',
    ordinaryMemberSellingPricebrestimatedSettlementPrice: '普通会员卖价<br>/预估结算价',
    goldMemberSellingPricebrestimatedSettlementPrice: '黄金会员卖价<br>/预估结算价',
    platinumMemberSellingPricebrestimatedSettlementPrice: '白金会员卖价<br>/预估结算价',
    diamondMemberSellingPricebrestimatedSettlementPrice: '钻石会员卖价<br>/预估结算价',
  },
  sellPTableTdNew: {
    noData: '无数据',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: '渠道售价计算器',
    selectRoomType: '选择房型',
    pleaseSelectRoomType: '请选择房型',
    selectProduct: '选择产品',
    pleaseSelectAProductName: '请选择产品名称',
    selectSaleDate: '选择售卖日期',
    distributionChannel: '分销渠道',
    pleaseSelectTheDistributionChannelNamenotRequired: '请选择分销渠道名称(非必选)',
    canNotExceed: '最大不能超过',
    pleaseSelectASaleDate: '请选择售卖日期',
    figure: '数字',
  },
  filtersIndex: {
    all: '全',
    sinceThe: '自',
    free: '免',
    group: '团',
    association: '协',
    theClock: '钟',
    long: '长',
    inapplicability: '不适用',
    haveProcessed: '已办理',
    notProcessed: '未办理',
    averageSalesRate: '销售平均房价',
    consumptionNight: '消费间夜',
    averageHousePriceOfConsumption: '消费平均房价',
    onlinePermeability: '线上渗透率',
    cancelNight: '取消间夜',
    rejectionNight: '拒绝间夜',
    channelProvision: '渠道提供',
    theHotelProvides: '酒店提供',
  },
  jsonBookertypeoptions: {
    singleStoreMember: '单店会员',
    lightLivingMember: '轻住会员',
  },
  layoutIndex: {
    collapseMenuBar: '折叠菜单栏',
  },
  componentsNavbar: {
    shiftManagement: '换班管理',
    helpCenter: '帮助中心',
    logout: '退出登录',
    reportTitle: '交班汇总统计报表',
    headers: {
      income: '收入',
      expend: '支出',
      total: '合计金额',
    },
  },
  componentsSidemessage: {
    orderNotice: '订单通知',
    orderMessageReceivedNotification: '订单消息收到通知了',
    youDoNotHaveOrderManagementPermission: '你还未开通订单管理权限',
    ignore: '忽略消息',
    order: '订单消息',
    noData: '暂无新消息',
    system: '系统消息',
    settlement: '结算消息',
    dynamic: '动态消息',
    serviceManagement: '服务工单管理',
    roomService: '客房服务',
    itemBorrow: '物品借用',
    extendStay: '续住服务',
    notice: '通知',
    aiNoticeMsg: '条新AI通知',
    manualEntry: '手工录单',
    confirmOrder: '确认接单',
    viewOrder: '查看订单',
    youDoNotHaveAccessToEbkOrderManagement: '你还未开通EBK订单管理权限',
    youReceive: '您收到',
    aNewMessage: '条新消息',
    have: '有',
    orderMessage: '条订单消息',
    aNewSystemMessage: '条新系统消息',
    aNewSettlementMessage: '条新结算消息',
  },
  componentsSoundnotice: {
    playOut: '播放完毕',
    theVoicePromptsThatAMessageIsReceived: '语音提示收到消息',
  },
  nightcheckNightStart: {
    nightTrialSequence: '夜审顺序',
    nightAuditInstructions2: '夜审说明',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible: '酒店尚未夜审，为了避免影响酒店营收数据，请尽快开始夜审',
    nightAuditInstructions2: '夜审说明',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue: '夜审前请务必提前核对酒店账务数据是否正确，以免影响酒店营收',
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed: '请确认当前营业日需要办理入住及离店的订单已经处理完毕',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived: '您已设置夜审时自动取消预抵未到的门店订单',
    preArrivalAutoCheckIn: '您已设置夜审时自动为预抵订单办理入住',
    preArrivalAutoNoshow: '您已设置夜审时自动将预抵订单标记为noshow',
    preDepartureAutoCheckOut: '您已设置夜审时自动为预离订单办理退房',
    preDepartureAutoExtendStay: '您已设置夜审时自动为预离订单办理续住',
    theEarliestTimeForManualNightAuditIs: '手工夜审最早时间为',
    nightAuditProcess: '夜审流程',
    hotelBusinessDaysAreNowGreaterThanNaturalDays: '当前酒店营业日已经大于自然日',
    nightAuditReminder: '夜审提醒',
    hotelBusinessDay: '酒店营业日',
    currentNaturalDay: '当前自然日',
    viewLogs: '查看日志',
    theNightTrialWasCompleted: '已夜审完成',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh: '夜审开始时间不能早于21点，无法执行夜审操作哦',
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure: '有正在进行的夜审，请勿重复操作',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation: '当前酒店营业日已经大于自然日，或者夜审开始时间不能早于21点，无法执行夜审操作哦',
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible: '尚未完成夜审，请尽快执行夜审',
  },
  globalMethodsmixin: {
    hotelChangeAlert: '酒店变更提醒',
    theHotelIsCurrentlyFrom: '当前酒店已从',
    switchTo: '切换至',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: '请输入正确邮箱',
    pleaseEnterTheCorrectIdNumber: '请输入正确的身份证号',
    pleaseEnterTheCorrectIdNumber2: '请输入正确的证件号',
  },
  sidebarLogo: {
    helpCenter2: '帮助中心',
  },
  modulesMember: {
    drench: '轻住',
  },
  modulesUser: {
    client: '客户',
    membershipManagement: '会员管理',
    singleStoreMemberManagement: '单店会员管理',
    storeValueManagement: '单店储值管理',
    singleStorePointsSetting: '单店积分设置',
    storeValueReport: '单店储值报表',
    failedToObtainOperationInformationProcedure: '获取运营信息失败',
    billReconciliation: '账单核对',
    paymentRecord: '打款记录',
    expenseStatement: '费用流水',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: '初始化应收账财务菜单',
  },
  utilsDoorcard: {
    initializationFailure: '初始化失败',
    noKeyCardReaderPlugInFound: '未找到门卡读卡器插件',
    cardReadingError: '读卡错误',
    plugIn: '插件',
    cardReadingResult: '读卡结果',
    cardReadingFailure: '读卡失败',
    businessCardWriteData: '制卡写入数据',
    businessCardPrintingResult: '制卡结果',
    businessCardFailure: '制卡失败',
    logoutStatusCode: '注销状态码',
    logoutFailure: '注销失败',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: '未找到门卡读卡器插件',
    cancelTheCardSuccessfully: '注销卡成功',
    readTheCardSuccessfully: '读卡成功',
  },
  utilsEnum: {
    roomInNeedOfRepair: '房间需维修',
    guestRequest: '宾客要求',
    hotelRowRoomDemand: '酒店排房需求',
    inProcess: '处理中',
    alreadyEnded: '已结束',
    storeOrderPreArrivalHasNotBeenChecked: '门店订单预抵未到检查',
    leaveTheRoomForInspectionToday: '今日预离房间检查',
    generateRoomChargesInTheRoom: '在住房间生成房费',
    cleanRoomToDirtyRoom: '住净客房转住脏',
    switchingDay: '转换营业日',
    preArrivalNoShowRoomListPending: '预抵达未到，房单待入住',
    preSeparationIsNotSeparated: '预离未离',
    allRoomChargesAreGeneratedAndRecordedInTheAccount: '全部在住生成房费，并入账',
    roomChange: '房态变更',
    generateCureReport: '生成固化报表',
    shopHourRoom: '门店钟点房',
    onlineHourRoom: '线上钟点房',
    presaleFullDayRoomProduct: '预售全日房产品',
    presaleClockRoomProduct: '预售钟点房产品',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer: '读卡器未连接到电脑上',
    checkValueError: '校验值错误',
    passwordError: '密码错误',
    readCard: '读卡',
    cardReaderCommunicationIsNormal: '读卡器通讯正常',
    businessCardPrintingSoftwareIsNotOpened: '制卡软件未打开',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen: '读卡器未连接或是软件未打开',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome: '对不起，你的浏览器不支持读卡器功能，请使用chrome浏览器。',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage: '身份证读卡器连接. 如需扫描身份证,请将身份证扫描仪连接到电脑上.并刷新页面',
    toScanDocumentsInstallTheIdCardReaderControl: '如需扫描证件,请安装身份证读卡器控件',
    abnormalReadingIdCardPleaseRefreshAndTryAgain: '读取身份证异常，请刷新重试',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition: '未读取到证件信息，请检查是否放置身份证或放置位置是否正确',
  },
  utilsIndex: {
    justNow: '刚刚',
    aMinuteAgo: '分钟前',
    hoursAgo: '小时前',
    month: '月',
    when: '时',
    connectionSuccessful: '连接成功',
    theGlobalConnectionIsClosed: '全局连接已关闭',
    yourBrowserDoesNotSupportIt: '您的浏览器不支持',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: '请联系管理员开通',
    noCorrespondingLedgerFound: '未找到对应的账套',
    accountReceivable: '应收账',
    administrativeAuthority: '管理权限',
  },
  utilsRequest: {
    doNotRepeatRequests: '请勿重复请求',
    noFlightFoundPleaseSelectAgain: '未查询到班次，请重新选择',
    systemErrorPleaseContactTechnicalSupport: '系统错误，请联系技术支持',
    networkException: '网络异常',
    requestTimedOutPleaseRefreshThePage: '请求超时,请刷新页面',
    requestTimeout: '请求超时',
    requestFailed: '请求失败',
  },
  utilsSharestorage: {
    putInTheInitialMarker: '放进去初次标记',
  },
  appdetailIndex: {
    specification: '规格',
    contactBusinessManager: '联系业务经理',
    buyNow: '立即购买',
    applicationIntroduction: '应用介绍',
    workingHours: '工作时间',
    pleaseSelectProductSpecifications: '请选择产品规格',
  },
  applistIndex: {
    fullApplication: '全部应用',
    haveOpened: '已开通',
    haveNotOpened: '未开通',
    inService: '开通中',
    contactBusinessManager: '联系业务经理',
    workingHours: '工作时间',
    openImmediately: '立即开通',
    immediateRenewal: '立即续费',
    expiredDays: '已过期{days}天',
    daysLeftToExpire: '还有{days}天到期',
  },
  createorderIndex: {
    goToPay: '去支付',
    remaining: '剩余',
    orderProduct2: '订购产品',
    purchaser2: '购买人',
    specification: '规格',
    successfulCustomsOrder2: '关单成功',
  },
  createorderPay: {
    amountPaid: '支付金额',
    paymentCountdown: '付款倒计时',
    qrCodeHasExpired: '二维码已过期',
    updateNow: '立即更新',
    payment3: '支付',
    scanQRCode: '请使用微信/支付宝扫描二维码支付',
  },
  orderlistIndex: {
    orderDate: '订购日期',
    product: '商品',
    toBePaid: '待支付',
    paymentSuccess: '支付成功',
    paymentFailure: '支付失败',
    refunded: '已退款',
    partialRefund: '部分退款',
    goToPay: '去支付',
    orderTime: '订购时间',
    orderProduct2: '订购产品',
    orderSpecification: '订购规格',
    refundAmount: '退款金额',
    orderEffectiveTime: '订单生效时间',
    purchaser2: '购买人',
    orderOperation: '订单操作',
    successfulCustomsOrder2: '关单成功',
  },
  commentChannelComment: {
    modifyReply: '修改回复',
    setAsTemplate: '设为模板',
    selectRecommendedTemplate: '选择推荐模板',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words: '输入回复内容，字数在10以上500字以内',
    theMaximumResponseTextIs500Characters: '回复文字最大允许500字',
    areYouSureYouWantToDeleteReplies: '确认要删除回复吗',
  },
  commentCommentTempManage: {
    newTemplate: '新建模板',
    goodReputation: '好评',
    delete2: '删 除',
    templateName: '模板名称',
    replyClassification: '回复分类',
    replyContent2: '回复内容',
    pleaseEnterAtLeast10Characters: '请输入至少10个字符',
    keyword: '关键字',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas: '请输入要匹配评论的关键字以逗号分隔',
    pleaseEnterATemplateName: '请输入模板名称',
    theValueCanContainNoMoreThan15Characters: '长度在15个字符以内',
    pleaseSelectAReplyCategory: '请选择回复分类',
    pleaseEnterTheReplyContent: '请输入回复内容',
    '10To500CharactersInLength': '长度在 10 到 500 个字符',
    theValueContainsAMaximumOf50Characters: '长度在50个字符以内',
    definitiveDeletion: '确定删除',
    deletingATemplateSucceeded: '删除模板成功',
    creatingATemplateSucceeded: '新建模板成功',
  },
  commentComment: {
    reasonForNotPassing: '未通过原因',
    setAsTemplate: '设为模板',
    replyAgain: '再次回复',
    reappeal: '再次申诉',
    inComplaint: '申诉中',
    typeOfAppeal: '申诉类型',
    statementOfAppeal: '申诉说明',
    selectRecommendedTemplate: '选择推荐模板',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words: '输入回复内容，字数在10以上300字以内',
    theMaximumResponseTextIs500Characters: '回复文字最大允许500字',
    areYouSureYouWantToDeleteReplies: '确认要删除回复吗',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted: '您的申诉通过审核后，系统将自动删除该评论',
    youCanUploadUpToFivePictures: '最多可上传五张图片',
    launchAComplaint: '发起申诉',
    typeOfAppeal: '申诉类型',
    statementOfAppeal: '申诉说明',
    uploadCredentials: '上传凭证',
    pleaseFillInTheContact: '请填写联系人',
    pleaseEnterTheCorrectName: '请输入正确的姓名',
    pleaseSelectTheAppealType: '请选择申诉类型',
    theCauseOfTheComplaintMustBeAtLeast10Words: '申诉原因至少为10个文字',
    theMaximumCauseOfAppealIs300Words: '申诉原因最大允许300字',
    underAppeal: '提交申诉中',
    addAppealSuccess: '添加申诉成功',
  },
  commentIndex: {
    totalEvaluation: '全部评价',
    waitForReply: '待回复',
    appealed: '已申诉',
    allRoomTypes: '全部房型',
    noReplyYet: '未回复',
    toBeReviewed: '待审核',
    notPass: '未通过',
    alreadyPassed: '已通过',
  },
  commentMain: {
    deleteReplySucceeded: '删除回复成功',
    modifiedReplySucceeded: '修改回复成功',
  },
  commentPreview: {
    viewPicture: '查看图片',
  },
  commentReplyList: {
    replyDate: '日期',
    commentChannel: '评论渠道',
    review2: '评论',
    replyContent2: '回复内容',
    commentReply: '评论回复',
    modifyReply: '修改回复',
    deleteReply: '删除回复',
    meituanReview: '美团评论',
    ctripReview: '携程评论',
    whereToComment: '去哪儿评论',
    sameTripReview: '同程旅行评论',
    dianpingReviews: '大众点评评论',
    flyingPigReview: '飞猪评论',
    parallelComment: '同程评论',
  },
  commentScore: {
    renewal: '更新',
    guestImpression: '客人印象',
    overallGuestRating: '客人综合评分',
  },
  complainDetail: {
    issueDetails: '问题详情',
    processingDetails: '处理详情',
    serviceProblem: '服务问题',
    healthProblem: '卫生问题',
    processor: '处理人',
    processingTime: '处理时间',
    communicationSituation: '沟通情况',
  },
  complainHandle: {
    successfulProcessing: '处理成功',
    problemHandling: '问题处理',
    roomInformation: '房间信息',
    guestInformation: '客人信息',
    communicationSituation: '沟通情况',
    enterAMaximumOf300Characters: '最多输入300个字',
    pleaseEnterTheProcessingResult: '请输入处理结果',
  },
  complainIndex: {
    submissionDate: '日期',
    processed: '已处理',
    submissionTime: '提交时间',
    feedbackProblem: '反馈问题',
    untreated: '未处理',
    viewTheResults: '查看结果',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words: '输入回复内容，字数在10以上300字以内',
    theMaximumResponseTextIs300Characters: '回复文字最大允许300字',
    modifiedReplySucceeded: '修改回复成功',
  },
  ebkGrade: {
    guestImpression: '客人印象',
  },
  ebkIndex: {
    totalEvaluation: '全部评价',
    waitForReply: '待回复',
  },
  customerCompany: {
    new: '新增',
    whetherToAllowHangingAccounts2: '是否允许挂账',
    loginListHidesRates: '登录单隐藏房价',
    confirmAction: '确定{action}公司客户“{name}”吗？',
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: '是否允许挂账',
    theRegistrationFormHidesTheRoomRate: '登记单隐藏房价',
    addACorporateClient: '添加公司客户',
    changeCorporateAccount: '修改公司客户',
    companyInformation: '公司信息',
    forShort: '简称',
    pleaseEnterCompanyAbbreviation: '请输入公司简称',
    code: '代码',
    pleaseEnterTheCode: '请输入代码',
    legalPerson: '法人',
    pleaseEnterTheLegalPersonName: '请输入法人姓名',
    fax: '传真',
    pleaseEnterTheFaxNumber: '请输入传真号码',
    city: '城市',
    postcode: '邮编',
    pleaseEnterPostalCode: '请输入邮编',
    pleaseEnterDiscountRatio: '请输入优惠比例',
    enterAMaximumOf100Characters: '最多输入100个字',
    contactInformation: '联系人信息',
    pleaseEnterTheContactNumber: '请输入联系人电话',
    pleaseEnterEmail: '请输入邮箱',
    setUp: '挂账设置',
    pleaseEnterYourAccountName: '请输入账户名称',
    accountType: '账户类型',
    maximumAmount: '最大额度',
    pleaseEnterDiscount: '请输入折扣',
    pleaseEnterAnIntegerBetween0And100: '请输入0 - 100整数',
    pleaseEnterTheCorrect11DigitMobileNumber: '请输入正确的11位手机号码',
    pleaseEnterName: '请输入名称',
    pleaseEnterTheContactName3: '请输入联系人名字',
    creditAccount: '信用账户',
    theCreditLimitCannotBeExceeded: '信用额度不能超过',
    enterRange: '请输范围1～365数字',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: '协议单位,待开发',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: '报警事件',
    shootingTime: '拍摄时间',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto: '以下住客暂未加入白名单，选择与照片匹配的住客',
    stranger: '陌生人',
    whiteAdded: '已加白',
    ignored: '已忽略',
    whitelist: '加入白名单',
    environmentalPhotograph: '环境照片',
    facePhoto: '人脸照片',
    pleaseSelectUser: '请选择用户',
  },
  heavenlyEyeWhiteList: {
    personnelType: '人员类型',
    addStaff: '新增',
    pleaseEnterTheRoomNumber: '请输入房间号',
    employee2: '员工',
    dweller: '住客',
    avatar: '头像',
    photograph: '照片',
    pleaseSelectEnterName: '请选输入姓名',
    pleaseCompleteTheFormBeforeSubmitting: '请填写完成再进行提交',
    inputLabelDuplication: '输入标签重复',
    pleaseEnterTheLabelContent: '请输入标签内容',
    doNotEnterLabelsInMoreThan10Words: '输入标签不要超过10个字',
    whetherToDeleteTheWhitelist: '是否确认删除该员工白名单',
    uploadImageFormat: '上传图片只能是JPG或者PNG格式!',
  },
  hicList: {
    dateOfPresentation: '提报日期',
    dataExport: '数据导出',
    bookingChannel: '预订渠道',
    bodyTemperature: '体温',
    healthStatus: '健康状况',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure: '健康信息收集报表导出成功',
    failedToExportTheHealthInformationCollectionReportProcedure: '健康信息收集报表导出失败',
  },
  hicQrCode: {
    downloadPicture: '下载图片',
  },
  marketActivity: {
    couponType: '优惠券类型',
    couponName: '优惠券名称',
    beOffline: '已下线',
    terminated: '已终止',
    full: '满',
    reduction: '减',
    fromTheDateOfReceipt: '从获得券之日起',
    withinDays: '天内有效',
    thisParameterIsValidWithinAFixedPeriod: '固定时间段内有效',
    restrictedRoomNight: '限制间夜',
    unlimited: '不限',
    oneNight: '一间夜',
    discountType: '优惠类型',
    validForTimePeriod: '时间段内有效',
    instructionsForUse: '使用须知',
    selectionOfParticipatingGoods: '选择参与商品',
    allGoods: '全部商品',
    platform: '平台',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully: '优惠券名称会展示给用户，请认真填写',
    denomination: '面额',
    fillInTheCouponAmountdiscountAmount: '填写优惠券金额（优惠金额）',
    pleaseSelectTheYearMonthAndDay2: '请选择年月日',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully: '使用须知会展示给用户，请认真填写',
    viewActivity: '查看活动',
    maxOut: '满减',
    availableForBooking1Room1NightOnly: '仅限预订1间1晚可用',
    events: '活动',
    orderNeedsToBeFull: '订单需满',
    issued: '已发放',
    haveBeenUsed: '已使用',
    expired2: '已过期',
    editCoupon: '编辑优惠券',
    addCoupon: '添加优惠券',
    pleaseSelectTheOfferType: '请选择优惠类型',
    pleaseEnterExpiryDate2: '请输入有效期',
    pleaseSelectExpirationDate: '请选择有效期',
    pleaseEnterTheCouponName2: '请输入优惠券名称',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter: '金额只可输入正整数，请重新输入',
    successfulActivation: '激活成功',
    deactivated: '已取消激活',
    pleaseConfirmWhetherYouWantToTerminate: '请确认是否要终止',
    terminationSuccess: '终止成功',
    cancelledTermination: '已取消终止',
    pleaseEnterTheValidityPeriod: '请输入有效期对应内容',
    createACoupon: '创建优惠券',
    unedited: '已取消编辑',
    discountTemplate: '立减{ money }元',
    fullReductionTemplate: '满减{ minAmount }元',
    validityDaysTemplate: '从获得券之日起 { day } 天内有效',
    activationConfirmation: '当券被激活后便不能再修改，请确认是否要激活？',
    importValidationWarning: '部分导入酒店校验存在异常, 是否继续?',
  },
  marketActivitydata: {
    classificationSpecification: '分类说明',
    data: '数据',
    marketingRevenue: '营销收入',
    marketingExpenses: '营销费用',
    numberOfContacts: '触达人数',
    numberOfVisitors: '访问人数',
    numberOfTransactions: '成交人数',
    revenueDescription: '30天内触达用户产生收入（元）',
    costDescription: '30天内营销所产生的成本（元）',
    reachCountDescription: '30天内营销活动触达用户数（个）',
    visitCountDescription: '30天内触达用户访问本门店用户数（个）',
    orderCountDescription: '30天内触达后下单用户数（个）',
  },
  marketCrowddata: {
    subdivide: '细分',
    classificationSpecification: '分类说明',
    numberOfPeople: '人数',
    membersWhoHaveStayedAtThisStore: '入住过本店的会员',
    allMembers: '全部会员',
    usersWhoHaveStayedInThisStoreInThePast1Year: '近1年入住过本门店的用户',
    lowFrequencyMember: '低频会员',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months: '近1年入住过，但近3个月没有入住的用户',
    loyalUser: '忠实用户',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year: '近1年入住过3次以上的用户',
    lostUsers: '流失用户',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year: '近2年入住过，近1年没用入住的用户',
    interestedMember: '兴趣会员',
    interestedUserGroupsOfThisStore: '本店兴趣用户群体',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder: '近7天该用户进入过本酒店小程序首页，未下单',
    localInterestUserGroups: '同城兴趣用户群体',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated: '近7天进入搜索过本酒店所在城市、酒店',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder: '或进入过本城市其他酒店，但未下单',
    intraCityUserGroup: '同城用户群体',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore: '近30天入住过本城市非本门店用户',
    createActivity: '创建活动',
    lowFrequencyUser: '低频用户',
    marketingSuggestion: '建议：及时创建营销活动，留住用户，增加上单！',
  },
  marketDatakb: {
    crowdDataBulletinBoard: '人群数据看板',
    activityDataKanban: '活动数据看板',
  },
  marketDistribution: {
    releaseTime: '发放时间',
    events: '活动',
    releaseMode: '发放方式',
    smsSending: '短信发送',
    publicAccount: '公众号',
    stopSmsPlatformPush: '轻住短信平台推送',
    stopThePublicAccountPush: '轻住公众号推送',
    iHaveReadAndAgree: '我已阅读并同意',
    precisionMarketingRules: '精准营销规则',
    pleaseReadAndAgree: '请阅读并同意',
    warmReminder: '温馨提示',
    issue: '发放',
    couponName: '优惠券名称',
    pleaseEnterTheCouponName2: '请输入优惠券名称',
    sendingCrowd: '发送人群',
    pleaseSelectTheSender: '请选择发送人群',
    quantityIssued: '发放数量',
    pleaseFillInTheNumberOfIssuedCards: '请填写发放张数',
    sendingMode: '发送方式',
    notificationTemplate: '通知模板',
    pleaseSelectANotificationTemplate: '请选择通知模板',
    projectedCost: '预计费用',
    allUsers: '全部用户',
    interestedUsersOfThisStore: '本店兴趣用户',
    lostUsers: '流失用户',
    loyalUser: '忠实用户',
    lowFrequencyUser: '低频用户',
    interestedUsersInTheSameCity: '同城兴趣用户',
    localUser: '同城用户',
    unactivated: '未激活',
    terminated: '已终止',
    voucherInformation: '发放券信息',
    issuer: '发放人',
    pleaseEnterTheReleaseQuantity: '请输入发放数量',
    couponIssuedSuccessfully: '发放优惠券成功',
    pleaseEnterCoupon: '请输入优惠券',
    sendBatch: '发送批次',
    pleaseEnterTheCorrectCoupon: '请输入正确的优惠券',
    perPersonUnit: '张/人',
    rule1: '1、营销活动的创建不宜过于频繁。轻住在用户端有防疲劳机制，在一定时间内用户只能收到有限数量的营销推送/短信。',
    rule2: '2、为防止酒店过度使用营销推送/短信，对用户产生不必要的骚扰，降低酒店品牌形象，该功能限制不同推送渠道用户7天仅可收到1次推送。',
    rule3: '3、营销推送/短信不保证全部发送成功，以实际触达效果为准。',
    rule4: '4、未发送成功的营销推送/短信，营销费用将退回，发送记录需列明成功或失败。',
  },
  marketRules: {
    rulesRulesRules: '规则规则规则',
  },
  memberActivityManage: {
    longTerm: '长期',
    customInterval: '自定义区间',
    activeTime: '活动时间',
    addActivity: '新增',
    editingActivity: '编辑活动',
    editGear: '编辑档位',
    addGear: '添加档位',
    unlimited: '不限',
    rechargeAmount2: '充值金额',
    enabledState: '启用状态',
    activeState: '活动状态',
    pleaseEditTheAddedGears: '请编辑已添加的档位',
  },
  memberIntegralSetting: {
    integralRatioSetting: '积分比例设置',
    points: '积分',
    automaticCumulativePointSetting: '自动累计积分设置',
    storedValueConsumption: '储值消费',
    nonCumulativeIntegral: '不累计积分',
    pleaseFillInThePointsRatioSetting: '请填写积分比例设置',
    pleaseSelectTheAutomaticAccumulationPointSetting: '请选择自动累计积分设置',
    roomAndStoredConsumption: '房费消费 + 储值消费',
    integralRatioLimit: '积分比例只能限定在0.01~1000之间',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate: '请按照模版中的要求整理会员信息',
    downloadTemplate: '下载模版',
    freeCommissionPolicyTips: '免佣政策提示',
    downloadFailureData: '下载失败数据',
    normal: '正常',
    registrationTime: '注册时间',
    entryTime: '录入时间',
    augment: '增加',
    decrease: '减少',
    singleStoreStoredValueBillPrinting: '单店储值账单打印',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores: '会员储值金额仅该门店可用，其他门店不可使用',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable: '当前会员有未使用的余额或者积分，请确认是否要禁用',
    lightLivingMember: '轻住会员',
    startOfEntryDate: '录入日期始',
    dateOfEntry: '录入日期止',
    membershipIntroduction: '会员导入',
    memberExport: '会员导出',
    newMember: '新增会员',
    viewGrade: '查看等级',
    viewMembers2: '查看会员',
    storedValueQuery2: '储值查询',
    transactionType: '交易类型',
    registered: '已注册',
    unregistered: '未注册',
    theAmountOfThisStoredValue: '本次储值金额',
    storedValueActivity: '储值活动',
    eventGiftAmount: '活动赠送金额',
    currentStoredValueBalance: '当前储值余额',
    storageTime: '储值时间',
    currentBalance: '当前余额',
    topUpTheTotalAmount: '充值总金额',
    totalGiftAmount: '赠送总金额',
    totalPayment: '支付总金额',
    totalRefundAmount: '退款总金额',
    singleStoreMembershipLevel: '会员等级',
    storePoints: '单店积分',
    storedValueAccumulation: '储值累计',
    incorrectEmailFormat: '邮箱格式不对',
    membershipLevel: '会员等级',
    occupation: '职业',
    pleaseEnterOccupation: '请输入职业',
    salespersonName: '销售员名称',
    salespersonId: '销售员 ID',
    pleaseEnterSalespersonId: '请输入销售员 ID',
    pleaseEnterTheSalespersonsName: '请输入销售员姓名',
    pleaseSelectTheYearMonthAndDay2: '请选择年月日',
    detailedAddress: '详细地址',
    lv: '等级',
    gradeName: '等级名称',
    variableIntegral: '变动积分',
    pointBalance: '积分余额',
    transactionAmount: '交易金额',
    changeType: '变更类型',
    changeOfAmount: '变更数额',
    pleaseEnterAnInteger: '请输入整数',
    topUpActivity: '充值活动',
    pleaseSelectAnActivity: '请选择活动',
    activeGear: '活动档位',
    rechargeAmount2: '充值金额',
    pleaseEnterTheRechargeAmount: '请输入充值金额',
    amountReceivable: '应收金额',
    printDocuments: '打印单据',
    deductionAmount: '扣减金额',
    pleaseEnterTheAmountOfDeduction: '请输入扣减金额',
    increaseTheIntegral: '增加积分',
    reduceIntegral: '减少积分',
    filling: '充',
    send: '送',
    pleaseEnterTheCorrectIdNumber: '请输入正确的身份证号',
    pleaseEnterTheCorrectIdNumber2: '请输入正确的证件号',
    pleaseFillInTheIdNumber: '请填写证件号',
    operationFailure: '操作失败',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions: '你没有访问权限,请联系轻住运营添加权限',
    currentLimitSelect1FilePleaseRemoveAndAdd: '当前限制选择 1 个文件,请移除再添加',
    memberDataIsExportedSuccessfullyProcedure: '会员数据导出成功',
    memberDataFailedToBeExportedProcedure: '会员数据导出失败',
    noDataAvailableAtThisTime: '目前暂无数据',
    memberImportTemplateDownloadedSuccessfully: '会员导入模版下载成功',
    failedToDownloadTheMemberImportTemplate: '会员导入模版下载失败',
    modifyMembership2: '修改会员',
    addAMemberSuccessfully: '新增会员成功',
    renewMemberSuccessfully: '更新会员成功',
    integralChange2: '积分变更',
    memberRecharge: '会员充值',
    deductionOfStoredValue: '储值减扣',
    scoreChangeSuccess: '积分变更成功',
    memberRechargeSuccessfully: '会员充值成功',
    theDeductionOfStoredValueIsSuccessful: '储值减扣成功',
    integralQuery2: '积分查询',
    pleaseEnterSalesman: '请输入销售员',
    definitiveRemoval: '确定移除',
    derivedInformation: '导出信息',
    memberDataExportInformation: '会员数据导出信息.xlsx',
    memberImportTemplate: '会员导入模版.xlsx',
    totalMembers: '共有{memberTotal}个会员',
    xlsFormatOnly: '仅支持XLS格式文件',
    commissionRefundNotice: '自21年2月1日起，首次使用“会员导入”功能导入的会员，在轻住小程序预订本酒店并入住后产生的佣金全额返还！',
    enabled: '已开启',
    disabled: '未开启',
    idTypeAndNumber: '证件类型/证件号',
    distributionSettings: '分销设置',
    setAsAPromotionalUser: '设为推广用户',
  },
  memberMemberReport: {
    ordinaryMember: '普通会员',
    goldMember: '黄金会员',
    platinumMember: '白金会员',
    diamondMember: '钻石会员',
    enterYourNamePhoneNumberAndIdNumber: '输入姓名、手机号、证件号',
    membership: '会员身份',
    activateStore: '激活门店',
    ourStore: '本门店',
    otherStores: '其他门店',
    sourceOfDevelopment: '发展来源',
    activationDate: '激活日期',
    dateOfPurchase: '购买日期',
    purchaseTime: '购买时间',
    memberNickname: '会员昵称',
    memberName: '会员姓名',
    membershipIdNumber: '会员证件号',
    activationTime: '激活时间',
    currentLevelDevelopmentSource: '当前等级发展来源',
    currentLevelPurchaseTime: '当前等级购买时间',
  },
  memberSaveReport: {
    downloadReport: '下载报表',
    totalAmountOfStoredValue: '储值金额合计',
    totalGiftAmount: '赠送金额合计',
    totalConsumptionAmount: '消费金额合计',
    totalAmountOfRefund: '消费退款金额合计',
    user: '用户',
    transactionType: '交易类型',
    storedValue: '储值',
    consumptionRefund: '消费退款',
    membershipLevel: '会员等级',
    storedValueAmount: '储值金额',
    amountOfRefund: '消费退款金额',
    memberStoredValueReport: '会员储值报表.xlsx',
    theMemberStoredValueReportIsSuccessfullyExported: '会员储值报表导出成功',
    failedToExportTheMemberStoredValueReport: '会员储值报表导出失败',
    searchPlaceholder: '手机号/证件/姓名/卡号',
  },
  clientClient: {
    guestTag: '客人标签',
    pleaseEnterYourContactInformation: '请输入联系方式',
    pleaseEnterYourNationality: '请输入国籍',
    pleaseEnterNationality: '请输入民族',
    pleaseEnterAddress: '请输入住址',
    age: '年龄',
    customerLabel: '客户标签',
    modifyGuestInformation: '修改客人信息',
    inputLabelDuplication: '输入标签重复',
    pleaseEnterTheLabelContent: '请输入标签内容',
    doNotEnterLabelsInMoreThan10Words: '输入标签不要超过10个字',
  },
  financeIndex: {
    pleaseCancelRenewFirst: '请先取消续住，再操作退房',
    addAnotherItem: '添加另一细目',
    checkInOrderNumber: '入住单号',
    adjustFinance: '调整财务',
    batchTransfer: '批量转账',
    checkOut: '挂账退房',
    pleaseEnterTheRoomNumber: '请输入房间号',
    pleaseEnterRoomTypeName: '请输入房型名称',
    pleaseEnterChannel: '请输入渠道',
    pleaseEnterCheckInTime: '请输入入住时间',
    pleaseEnterYourDepartureTime: '请输入离店时间',
    pleaseEnterAccount: '请输入科目',
    entryTime2: '入账时间',
    pleaseEnterTheCreditDate: '请输入入账时间',
    consumptionAmountyuan: '消费金额（元）',
    pleaseEnterTheAmountSpent: '请输入消费金额',
    paymentAmountyuan: '付款金额（元）',
    pleaseEnterThePaymentAmount: '请输入付款金额',
    editBill: '编辑账单',
    checkOut2: '结账退房',
    cancelAccount: '撤销结账',
    partialClosing: '部分结账',
    accountAdjustment: '调账',
    smallGoodsAreAccountedFor: '小商品入账',
    pleaseSelectAPaymentHistory: '请选择付款记录',
    pleaseFillInTheAmountOfPayment: '请填写付款金额',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting: '您的账务信息为空，请入账后再操作打印',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect: '房单号不能为空,请检查页面路径是否正确',
    smallwares: '小商品',
    creditOrdersDoNotSupportPartialCheckout: '信用住订单不支持部分结账',
    pleaseSelectTheOrderYouWantToCheckOut: '请选择要结账的订单',
    creditBookingIsNotSupportedPleaseCheckOutDirectly: '信用住订单不支持挂账，请您直接结账退房',
    pleaseSelectACover: '请选择账套',
    unionpayScanCode: '银联-扫码',
    checkOutSuccessfully: '退房成功',
    securityDeposit: '押金',
    warmReminder: '温馨提示',
    signOut: '注销',
    cancelled: '已注销',
    the: '的',
    wheatDoorLockPlugInCancellationCard: '麦田门锁插件注销卡',
    whetherTheKeyCardHasBeenCancelled: '门卡是否已注销',
    selectUnsettledAccountsWarning: '请选择“未结账”的账务',
    feizhuRoomFeeValidation: '飞猪房费金额必须≥0，当前结账房费:{roomRateFees}',
    feizhuNonRoomFeeValidation: '飞猪"非房费"金额必须≥0，当前"非房费"结账房费:{fees}',
    pleaseSelectUnsettledAccounts: '请选择未结账的账务',
    additionalChargeAmountEmpty: '加收金额为空，请再次操作',
  },
  financeMangementOld: {
    accountType: '账户类型',
    creditAccount: '信用账号',
    prepaidAccount: '预付账号',
    settlementPeriod: '结算账期',
    maximumAmount: '最大额度',
    theMaximumMustBeGreaterThanZero: '最大额度必须大于零',
    theMaximumAmountCannotBeGreaterThan100Million: '最大额度不能大于一个亿',
    theStartTimeCannotBeEqualToTheEndTime: '开始时间不能等于结束时间',
    theStartTimeCannotBeLaterThanTheEndTime: '开始时间不能大于结束时间',
    pleaseSelectAnEndTime: '请选择结束时间',
    theEndTimeCannotBeEqualToTheStartTime: '结束时间不能等于开始时间',
    theEndTimeCannotBeLaterThanTheStartTime: '结束时间不能小于开始时间',
    pleaseEnterTheBillingPeriod: '请输入结算周期',
    settlementPeriodCanOnlyBeEnteredInNumbers: '结算周期只能输入数字',
    newAccount: '新增账户',
    pleaseFillInTheAccountName: '请填写账户名称',
    pleaseFillInTheCompanyName: '请填写公司名称',
    pleaseSelectAnAccountType: '请选择账户类型',
    pleaseSelectAChannelName: '请选择渠道名称',
  },
  financeMangement: {
    creditAccount: '信用账号',
    prepaidAccount: '预付账号',
    enableConfirmation: '启用成功后，该协议单位将支持挂账，是否启用？',
    disableConfirmation: '禁用成功后，该协议单位将不再支持挂账，是否禁用？',
  },
  foodRoomAccountFinance: {
    foodSource: '餐饮来源',
    foodRoomAccountLabel: '餐饮挂房账',
    foodOrderNo: 'Food订单号',
    fmisAccountSerialNo: 'FMIS账务流水号',
    chargedAmount: '挂账金额',
    notAllowedSplit: '餐饮挂房账不允许拆账',
    notAllowedRush: '餐饮挂房账不允许冲账',
    notAllowedTransfer: '餐饮挂房账不允许转账',
    notAllowedPartialSettlement: '餐饮挂房账不允许部分结账',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen: '在线支付科目不允许拆账',
    smallCommodityAccountsCanNotBeDismantled: '小商品科目不能拆账',
    negativeDebtCannotBeBroken: '负账不能拆账',
    accountsReceivableAreNotAllowedToBeDebunked: '应收账科目不允许拆账',
    debitsAreNotAllowedInThisAccount: '该科目不允许拆账',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks: '在线支付退款账务不允许做冲账',
    theAccountHasBeenRefundedAndCannotBeCharged: '该账务已退款，不允许冲账',
    refundedAccountsCannotBeCharged: '已退款的账务无法冲账',
    thisAccountIsNotAllowedToBeCharged: '该科目不允许冲账',
    businessDayHasBeenSwitchedNoChargeIsAllowed: '营业日已切换，不允许冲账',
    splitBill: '拆账',
    transfer: '转账',
    offset: '冲账',
    refund: '退押',
  },
  detailcomponentsAccountlisttable: {
    onAccount: '已挂账',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: '加收房费过大',
    chargeJudgment: '加收判断',
    addOnOption: '加收选项',
    generatedRoomCharge: '生成房费',
    pleaseFillInTheAdditionalRoomCharge: '请填写加收房费',
    theAdditionalAmountCannotBe0: '加收金额不能为0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: '调账成功',
    accountAdjustment: '调账 ',
    accountOfReconciliation: '调账科目',
    incorrectTransferAmountFormatupToTwoDecimalPlaces: '调账金额格式不正确（最多两位小数） ',
    theTransferAmountCannotBe: '调账金额不能为',
    theTransferAmountCannotBeGreaterThan100Million: '调账金额不能大于一个亿',
  },
  detailcomponentsArsuitselect: {
    receivableSet: '应收账套',
    creditOrderCheckoutTip: '信用住订单需在退房时挂账',
    nonProtocolOrderArTip: '非协议单位订单无法挂账',
  },
  detailcomponentsBackout: {
    closedSuccessfully: '撤销结账成功',
    cancelAccount: '撤销结账',
    confirmationRevocation: '确认撤销',
    pleaseSelectTheBillYouWantToCancel: '请选择要撤销的账单',
  },
  detailcomponentsBorrow: {
    return: '归还',
    itemBorrowingReminder: '物品借用提醒',
    borrowARoom: '借用房间',
    quantityBorrowed: '借用数量',
    returnQuantity: '归还数量',
    loanDate2: '借用日期',
    returnOrNot: '是否归还',
    whetherToReturnAll: '是否全部归还',
    amountOfCompensation: '赔偿金额',
    onlyNumbersGreaterThan0CanBeEntered: '只能输入大于0的数字',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed: '部分归还只能小于借用数量',
    returned: '已归还',
    noReturn: '未归还',
    returnSuccessfully: '归还成功',
  },
  detailcomponentsColorblock: {
    financialType: '财务类型',
    accountingType: '账务类型',
    orderForGoods: '订单',
  },
  detailcomponentsCommon: {
    unionpayScanCode: '银联-扫码',
    insufficientMemberBalance: '会员余额为{balance}元，请选择其他收款方',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert: '提示：飞猪信用住订单，实际结算房费{roomRate}元，结算非房费{nonRoomRate}元，请核实金额无误后提交结账退房',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: '添加拆账',
    totalAmount: '总金额',
    totalDebitsTaken: '已拆账合计',
    totalUndismantledLoans: '未拆账合计',
    successfulDismantling: '拆账成功',
    borrowMoney: '拆账',
    loanAmount: '拆账金额',
    upTo150Words: '最多150字',
    closedAccount: '已拆账',
    tenAtMost: '拆账最多十条',
    theAmountOfDebitsIsNotEqualToTheTotalAmount: '拆账金额不等于总金额',
    theDebitAmountMustBeFilledInAndGreaterThan: '拆账金额必填且大于',
  },
  detailcomponentsEnteraccount: {
    cashCnyReceipt: '人民币现金收款',
    accountEntry: '入账科目',
    amountRecorded: '入账金额',
    pleaseFillInTheAmountOfPayment: '请填写入账金额',
    pleaseSelectAPaymentMethod: '请选择支付方式',
    entriesCannotBeEmpty: '入账科目不能为空',
    theAmountRecordedCannotBe: '入账金额不能为0',
    pleaseFillInUnitPrice: '请填写单价',
    unitPriceCannotBeZero: '单价不能为0',
    pleaseFillInServings: '请填写份数',
    servingsCannotBeZero: '份数不能为0',
    pleaseSelectMealDate: '请选择用餐日期',
    ArRefundCannotExceedBalance: 'Ar退款金额不能大于Ar余额',
  },
  detailcomponentsExpandcolumn: {
    memberName: '会员姓名',
    receivableSet: '应收账套',
    from: '从',
    orderForGoods: '订单',
    rollOutTo: '转出至',
    refundedAmount: '已退：{amount}元',
  },
  detailcomponentsHangaccounts: {
    checkOut: '挂账退房 ',
    reasonForPayment: '挂账原因',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: '房费确认',
    roomRate2: '房费金额',
  },
  detailcomponentsPartsettle: {
    partialClosing: '部分结账',
    pleaseFillInTheAmountOfPayment: '请填写付款金额',
    pleaseSelectAPaymentHistory: '请选择付款记录',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: '授权结算',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: '取消授权中请稍后',
    succeededInCancelingAuthorization: '取消授权成功',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom: '房间中存在未结算的预授权记录',
    confirmThatYouWantToCancelAuthorization: '确认要取消授权',
    roomPaymentRequired: '客房需{action}金额：',
    orderCanceledWarning: '订单已取消，无法{action}',
    roomCheckedInWarning: '房间已入住，无法{action}',
    roomCheckedOutWarning: '房间状态为"已退房"，无法{action}',
  },
  detailcomponentsRefundtip: {
    refundReminder: '退款提示',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid: '使用在线退款时，金额会退到客人付款的账户',
    whenUsingAOneCardRefundSystem: '使用一卡通退款时，金额会退到客人付款的账户',
  },
  detailcomponentsSmallwarecost: {
    smallwares: '小商品',
    smallGoodsEnteredTheAccountSuccessfully: '小商品入账成功',
    smallGoodsAreAccountedFor: '小商品入账',
    payOrNot: '是否支付',
    pleaseEnterTheExternalOrderNumber: '请输入外部单号',
    pleaseSelectASmallItem: '请选择小商品',
    insufficientMemberBalance: '会员余额为{balance}元，请选择其他收款方',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: '转账 ',
    transferToAccount: '转入账号',
    pleaseSelectValidTransferAccount: '请选择有效的转入账号',
    transferSuccess: '转账成功',
    batchTransferSuccess: '批量转账成功',
  },
  mangementMember: {
    orderType: '订单类型',
    receivableOrders: '订单应收账',
    totalAmountNotApproved: '未核总金额',
    approvedTotalAmount: '已核总金额',
    amountAvailable: '可用金额',
    amountSpent: '已用金额',
    whetherToWriteOffAllTheReceivables: '是否要将应收账全部核销',
    whetherToReverseWriteOffAllTheReceivables: '是否要将应收账全部反核销',
    cancelAfterVerification: '核销',
    reverseWriteOff: '反核销',
    depositInAdvance: '预存款',
    dateOfPosting: '挂账日期',
    pleaseEnterTheOrderNumber: '请输入订单号',
    completeWriteOff: '全部核销',
    completeReverseWriteOff: '全部反核销',
    batchWriteOff: '批量核销',
    batchReverseWriteOff: '批量反核销',
    records: '记录',
    advanceCredit: '预付入账',
    thePrepaidAmountMustBeGreaterThanZero: '预付金额必须大于零',
    theAmountInAdvanceCannotBeGreaterThan100Million: '预付金额不能大于一个亿',
    checkTheDepartureDateUpToOneMonth: '离店日期最多查询一个月',
    noAccountPleaseCreateANewOne: '没有账套，请新建',
    allWereSuccessfullyWrittenOff: '全部核销成功',
    allWriteOffsFailed: '全部核销失败',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated: '应收账生成当日不允许核销',
    pleaseSelectTheItemsYouWantToWriteOff: '请选择要核销的项目',
    listOfAccountsReceivable3XLS: '应收帐列表.xls',
    prepaymentAmountRequired: '请填写预付金额',
    prepaymentAmountFormatError: '预付金额格式不正确（最多两位小数）',
  },
  mangementTablerow: {
    paidInAmount: '实收金额',
  },
  mangementVerificatemodal: {
    successfulWriteOff: '核销成功',
    cancelAfterVerification: '核销',
    reverseWriteOff: '反核销',
    generationTime: '生成时间',
    amountWrittenOff2: '核销金额',
    pleaseFillInTheWriteOffAmount: '请填写核销金额',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff: '核销金额不能大于可核销金额',
  },
  mangementVerifyrecordsmodal: {
    records: '记录',
    lot: '批次',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod: '合同期内累计未抵扣欠间夜',
    hideZeroAmounts: '不显示全部0元',
  },
  merchantCheckBill: {
    confirmationCheck: '确认核对',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill: '确认后将按照本账单进行结算',
    appealChannel: '申诉渠道',
    causeOfAppeal: '申诉理由',
    youCanEnterUpTo150Words: '最多可输入150字',
    accountName: '开户名',
    roomBillCheck: '房单账单核对',
    memberIncentiveCheck: '会员激励核对',
    confirmed: '已确认',
    reasonForAdjustment: '调整原因',
    deductibleTarget: '抵扣目标',
    currentDeduction: '本期抵扣',
    deductible: '已抵扣',
    confirmationTime: '确认时间',
    rejectionTime: '驳回时间',
    liveLightlyInTheDirectCamp: '轻住直营',
    new: '新增',
    appealSuccessfully: '申诉成功',
    checkSuccessfully: '核对成功',
    currDeductionDesc: '1. 本期抵扣为正数，代表轻住抵扣商家金额2. 本期抵扣为负数，代表返还商家金额',
    qzMerchantSettleDesc: '轻住与商家结算=订单总金额-本期抵扣',
  },
  merchantInfoManage: {
    changeLetter: '变更函',
    note: '注',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount: '修改收款账号需要通过审核后才能打款，如果当前有待支付结算款，仍将按照原账户打款',
    groundsForRejection: '驳回理由',
    downloadTheAttachmentTemplate2: '下载附件模版',
    viewingModificationLogs2: '查看修改日志',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution: '该结算信息用于房费结算，仅限酒店老板修改，请谨慎添加',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired: '该收款账号用于房费结算，仅限酒店老板修改，请谨慎修改，按要求上传变更函并加盖公章',
    modifyLog2: '修改日志',
    beforeModification3: '修改前',
    receivablesAccountManagement2: '收款账号管理',
    bankAccountName4: '银行开户姓名',
    letterOfRequestForChange2: '申请变更函',
    pleaseEnterYourBankName2: '请输入银行开户姓名',
    pleaseUploadTheRequestForChange2: '请上传申请变更函',
    afterModification2: '修改后',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile: '申请变更函，下载后需要打印出来签字盖章，再上传图片或者PDF文件',
    onlyJpgPngAndPdfFilesCanBeUploaded: '仅支持上传jpg，png，pdf格式文件',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: '小程序结算规则问题',
    settlementOfPaymentProblems: '结算打款问题',
    smallProgramSettlementRulesCommonProblems: '小程序结算规则常见问题',
    frequentlyAskedQuestionsAboutSettlementPayments: '结算打款常见问题',
    q1SettlementCriteria: 'Q1：什么样的账单可以结算？',
    a1SettlementCriteria: '我们结算的口径是订单状态已完成，且已离店状态。',
    q2PmsCancellation: 'Q2：PMS账单取消怎么办？',
    a2PmsCancellation: 'PMS是取消状态，我们的结算标准是：客人要求取消后，退款给客人的，需要联系客服团队，走退款流程。',
    q1AuditTime: 'Q1：结算审核的时间是什么时候？',
    a1AuditTime: '每周五之前会将下周的直连结算账单上传结算系统，商家只需要在下个周四申请打款的时候确认账单即可打款。',
    q2PaymentTime: 'Q2：商家已经确认账单了，什么时候打款？',
    a2PaymentTime: '已经确认账单的商家，会在周四打款。往期打款失败的商家同样也会再周四--周五补打款打款。',
    q3CheckPayment: 'Q3：怎么查看是否已经给商家打款了？',
    a3CheckPayment: '商家在打款记录界面，可以查看是否已经打款。',
    q4RejectedStatement: 'Q4：对账单被驳回了怎么办？啥时候打款？',
    a4RejectedStatement: '商家驳回的账单，总部会再次进行审核，如总部调整完毕之后，商家赶在周四能够确认账单，则在周四打款，没有确认的账单会在下个周四申请打款。',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: '房费打款记录',
    memberIncentiveRecord: '会员激励记录',
    fundsToBeRemitted: '待打款',
    remitting: '打款中',
    remittedMoney: '已打款',
    paymentFailure2: '打款失败',
    collectionAccount: '收款账户',
    payee: '收款人',
    statusUpdateTime: '状态更新时间',
    paymentTime: '打款时间',
    timeToInitiateAPayment: '发起打款时间',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard: '请扫描云账户二维码 绑定银行卡',
    bindBankCard: '绑定银行卡',
    completeInformation: '个人信息',
    bankAccountName4: '银行开户姓名',
    idNumber: '身份证号',
    pleaseEnterYourBankName2: '请输入银行开户姓名',
    pleaseEnterYourIdNumber2: '请输入身份证号',
    idNumberFormatIsIncorrectPleaseReEnter: '身份证号格式错误，请重新输入',
    phoneNumberFormatIsIncorrectPleaseReEnter: '手机号格式错误，请重新输入',
    pleaseUpload: '请上传',
    internalUserHidden: '内部用户不可见',
    amountPendingPayment: '金额{amount}，会在稍后打款',
  },
  billCheckBillDetails: {
    channelDetails: '渠道详情',
    whereToConnectDirectly: '去哪儿直连',
    drench: '轻住',
    cityWide: '同城',
    whereToGo: '去哪儿',
    distribution: '分销',
    tradeCaravan: '商旅',
    statementOfAccount: '对账单',
    qzSettleFormula: '轻住与商家结算=订单结算金额+商家承担退款+商家承担优惠+商家公益金额',
    merchantDiscountNote: '当本期订单发生退款时，商家承担优惠金额为0',
    merchantWelfareAmountTip: '包括商家公益金额合计',
    otherAmountTipDouyin: '包括达人佣金、早餐佣金合计；服务商佣金暂不收取',
  },
  billCheckBill: {
    turnDown: '驳回',
    ticketReceived: '已收票',
    forThePublic: '对公',
    forPrivacy: '对私',
    expenseDetail: '费用明细',
    confirmationCheck: '确认核对',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill: '确认后将按照本账单进行结算',
    perfectInformation: '完善信息',
    causeOfAppeal: '申诉理由',
    youCanEnterUpTo150Words: '最多可输入150字',
    creditDetails: '抵扣详情',
    roomNightCreditDetails: '间夜抵扣详情',
    invoiceManagement: '发票管理',
    sellersName: '销售方名称',
    invoiceNumber: '发票票号',
    invoiceDate: '发票日期',
    invoiceAmount2: '发票金额',
    electronicInvoiceOrNot: '是否电子发票',
    invoiceFile: '发票文件',
    reasonForRejectingInvoice: '发票驳回原因',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0: '订单总金额已包含上期账单轻住与商家结算金额小于0的金额',
    quantityDueForTheCurrentPeriod: '本期应抵数量',
    actualAmountOfDeductionForTheCurrentPeriod: '本期实际抵扣数量',
    amountDeductedForTheNightOfThePeriod: '本期间夜抵扣金额',
    uncreditedQuantityForTheCurrentPeriod: '本期未抵扣数量',
    pleaseEnter150WordsOrLess: '请输入150字以内',
    pleaseEnterTheInvoiceHoldersInformation: '请输入发票人信息',
    pleaseEnterTheInvoiceNumber: '请输入发票票号',
    pleaseEnterExpiryDate2: '请输入有效期',
    pleaseSelectTheInvoiceType: '请选择发票类型',
    pleaseSelectWhetherToEInvoice: '请选择是否电子发票',
    pleaseUploadTheInvoicePhoto: '请上传发票照片',
    pleaseFillInTheAmount: '请填写金额',
    specialTicket: '专票',
    ordinaryTicket: '普票',
    expenseItem: '费用项',
    amountIncurred: '发生金额',
    source: '来源',
    instructions: '说明',
    confirmationTime: '确认时间',
    groupReceiptStatus: '集团收票状态',
    rejectionTime: '驳回时间',
    whetherTheInvoiceHasBeenEntered: '发票是否已录入',
    feeDetails: '费用详情',
    fileUpload: '文件上传',
    uploadAMaximumOf5Images: '图片最多上传5张',
    appealSuccessfully: '申诉成功',
    checkSuccessfully: '核对成功',
    theSizeOfTheUploadedCompressedPackageCannotExceed: '上传压缩包大小不能超过',
    onlyTheUploadFormatIsSupported: '上传格式只支持',
    theCompressedPackageFileCannotBeLargerThan: '压缩包文件不能大于',
    amountOfDeductionForTheCurrentPeriod: '本期抵扣金额',
    theMerchantNeedsToInvoiceTheAmount: '商家需开票金额',
    billingDetails: '账单详情',
    currentAdrAmount: '本期ADR金额',
    settlementSystemUpgrade: '为了满足银行对资金结算的要求，提高结算效率，完善结算资质信息，现集团对结算系统进行升级，现需要补充银行要求的资质信息！',
    confirmPreviousBills: '请先确认往期账单，否则新账期账单无法展示',
    paperInvoiceInstructions: '纸质发票，快递为寄付，到付件一律驳回，发票收件人为：轻住分销电子发票；电话：15901580289，若发票为纸质发票，则轻住收到票后审核发票',
    uploadFormatRestrictions: '注：支持pdf、图片、word、压缩包、ofd5种格式其中一种上传。pdf和ofd最大支持5个，单个最大3M；图片最大支持5张，单个最大3M，图片格式包含jpg、jpeg、png；word最大支持1个，最大20M，压缩包最大支持1个，最大20M，压缩包支持rar、zip、7z',
    cumulativeUndeductedNights: '合同期内累计未抵扣欠间夜（本账期抵扣前）',
    invoiceDuplicate: '发票票号重复，请检查票号是否正确，若票号正确，请在备注中填写重复使用相同发票的原因。',
    pdfSizeExceeded: '上传pdf大小不能超过 3MB!',
    ofdSizeExceeded: '上传ofd大小不能超过 3MB!',
    wordSizeExceeded: '上传word大小不能超过 20MB!',
    singleFormatOnly: '仅支持1种格式!',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: '会员激励详情',
    memberIncentiveStatement: '会员激励对账单',
  },
  billDeductionDetails: {
    feeDetails: '费用详情',
    statementDetailsSheet: '对账单详情单',
  },
  billRemitRecord: {
    collectionAccount: '收款账户',
    payee: '收款人',
    statusUpdateTime: '状态更新时间',
    timeToInitiateAPayment: '发起打款时间',
    paymentTime: '打款时间',
  },
  billCheckDetails: {
    channelOrderDetails: '渠道订单详情',
    merchantRefunds: '商家承担退款',
    merchantConcession: '商家承担优惠',
    channelOrderNumber: '渠道订单号',
    reasonForAdjustment3: '调整理由',
    adjustmentType: '调整类型',
    originalOrderPrice: '订单原价',
    memberDiscount: '会员折扣',
    skimpingOnCommission: '轻住佣金',
    payChannelCommission: '支付渠道佣金',
    amountOfMerchantWelfare: '商家公益金额',
    refundNight: '退款间夜',
    totalRefundAmount: '退款总金额',
    stayEasyAndRefundCommission: '轻住退款佣金',
    subsidy: '补贴',
    saleCardOrderNumber: '售卡订单号',
    membershipLevel: '会员级别',
    dateOfRegistration: '注册日期',
    referrer: '推荐人',
    amountPaid: '支付金额',
    merchantsShareTheAmount: '商家分润金额',
    employeeShareAmount: '员工分润金额',
    shareAmount: '分润金额',
    rebateRatio: '返佣比例',
    commissionRebate: '返佣金额',
    distributionSubchannel: '分销子渠道',
    channelCost: '渠道原价',
    lightSettlementWithMerchantsOrder: '轻住与商家结算（订单）',
    lightUndertakeDiscounts: '轻住承担优惠',
    orderBasePrice: '订单底价',
    invoiceAmount: '开票金额',
    roomFeeCommission: '轻住房费佣金',
    expertCommission: '达人佣金',
    serviceCommission: '服务商佣金',
    breakfastCommission: '早餐佣金',
    roomFeeCommissionRefund: '房费佣金退款',
    expertCommissionRefund: '达人佣金退款',
    serviceCommissionRefund: '服务商佣金退款',
    breakfastCommissionRefund: '早餐佣金退款',
  },
  billDedetails: {
    currentAmountReceivable: '本期应收金额',
    amountOfDeductionForTheCurrentPeriod: '本期抵扣金额',
    remainingAmountOfDeduction: '剩余抵扣金额',
    pleasureManagementFee: '悦享管理费',
    brandManagementFee: '品牌管理费',
    mastersCommission: '店长费用',
    otherExpenses: '其他费用',
    openingDate: '开业日期',
    preferentialPolicy: '优惠政策',
    managementFeeStartDate: '开始收取管理费日期',
    thisPeriodOfBusinessSelfPromotion: '本期商家自促',
    enjoyCommissionRate: '悦享佣金率',
    enjoyManagementFeeForThisPeriod: '本期悦享管理费',
    currentAdjustmentExpense: '本期调整费用',
    reasonsForAdjustingExpensesInTheCurrentPeriod: '本期调整费用原因',
    notPaidInThePreviousPeriod: '上期未缴',
    currentReceivable: '本期应收',
    currentPaid: '本期已缴',
    balanceDue: '剩余应缴',
    brandCommissionRate: '品牌佣金率',
    currentBrandManagementFee: '本期品牌管理费',
    monthlyRate: '月收费标准',
    currentObjective: '本期目标',
    totalPmsRevenueForThePeriod: '本期PMS总营收',
    totalPmsReceivableForThePeriod: '本期PMS总应收',
  },
  chargeIndex: {
    expenseItem: '费用项',
    totalAmountPayable: '应付总金额',
    cashPayable: '现金应付',
    creditPayable: '抵扣应付',
    deductionAdjustment: '抵扣调整',
    deductible: '已抵扣',
    residualCredit: '剩余抵扣',
    managementFeeStartDate: '开始收取管理费日期',
    currentObjective: '本期目标',
    currentPeriodAdjustment: '本期调整',
    notPaidInThePreviousPeriod: '上期未缴',
    currentReceivable: '本期应收',
    currentPaid: '本期已缴',
    balanceDue: '剩余应缴',
  },
  commonIndex: {
    accountName: '开户名',
    collectionAccountType: '收款账号类型',
    distributionRoomBillReconciliation: '分销房费账单核对',
    memberIncentiveCheck: '会员激励核对',
    directSellingRoomFeePaymentRecords: '直销房费打款记录',
    distributeRoomChargePaymentRecords: '分销房费打款记录',
    memberIncentiveRecord: '会员激励记录',
    confirmed: '已确认',
    reasonForAdjustment: '调整原因',
    settlementGrounds: '结算理由',
    operationDetails: '操作详情',
    merchantRefunds: '商家承担退款',
    merchantConcession: '商家承担优惠',
    amountOfMerchantWelfare: '商家公益金额',
    americanOrder: '美团订单',
    flyingPigOrder: '飞猪订单',
    lightLiveMiniProgramOrder: '轻住小程序订单',
    memberShareAmount: '会员分润金额',
    theAmountOfCrossStoreRefund: '跨店返佣金额',
    lightlyAdjustTheAmount: '轻住调整金额',
    reasonForAdjustment3: '调整理由',
    fundsToBeRemitted: '待打款',
    remitting: '打款中',
    remittedMoney: '已打款',
    paymentFailure2: '打款失败',
    lightSettlementWithMerchantsOrder: '轻住与商家结算（订单）',
  },
  infoInfoManage: {
    note: '注',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture: '申请变更函，下载后需要打印出来签字盖公章，如打印为2页，请加盖骑缝章，再上传图片',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade: '提交修改收款账户审核流程，审核通过后才能打款，驳回的账户，不予打款',
    beforeModification3: '修改前',
    pleaseBePatientWhileTheInformationIsBeingReviewed: '信息审核中，请耐心等待',
    groundsForRejection: '驳回理由',
    downloadTheAttachmentTemplate2: '下载附件模版',
    forPrivacy: '对私',
    forThePublic: '对公',
    auditStatus: '审核状态',
    viewingModificationLogs2: '查看修改日志',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress: '请尽快上传银行卡信息，以免影响您的结算进度',
    modifyLog2: '修改日志',
    receivablesAccountManagement2: '收款账号管理',
    collectionAccountType: '收款账号类型',
    pleaseSelectACollectionAccountType: '请选择收款账号类型',
    bankAccountName5: '银行开户名称',
    recipientsCellPhoneNumber: '收款人手机号',
    pleaseEnterTheRecipientsMobilePhoneNumber: '请输入收款人手机号',
    payeeIdNumber: '收款人身份证号',
    pleaseEnterThePayeeIdNumber: '请输入收款人身份证号',
    payeeIdCardFront: '收款人身份证正面',
    reverseOfPayeeIdCard: '收款人身份证反面',
    uploadContractAttachment: '上传合同附件',
    letterOfRequestForChange2: '申请变更函',
    pleaseEnterTheBankAccountName: '请输入银行开户名称',
    pleaseEnterTheLegalPersonName: '请输入法人姓名',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter: '法人姓名只能输入汉字，请重新输入',
    phoneNumberFormatIsIncorrectPleaseReEnter: '手机号格式错误，请重新输入',
    pleaseEnterYourIdNumber2: '请输入身份证号',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter: '身份证号格式错误，只能输入数字和大写字母，请重新输入',
    pleaseEnterAUnifiedSocialCreditCode: '请输入统一社会信用代码',
    onlyNumbersAndLettersAreSupportedPleaseReEnter: '仅支持数字和字母，请重新输入',
    pleaseUploadTheRequestForChange2: '请上传申请变更函',
    frontOfIdentityCard: '身份证正面',
    reverseOfIdCard: '身份证反面',
    businessLicense: '营业执照',
    pleaseUploadTheContractAttachment: '请上传合同附件',
    afterModification2: '修改后',
    corporateName: '法人姓名',
    unifyTheSocialCreditCode: '统一社会信用代码',
    legalPersonMobilePhoneNumber: '法人手机号',
    pleaseEnterTheFrenchPhoneNumber: '请输入法人手机号',
    legalPersonIdNumber: '法人身份证号',
    pleaseEnterTheCorporateIdNumber: '请输入法人身份证号',
    corporateIdentityCardFront: '法人身份证正面',
    reverseOfCorporateIdentityCard: '法人身份证反面',
    pleaseUpload: '请上传',
    fileUpload: '文件上传',
    uploadAMaximumOf2Images: '最多上传2张图片',
    theSizeOfTheUploadedProfilePictureCannotExceed: '上传头像图片大小不能超过',
    uploadPictureFormatOnlySupported: '上传图片格式只支持',
    onlyJpgJpegAndPngFilesCanBeUploaded: '仅支持上传jpg，jpeg，png格式文件',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto: '仅支持上传jpg，jpeg，png格式文件,请将变更函拍成一张照片上传',
    pleaseWaitFileUploadIsNotComplete: '请等待，文件上传尚未完成',
    contractStampPageRequired: '合同盖章页面（必选）',
    otherPagesOptional: '其他页（选填，最多上传2张）',
    contractStampInstructions: '2、合同盖章页：需有乙方收款账户信息页面，并盖公章，上传符合要求的合同盖公章页面；',
    individualMobileNote: '注：如个体工商户则填写经营者手机号',
    individualNameNote: '注：如个体工商户则填写经营者姓名',
    individualIdNote: '注：如个体工商户则填写经营者身份证号',
    individualRegNumberNote: '注：如个体工商户则填写注册号',
    maxTwoImages: '最多上传2张图片',
    recipientLegalMobile: '收款人/法人手机号',
    recipientLegalIdNumber: '收款人/法人身份证号',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: '开票申请',
    expenseType: '费用类型:',
    totalAmountApplied: '申请金额合计',
    theApplicationAmountIsIncorrect: '申请金额填写有误',
    status: '状态:',
    causeOfRejection: '驳回原因:',
    billingInformation: '开票信息:',
    pleaseEnterPhoneNumber: '请输入电话',
    dutyNumber: '税号',
    pleaseEnterYourTaxId: '请输入税号',
    pleaseEnterYourAccountBank: '请输入开户行',
    pleaseEnterTheAddress: '请输入地址',
    openABankAccount: '开户行账号',
    pleaseEnterYourBankAccountNumber: '请输入银行账号',
    pleaseEnterEmail: '请输入邮箱',
    pickUpTelephone: '收件电话',
    pleaseEnterTheReceivingPhoneNumber: '请输入收件电话',
    mailingAddress: '邮寄地址',
    pleaseEnterYourMailingAddress: '请输入邮寄地址',
    addressee: '收件人',
    pleaseEnterTheRecipient: '请输入收件人',
    repudiationPeriod: '驳回账期:',
    claimPeriod: '申请账期:',
    pleaseEnterTheAmountRequested: '请输入申请金额',
    theNumberCannotExceed15Digits: '号码不能超过15位',
    pleaseEnterTheCorrectNumber: '请输入正确的号码',
    paymentPeriod: '账期',
    availableAmount: '可开金额',
    amountApplied2: '申请金额',
    pleaseSelectTheBillingType5: '请选择开票类型',
    receipt: '收据',
    pleaseEnterTitle: '请输入抬头',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain: '当前所选费用类型无开票数据，请重新选择',
    theTotalApplicationAmountNeedsToBeGreaterThan: '申请金额合计需要大于',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit: '开票类型和费用类型不对应,收据只能匹配保证金和品质保证金',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission: '提交成功 5s后自动关闭页面',
    generalInvoice: '普票(电子发票)',
    specialInvoice: '专票(电子发票)',
  },
  invoicingInvoicingApplication: {
    applicationDate: '申请日期',
    billingApplication: '开票申请',
    expenseType: '费用类型',
    amountApplied2: '申请金额',
    expressNumber: '快递号',
    alreadyRequested: '已申请',
  },
  preauthorizationIndex: {
    turn: '转',
    increaseAuthorization: '增加授权',
    authorizationFailure: '授权失败',
    settlementTime: '结算时间',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem: '预授权明细 - 轻赢宝酒店管理系统',
    declined: '已拒绝',
    flyingPigCreditDoesNotSupportPreAuthorization: '飞猪信用住暂未支持预授权',
    newAuthorization: '新增授权',
    cancelAuthorizationPleaseWait: '取消授权中请稍后',
    succeededInCancelingAuthorization: '取消授权成功',
    pleaseWaitForTheSettlementAuthorization: '结算授权中请稍后',
    confirmThatYouWantToCancelAuthorization: '确认要取消授权',
    orderStatusWarning: '订单{status}，无法{action}',
    roomStatusWarning: '房间已入住，无法{action}',
    roomCheckoutWarning: "房间状态为'已退房'，无法{action}",
  },
  componentsAuthsettle: {
    payment3: '支付',
    paidInAmount: '实收金额',
    settlementSuccess: '结算成功',
    authorizedSettlement: '授权结算',
    accountEntry: '入账科目',
    pleaseFillInTheAuthorizedAmount: '请填写授权金额',
    theActualAmountReceivedMustBeGreaterThan0: '实收金额必须大于0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount: '实收金额不能大于授权金额',
  },
  componentsBanklist: {
    bankOfChina: '中国银行',
    industrialAndCommercialBankOfChina: '中国工商银行',
    industrialAndCommercialBankOfChina3: '工商银行',
    agriculturalBankOfChina: '中国农业银行',
    agriculturalBankOfChina3: '农业银行',
    chinaConstructionBank: '中国建设银行',
    chinaConstructionBank3: '建设银行',
    postalSavingsBankOfChina: '中国邮政储蓄银行',
    postalSavingsBank: '邮储银行',
    bankOfCommunications: '交通银行',
    chinaMerchantsBank: '招商银行',
    shanghaiPudongDevelopmentBank: '上海浦东发展银行',
    shanghaiPudongDevelopmentBank3: '浦发银行',
    chinaCiticBank: '中信银行',
    everbrightBank: '光大银行',
    chinaMinshengBank: '中国民生银行',
    minshengBank: '民生银行',
    guangdongDevelopmentBank: '广东发展银行',
    guangfaBank: '广发银行',
    pingAnBank: '平安银行',
    industrialBank: '兴业银行',
    huaxiaBank: '华夏银行',
    bankOfShanghai: '上海银行',
    bankOfBeijing: '北京银行',
    bohaiBank: '渤海银行',
    zheshangBank: '浙商银行',
    huishangBank: '徽商银行',
    hsbc: '汇丰银行',
    hangSengBank: '恒生银行',
    hengfengBank: '恒丰银行',
  },
  componentsExpandcolumn: {
    bankName: '银行名称',
    authorizationCode: '授权码',
    from: '从',
    rollOutTo: '转出至',
  },
  componentsTransferaccounts: {
    transferMoney: '转账 ',
    transferToAccount: '转入账号',
    authorizationFailure: '授权失败',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: '有效期到期后自动结算',
    authorizationCode: '授权码',
    bankName: '银行名称',
    pleaseFillInTheAuthorizedAmount: '请填写授权金额',
    newAuthorization: '新增授权',
    modifyAuthorization: '修改授权',
    renewal: '更新',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation: '提示：该订单为EB单，取消前请核实OTA订单状态',
    orderCancelledSuccessfully: '订单取消成功',
    cancelAnOrder2: '取消订单',
    cancellationReason: '取消原因',
    remarks5100Words: '备注（5-100文字）',
    replyTextMinimum5Words: '回复文字最少5个字',
    pleaseSelectACancellationReason: '请选择取消原因',
    originalStayWillBeCancelled: '原单续住将自动取消',
    cancellationRules: '取消规则',
    channelDescription: '渠道说明',
    refundScore: '是否退还积分',
    refundCoupon: '是否退还优惠券',
    orderMessage: '订单留言',
    pleaseEnterOrderMessage: '请输入订单留言',
    directCancelSuccessComment: '订单取消成功',
  },
  componentsEditcontactinfo: {
    modifyAContact: '修改联系人',
    pleaseEnterThe11DigitPhoneNumber: '请输入11位手机号',
  },
  componentsEditorder: {
    modifyTheOrder2: '修改订单',
    selectDate1: '选择日期1',
    selectDate2: '选择日期2',
    contactNumber4: '联系人电话',
    theRetentionTimeMustNotBeLessThanTheCurrentTime: '保留时间不得小于当前时间',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime: '保留时间不得小于预抵时间',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime: '保留时间不得大于预离时间',
    doNotRepeatThisOperationWhileSubmittingChanges: '正在提交修改请不要重复操作',
    orderModificationSuccessful: '订单修改成功',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: '新增间数不能大于可订数',
    arrivalBeforeToday: '新增房单入住日期不能早于当前日期',
    assignedRoom: '已排房 {room}',
    availabilityLoading: '正在加载当前房型可订数，请稍后再试',
    availableCount: '可订数：{count}',
    checkedInRoom: '已入住 {room}',
    checkedOutRoom: '已退房 {room}',
    chooseArrivalTime: '选择入住时间',
    chooseDepartureTime: '选择离店时间',
    detailLoadFailed: '新版修改订单数据加载失败',
    detailLoadRetry: '新版修改订单数据加载失败，请重试',
    discountLabel: '门市价{discount}%优惠',
    invalidStay: '请选择正确的入住时间和离店时间',
    keepOneRoom: '修改后订单至少保留一个有效房单',
    latestPriceFailed: '最新房价加载失败，请调整抵离时间后重试',
    latestPriceLoading: '正在加载最新房价，请稍后提交',
    longStayAtLeastTenDays: '长包房的抵离时间间隔至少为10天',
    longStayAtMostOneYear: '长包房的抵离时间间隔至多为一年',
    longStayNoMorning: '长包房不允许凌晨房',
    markedCancelled: '已标记取消',
    newRoomOrder: '新增房单',
    newRoomPriceLoading: '正在加载新增房单住期和房价，请稍后提交',
    noReducibleRoom: '当前房型没有可减少的临时房单或待入住房单',
    otherStatus: '其他状态',
    phonePlaceholder: '请输入手机号',
    productPriceFailed: '门店产品和房价加载失败，请重试',
    roomNumberValue: '房间号 {room}',
    roomOrderDetails: '明细',
    roomTypeInfo: '房型信息',
    roomTypeNoProduct: '当前房型没有可用门店产品',
    stayChangedClearRoom: '住期已变更，原排房已清空，请重新排房',
    stayPriceRefreshFailed: '抵离时间变更后的房价加载失败，请重试',
    stayProductPriceFailed: '所选住期的门店产品和房价加载失败，请重试',
    stayProductUnavailable: '当前房型在所选住期没有可用门店产品',
    storeProductMissing: '未查询到门店产品',
    temporaryRoomOrder: '临时房单',
    unassignedSummary: '待排房 {count} 间',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder: '修改协议单位信息会重新计算订单中所有房间的房价',
    modifyRoomList: '修改房单',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: '修改房价',
    theCurrentPriceCalendarCannotBeModified: '当前价格日历不可修改',
    updatePriceCalendarSuccessfully: '更新价格日历成功',
  },
  componentsLevelup: {
    payTheBill: '付费',
    partUpgrade: '份 升级',
    confirmTheUpgrade: '确认升级',
    currentRoomType: '当前房型',
    reselection: '重选',
    chargeOrNot: '是否收费',
    currentTotalHousePrice: '当前总房价',
    totalRateAfterUpgrade: '升级后总房价',
    priceDifference: '差价',
    upgradeCause: '升级原因',
    enterAMaximumOf150Words: '最多输入150字',
    pleaseChooseWhetherToCharge: '请选择是否收费',
    pleaseEnterTheUpgradeReason: '请填写升级原因',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0: '付费情况下 差价不能小于等于0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference: '提示：夜审后至06:00间升级房型，请手工处理房型差价',
  },
  componentsSeeroomprice: {
    viewRoomRates: '查看房价',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate: '当前房型已售完，请选择其他日期',
    existingRoomSingleChargeCheckOut: '现房单挂账退房',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill: '现房单账务转至新房单后退房',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms: '提示：当前房间为联房单，续住后需手工将新房单加入联房',
    nonStoreSingleCanNotSustain: '非门店单不支持续住',
    youCannotRenewYourStayUntilTheCheckOutDate: '未到离店日期,不可办理续住',
    extendStayadvance: '续住/提前',
    originalOrder2: '原订单',
    continuationPrice: '续住价格',
    changeTheCheckOutTime: '变更离店时间',
    selectDateTime: '选择日期时间',
    continuationPriceRule: '续住价格规则',
    swapOrder: '换订单',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation: '预订人姓名、手机号',
    subscriber: '预订人',
    roomAccountProcessing: '房账处理',
    pleaseSelectTheRenewalPriceRule: '请选择续住价格规则',
    checkOutTimeCannotBeLessThanTheCurrentTime: '离店时间不能小于当前时间',
    theRenewalOfStayIsSuccessful: '办理续住成功',
    pleaseSelectANewOrder: '请选择新订单',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder: '换单续住不支持飞猪信用住订单',
    extendStayadvanceSuccess: '续住/提前离店成功',
    roomNumber: '房号',
    checkInPerson: '入住人',
    checkOutTime: '离店时间',
    makeCard: '制卡',
    booked: '入账',
    close: '关闭',

  },
  componentsTools: {
    pendingClosing: '待申请结账',
    closingSuccessful: '申请结账成功',
    failedToApplyForClosing: '申请结账失败',
    firstNightRate: '首晚房价',
    lateNightRate: '末晚房价',
    maximumHousePrice: '最高房价',
    minimumRoomRate: '最低房价',
  },
  ebkorderIndex: {
    priceDescription: '价格说明',
    merchantPromotionTotalAmountBorneByTheMerchant: '商家促销=商家承担的金额合计',
    totalSellingPriceTotalOrderAmountMerchantPromotion: '卖价总额=订单总额-商家促销',
    totalCommissionTotalSellingPriceCommissionRate: '佣金总额=卖价总额*佣金率',
    totalBasePriceTotalSellingPriceTotalCommission: '底价总额=卖价总额-佣金总额',
    userPaymentAmountActuallyPaidByTheUser: '用户支付=用户实际支付的金额',
    totalOrder: '订单总额',
    totalSellingPrice: '卖价总额',
    userPayment: '用户支付',
    totalCommission: '佣金总额',
    totalFloorPrice: '底价总额',
    merchantPromotion: '商家促销',
    viewOrder: '查看订单',
    orderTransferMethod: '搬单方式',
    removalOfOrder: '搬单',
    contactAndMobilePhoneNumber: '联系人、手机号',
    channelOrderStatus: '订单状态',
    orderStatus: '搬单状态',
    channelOrderNumber: '渠道订单号',
    channelType: '渠道房型',
    expectedArrivalexpectedDeparture: '预抵/预离',
    bookingType: '预订类型',
    estimatedTimeOfArrival: '预计到店时间',
    orderCreationTime: '订单创建时间',
    inBooking: '预订中',
    bookingFailed: '预订失败',
    bookingException: '预订异常',
    initialRejection: '初次拒绝',
    canceling: '取消中',
    otherStates: '其他状态',
    movedOrder: '已搬单',
    unmovedOrder: '未搬单',
    createTimeDesc: '创建时间降序',
    createTimeAsc: '创建时间升序',
    arriveTimeDesc: '到店时间降序',
    arriveTimeAsc: '到店时间升序',
    ebkOrderCheckMsg: '暂无数据，点击补录',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: '您还未绑定美团账户',
    pleaseSetItInmoresystemSettingsebAccountAuthorization: '请在【更多】-【系统设置】-【EB账号授权】中设置',
    clickToGo: '点击前往',
  },
  invoiceInvoiceDetail: {
    personage: '个人',
    firm: '企业',
    headerType: '抬头类型',
    invoiceAmount2: '发票金额',
    pleaseEnterTheInvoiceAmount: '请输入发票金额',
    pleaseEnterTheInvoiceNumber2: '请输入发票号',
    invoiceGroup: '开票组单',
    selectRoomList: '选择房单',
    orderAmount: '订单金额',
    pleaseEnterTheInvoiceTitleToSearch: '请输入发票抬头进行搜索',
    pleaseEnterYourTaxIdentificationNumber: '请输入纳税识别号',
    unitAddress: '单位地址',
    pleaseEnterTheAddressOfTheUnit: '请输入单位地址',
    telephoneNumber: '电话号码',
    bankOfDeposit2: '开户银行',
    pleaseEnterYourBank: '请输入开户银行',
    bankAccount: '银行账户',
    pleaseEnterYourBankAccount: '请输入银行账户',
    pleaseEnterYourEmailAddress: '请输入电子邮箱',
    invoiceMailingAddress: '发票邮寄地址',
    pleaseEnterTheInvoiceMailingAddress: '请输入发票邮寄地址',
    billingNote: '开票备注',
    pleaseEnterYourBillingRemarks: '请输入开票备注',
    pleaseSelectTheBillingType5: '请选择开票类型',
    pleaseSelectAHeaderType: '请选择抬头类型',
    fillInAtLeastOneEMailAndMailingAddress: '电子邮箱和邮寄地址至少填写一个',
  },
  invoiceInvoiceList: {
    toBeInvoiced: '待开票',
    pleaseEnterYourTaxIdentificationNumber: '请输入纳税识别号',
    pleaseEnterTheInvoiceNumber2: '请输入发票号',
    newInvoice: '新增发票',
    invoiceType: '发票类型',
    invoiceAmount: '开票金额',
    billingTime: '开票时间',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: '房单发票列表',
    namePhoneNumberRoomNumber: '入住人姓名，手机号，房间号',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: '房单发票列表',
    accumulatedInvoiceAmount: '累计发票金额',
    toBeInvoiced: '待开票',
    newInvoice: '新增发票',
    invoiceType: '发票类型',
    invoiceAmount: '开票金额',
    billingTime: '开票时间',
  },
  orderListBaseinfo: {
    getThePhoneNumber: '获取手机号',
    preSaleVoucherNumber: '预售券单号',
    contractNumber: '合同编号',
    invoice: '发票',
    promotionalActivity: '促销活动',
    estimatedSettlementAmount: '预估结算金额',
    pack: '礼包',
    selfServiceReservation: '自助机预订',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2: '该订单由销售渠道向客人提供发票',
    thisOrderIsInvoicedByYourHotelToTheGuest: '该订单由您的酒店向客人提供发票',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill: '该金额仅供参考，具体结算金额请以账单为准',
    systemRemark: '系统备注',
    sellerRemark: '商家备注',
  },
  orderListCheckIn: {
    handleSuccessfully: '办理成功',
    viewCheckInInformation: '查看入住信息',
    handleAgain: '重新办理',
    handlingFailure: '办理失败',
    theNameCannotBeBlank2: '姓名不能为空',
    theIdTypeCannotBeEmpty: '证件类型不能为空',
    theIdNumberCannotBeEmpty: '证件号码不能为空',
    pleaseArrangeTheRoomFirst: '请先排房',
    checkInData: '入住登记单数据',
  },
  orderListDetail: {
    checkInStatus: '入住情况',
    total: '共',
    chargedToAccount: '已挂账',
    natureTraffic: '自然流量',
    natureOrderTip: '该订单为轻住直销预订渠道带来的订单',
    preCheckInForm: '预入住单',
    continuationOrder: '续住订单',
    liveOnCredit: '信用住',
    preSaleVoucherReservationForm: '预售券预约单',
    meituanEbOrder: '美团EB单',
    ctripEbOrder: '携程EB单',
    flash: '闪住',
    fullGuarantee: '全额担保',
    roomListInformation: '房单信息',
    automaticRowHouse: '自动排房',
    bulkCheckIn: '批量入住',
    unterracedHouse: '未排房',
    upgrades: '升级',
    prefabricatedKeyCard: '预制门卡',
    modifyTheOrder2: '修改订单',
    cancelAnOrder2: '取消订单',
    rejectAnOrder: '拒单',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard: '请先排房后再预制门卡',
    theListingHasBeenCancelled: '该房单已被取消',
    noRoomingAllowedAfterThePreDepartureTime: '超过预离时间不允许排房',
    allListingsAreAlreadyFurnished: '所有房单均已排房',
    theAutomaticPlatoonSucceeded: '自动排房成功',
    someRowhousesAreSuccessful: '部分排房成功',
    smartCheckInBusinessHasNotOpenedTheFunction: '智慧入住商家暂未开通该功能',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal: '该订单为续住订单，办理入住可能影响原房间续住',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom: '该订单为续住订单，继续办理可能影响原房间续住',
    exceedDepartureDate: '已超过预离日期，不允许升级房型',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom: '当前时间已超过离店时间，不支持升级改房间',
    cancelingTheCurrentRowSucceededProcedure: '取消当前排房成功',
    orderAcceptedSuccessfully: '接单成功',
    successfulRejection: '拒单成功',
    thisActionWillCancelTheListingWhetherToContinue: '此操作将取消房单, 是否继续',
  },
  orderListGiftinfodetail: {
    packageName: '礼包名称',
    packageValue: '礼包价值',
    wayOfGiving: '赠送方式',
    dateOfPresentation2: '赠送日期',
    packageDetails: '礼包详情',
    oneDeliveryPerRoom: '每间房送一次',
    complimentaryOnceADayPerRoom: '每间房每日赠送一次',
  },
  orderListOrderDetail: {
    orderDetails: '订单详情',
    finance3: '财务',
    preAuthorizationDetail: '预授权明细',
  },
  orderListOrderList: {
    durationOfResidence: '在住时间',
    bookingTime: '预订时间',
    preCheckInForm: '预入住单',
    housePig: '房小猪',
    presaleTicket: '预售券',
    multipleSearch: '综合查询',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery: '姓名、手机号、订单号、渠道单号查询',
    selfServiceReservation: '自助机预订',
    rejectAnOrder: '拒单',
    individualTraveler: '散客',
    team2: '团队',
    estimate: '预抵',
    firstDayPrice: '首日价',
    areYouSureYouWantToTakeTheOrder: '您确定要接单吗',
    orderAcceptedSuccessfully: '接单成功',
    booked: '已预订',
    refused: '已拒绝',
    extendStayCheckInImpact: '该订单为续住订单，办理入住可能影响原房间续住',
    exceededDepartureCannotUpgrade: '已超过预离日期6点，不允许升级房型',
    exceededCheckoutCannotUpgrade: '当前时间已超过离店时间，不支持升级改房间',
    exceededDepartureCannotArrangeRoom: '超过预离时间不允许排房',
    preArrivalNotArrived: '预抵未到',
    noshow: '预抵未到',
  },
  orderListNoShow: {
    title: 'NoShow',
    noshowReason: 'NoShow原因',
    remarkPlaceholder: '备注（5-100文字）',
    remarkMinLength: '回复文字最少5个字',
    pleaseSelectNoshowReason: '请选择NoShow原因',
  },
  orderListPricedetail: {
    channelCost: '渠道原价',
    eventDiscount: '活动优惠',
    guestActivityDiscount: '客人活动优惠',
    memberDiscount: '会员折扣',
    guestMembershipDiscount: '客人会员折扣',
    sameTripExclusiveOffer: '同程专享优惠',
    guestTongchengExclusiveDiscount: '客人同程专享优惠',
    guestPurchasePrice: '客人购买价格',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests: '活动优惠、酒店卖价说明：该渠道客人与结算账单会存在差异，可点击“价格提示”查看客人实际金额',
    priceDetails: '价格详情',
    memberBenefits: '会员优惠',
    jointMemberBenefits: '联合会员优惠',
  },
  orderListPromotiondetail: {
    eventDetails2: '活动详情',
    preferentialRules: '优惠规则',
  },
  orderListPromotiondetailnew: {
    eventDetails2: '活动详情',
    dateCondition: '日期条件',
    bookingConditions: '预订条件',
    preferentialRules: '优惠规则',
    participationDate: '参与日期',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: '您确认要拒绝此订单吗',
    confirmationRejection: '确认拒单',
    successfulRejection: '拒单成功',
    theOrderWillBeClosedAtTheSameTime: '拒单后同时会关闭',
    overbookingSetup: '超售设置',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage: '使用微信扫一扫前台“入住二维码”，打开订单查询页',
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm: '填写预订人姓名、手机号、入住日期查询预订单',
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation: '选择需要办理入住的预订单，并选择要增加入住人的房间填写信息',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests: '此时，您可以在预订单详情中，查看到该房间预警填写入住人完毕，点击“入住”按钮为客人办理入住',
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully: '此时，您可以在房单详情中看到该入住人已经添加成功',
    off: '关 闭',
    theUserHasCompletedTheProcedure: '用户已办理完成',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay: '请引导宾客按照如下方式“办理入住”',
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification: '宾客填写并提交后，页面显示“请携带证件前往前台核验”',
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows: '请引导宾客按照如下方式“增加入住人”',
  },
  groupOrderAddroomer: {
    validityPeriod: '有效期限',
    addmodifyCheckInGuests: '添加/修改入住人',
    pleaseEnterAddress: '请输入住址',
    startDate: '起始日期',
    currentSubscript: '当前下标',
  },
  groupOrderIndex: {
    bulkCheckIn: '批量入住',
    automaticRowHouse: '自动排房',
    checkInAddition: '添加入住人',
    pleaseSelectTheRoomYouWantToCheckIn: '请选择要办理入住的房间',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn: '您选择的有空脏的房间，是否确认办理入住',
    checkInSuccessful: '办理入住成功',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber: '房间已停用，请更换其他房间号',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber: '房间为在住状态，请更换其他房间号',
    pleaseArrangeTheRoomBeforeChoosing: '请排房后再选择',
    allListingsAreAlreadyFurnished: '所有房单均已排房',
    theAutomaticPlatoonSucceeded: '自动排房成功',
    pleaseListTheRoomFirstAndThenAddTheGuest: '请您先排房后再添加入住人',
    succeededInCancelingTheRowHouse: '取消排房成功',
  },
  presalecouponsPredetail: {
    ticketName: '预售券名称',
    presaleTicket: '预售券',
    saleOrderNumber: '售卖单号',
    purchaseTime: '购买时间',
    advanceOrder: '预约订单',
    availableProduct: '可用产品',
    commodityContent: '商品内容',
    ruleInformation: '规则信息',
    availableTime: '可预约时间',
    checkInTime2: '可入住时间',
    markUpRule: '加价规则',
    cancellationRules: '取消预约规则',
    paymentInformation: '支付信息',
    crossedPrice: '划线价',
    chineseFood: '中餐',
    dinner2: '晚餐',
    bookedBedtotalBedHours: '已预约间夜/总间夜(小时)',
    raiseAPrice: '加价',
    meituanDirectNew: '美团直连(新)',
    officialWebsiteDirect: '官网直营',
    ctripSingleStore: '携程单店',
    agoda: 'Agoda',
    meituanHomestay: '美团民宿',
    tujiaHomestay: '途家民宿',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: '支付日期',
    productId: '商品ID',
    sellOrderNumber: '售卖订单号',
    noAppointment: '未预约',
    completeWriteOff: '全部核销',
    completeReverseWriteOff: '全部反核销',
    refunded: '已退款',
    orderNumber2: '订单编号',
    timeOfPayment: '支付时间',
    bookedBedtotalBedHours: '已预约间夜/总间夜(小时)',
  },
  hardwareParking: {
    parkingLotManagement: '停车场管理',
    parkingLotDescription: '支持自动识别车牌号，自动入场出场',
    settings: '设置',
    parkingLotConfig: '停车场配置',
    currentDevice: '当前设备',
    unboundDeviceTip: '当前酒店未绑定停车场设备',
    sidPlaceholder: '请输入 SID',
    secretKeyPlaceholder: '请输入 SecretKey',
    enableStatus: '启用状态',
    hotelNotBoundWarning: '当前酒店未绑定停车场设备',
    enterSidAndSecretKey: '请输入 SID 和 SecretKey',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    configFailed: '配置失败',
    parkingDeviceEnabled: '停车场设备已开启',
    parkingDeviceDisabled: '停车场设备已关闭',
    fetchHardwareRelationFailed: '获取硬件绑定关系失败',
    fetchConfigFailed: '获取停车场配置失败',
  },
  roomOrderListVehicleDialog: {
    title: '车牌号',
    platePlaceholder: '请输入车牌号',
    add: '添加',
    plateNo: '车牌号',
    enterPlateWarning: '请输入车牌号',
    enterPlateFormatWarning: '车牌格式不正确',
    addSuccess: '添加成功',
    deleteConfirm: '确认删除该车牌号吗？',
    deleteSuccess: '删除成功',
  },
  roomOrderListDetail: {
    vehiclePlateNo: '车牌号',
    saveFailed: '保存失败',
    cancelStay: '取消续住',
    enterRemarkContent: '请输入备注内容',
    systemRemark: '系统备注',
    merchantRemark: '商家备注',
    originalStayOrder: '续住原单',
    newStayOrder: '续住新单',
    continued: '续',
    downloadIdPhoto: '下载证件照',
    uploadedToPolice: '已上传公安系统',
    reuploadToPolice: '重新上传公安系统',
    cancelStaySuccess: '取消续住成功',
    enterNumber: '请输入数量',
    liveOnCredit: '信用住',
    duration: '时长',
    invoice: '发票',
    roomInformation2: '客房信息',
    numberOfGuests: '入住人数',
    doorLockCode: '门锁密码',
    generatePassword: '生成密码',
    resetPassword: '重置密码',
    passwordInvalidation: '密码置失效',
    idNumber2: '证件号',
    guestAddress: '客人地址',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2: '该订单由销售渠道向客人提供发票',
    thisOrderIsInvoicedByYourHotelToTheGuest: '该订单由您的酒店向客人提供发票',
    originalOrder2: '原订单',
    swapOrder: '换订单',
    faceCollection: '人脸采集',
    invoice2: '开发票',
    sendPassword: '发送密码',
    upgradeTheRoom: '升级房间',
    extendStayadvance: '续住/提前',
    transferToFullDayRoom: '转全日房',
    decamping: '减少同住',
    increaseCohabitation: '增加同住',
    checkInSlip4: '入住登记单',
    reinstatement: '恢复入住',
    renewalOrder2: '续住单',
    roomChangeConfirmationForm3: '换房确认单',
    conferenceCorps: '会议团',
    tourParty: '旅行团',
    confirmNeedToResumeCheckIn: '确定需要恢复入住',
    operationReminder: '操作提醒',
    reinstatedCheckInSuccessful: '恢复入住成功',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders: '线上订单不支持转全日房',
    whetherToCancelTheRowRoomAndTransferToTheFullDay: '是否取消排房并转全日',
    areYouSureYouWantToChangeToAFullDayRoom: '确认要转全日房吗',
    checkOutTimeWillBeChangedTo2: '转全日房后离店时间将调整为',
    theRoomIsIn: '房间在',
    existingRowHouse: '已有排房',
    conversionToFullDayRoomSuccessful: '转为全日房成功',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2: '飞猪信用住订单不支持联房',
    generatePassword2: '生成密码中',
    passwordGeneratedSuccessfully: '生成密码成功',
    areYouSureYouWantToResetYourCurrentPassword: '确认要重置当前密码吗',
    resetPassword2: '重置密码中',
    resetPasswordSuccessfully: '重置密码成功',
    areYouSureYouWantToInvalidateYourCurrentPassword: '确认要将当前密码置失效吗',
    thePasswordIsInvalid: '密码置失效中',
    thePasswordIsInvalidProcedure: '密码置失效成功',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2: '当前时间已超过离店时间，不支持更换房间',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2: '当前时间已超过离店时间，不支持升级房间',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2: '当前时间已超过离店日期六点，不支持升级房间',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder: '客人已申请在线续住，继续办理可能无法进行换单续住办理',
    flyingPigCreditOrdersCanNotBeSustained2: '飞猪信用住订单无法支持续住',
    itHasPassedTheCheckOutDateAndCannotBeExtended2: '已超过离店日期，无法续住',
    successfulRoomExchange2: '换房成功',
    upgradedRoomTypeData: '升级的房型数据',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified: '订单中的其他房间已退房，无法进行“客源类型”修改',
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms: '客人已申请在线续住，确认需要继续更换房间?',
  },
  roomOrderListGroupRoomDetail: {
    contactNumber4: '联系人电话',
    aTotalOf: '共',
    occupancyStatus: '入住情况',
    onAccount2: '已挂帐',
    rollOut: '转出',
    setAsMaster: '设为主单',
    rescission: '解除联房',
    teamRegistrationSheet: '团队登记单',
    numberOfRooms: '房间数量',
    confirmToCancelTheHouseRelationship: '确认解除联房关系',
    successfullyDisconnectingTheHouse: '解除联房成功',
    rollOutSuccess: '转出成功',
    setTheMasterOrderToSucceed: '设为主单成功',
  },
  roomOrderListMinusroomer: {
    residentGuest: '在住客人',
    reduceRoommateSuccess: '减少同住人成功',
    decamping: '减少同住',
    pleaseSelectTheNumberOfPeopleYouWantToReduce: '请选择要减少的入住人',
    keepAtLeastOneOccupantInTheRoom: '房间中至少保留一个入住人',
  },
  roomOrderListRelativeRoom: {
    roomOrder: '房单',
    reservationOrder: '预订单',
    pendingCheckIn: '待入住',
    pleaseSelectARoomOrder: '请选择房单',
    linkRoomNumber: '联房号',
    inTheRoom: '在住房间',
    residentialTeam: '在住团队',
    flyingPigCreditDoesNotSupportHousing: '飞猪信用住不支持联房',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels: '直连渠道不支持与门店渠道建立联房及团队',
    guestsNameMobilePhoneNumberAndRoomNumber: '入住人姓名、手机号、房号',
    teamNameBookingPersonNameMobilePhoneNumber: '团队名称、预订人姓名、手机号',
    pleaseSelectATeam: '请选择团队',
    joinTheTeamSuccessfully: '加入团队成功',
    joinTheRoomSuccessfully: '加入房间成功',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: '飞猪信用住不支持联房',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels: '直连渠道不支持与门店渠道建立联房及团队',
    transferIn: '转入联房',
    namePhoneNumberRoomNumber2: '入住人姓名，手机号，房号',
    succeededInJoiningTheHouse: '加入联房成功',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: '联房',
    roomList: '房单列表',
    noRoomListingInformationAvailable: '暂无房单信息',
    manage: '管理',
    fullState: '全部状态',
    finance3: '财务',
    preAuthorizationDetail: '预授权明细',
    houseDetails: '联房详情',
    listingDetails: '房单详情',
    thereAreNoOccupants: '暂无入住人',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: '在住时间',
    bookingTime: '预订时间',
    room2: '房',
    doNotGift: '不赠送',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery: '姓名、手机号、订单号、渠道单号查询',
    multipleSearch: '综合查询',
    bonusPoints: '赠送积分',
    subscriber: '预订人',
    subscriberNumber: '预订人电话',
    areYouSureYouWantToGiveAwayPoints: '确定要赠送积分吗',
    rewardPointsSuccessfully: '积分赠送成功',
    guestphone: '入住人/电话',
    actualCheckoutTime: '实际离店时间',
  },
  faceFacedialog: {
    faceCollection: '人脸采集',
    faceCollectionSuccess: '人脸采集成功',
    faceCollectionFailure: '人脸采集失败',
    takeAPicture: '拍照',
    upload: '上传',
    upCross: '上传中',
    uploadingPhotosPleaseCloseLater: '正在上传照片，请稍后关闭',
    pleaseTakeAPictureFirst: '请先拍照',
    collectionSuccess: '采集成功',
    collectionFailedPleaseTryAgain: '采集失败，请重试!',
  },
  printtemplateChangeroom: {
    theOriginal: '原',
    changeDate: '换房日期',
    roomRateUpgrade: '房价升级:',
    roomRate: '房价:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: '换房日期',
    checkOutTime: '退房时间',
    theOriginal: '原',
  },
  printtemplateGroupordertableprint: {
    position: '站位',
  },
  printtemplateStayinprint: {
    confidentiality: '保密',
  },
  printtemplateStaymore: {
    departureDate: '预离日期',
    newDepartureDate: '新预离日期',
  },
  printtemplateStaymoreprint: {
    departureDate: '预离日期',
    newDepartureDate: '新预离日期',
  },
  noticeOrdernotice: {
    messageCenter: '消息中心',
    orderInformation: '订单信息',
    dynamic: '动态消息',
    settlement: '结算消息',
    system: '系统消息',
    noData: '暂无新消息',
    dynamicInformation: '动态信息',
    systemInformation: '系统信息',
    nightTrialFailTitle: '夜审失败',
    nightTrialFailContent: '夜审失败，请及时处理。',
  },
  noticeServicemanage: {
    serviceManagement: '服务工单管理',
    roomService: '客房服务',
    itemBorrow: '物品借用',
    extendStay: '续住服务',
  },
  operatelogLog: {
    nightAuditLog: '夜审日志',
    downloadLog: '下载日志',
    downloadSuccessfully: '下载成功',
  },
  operatelogNightauditlog: {
    nightTrialMethod: '夜审方式',
    nightTrialResult: '夜审结果',
    manualNightAudit: '手动夜审',
    automaticNightAudit: '自动夜审',
    nightAuditFailure: '夜审失败',
    successfulNightAudit: '夜审成功',
    nightTrialDate: '夜审日期',
    nightAuditRecord: '夜审记录',
  },
  operatelogWorkingday: {
    variableMode: '变动方式',
  },
  financeAccountsreceivableaging: {
    bookName: '帐套名称',
    totalAmountReceivable: '应收账总额',
    amountPayable030Days: '应收账金额（0-30天）',
    amountPayable3160Days: '应收账金额（31-60天）',
    amountPayable6190Days: '应收账金额（61-90天）',
    amountToBeCollected91DaysOrMore: '应收账金额（91天以上）',
    typeOfExchange: '换房类型',
    originalRoomNumber: '原房号',
    existingRoomNumber: '现房号',
    currentHouseType: '现房型',
    roomChangeTime: '换房时间',
    changeRoomsAfterCheckIn: '入住后换房',
    originalRoomRate: '原房价',
    spotRate: '现房价',
  },
  financeAdjustmentCash: {
    financialStatement: '财务流水',
    occurrenceTime: '发生时间',
    reconciliationStatement: '调账报表',
  },
  financeAr: {
    channelReconciliationReport: '渠道对账报表',
    writeOffStatus: '核销状态',
    amountOnCredit: '挂帐金额',
    estimatedSettlementPrice: '预估结算价',
    unapprovedAmount: '未核金额',
    guestInvoiceRequirement: '客人发票要求',
    roomNumbername: '房号/姓名',
  },
  financeBreakfastStatistic: {
    flatBreakfast: '房包早',
    advancePurchase: '购早',
    availableBreakfasts: '可用早餐数',
    verifiedBreakfasts: '已核销早餐数',
    breakfastAmount: '早餐金额',
    breakfastStatisticsReport: '早餐统计报表',
    breakfastStatisticsReportxls: '早餐统计报表.xls',
  },
  financeChannelConsume: {
    typeOfCompany: '公司类型',
    roomNights: '间夜数',
  },
  financeCheckout: {
    checkOutBusinessDay: '离店营业日',
    helpOneself: '自用',
    team2: '团队',
    checkOutStatement: '结账退房报表',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: '比例',
    aged180DaysOrMore: '账龄180天以上',
    agingStatementOfCreditCompany: '信用公司账龄报表',
    accountAge030Days: '账龄0~30天',
    accountAge3160Days: '账龄31~60天',
    accountAge6190Days: '账龄61~90天',
    accountAge91180Days: '账龄91~180天',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: '预收房费',
    estimatedArrears: '预计欠款',
    collectionStatement: '催账报表',
  },
  financeHangAccount: {
    accountStatus: '账务状态',
    businessDayOfHangingAccount: '挂账营业日',
    hangTheAccountOperator: '挂账操作人',
    currentBalance: '当前余额',
    closingTime: '结账时间',
    noteOfHangingAccount: '挂账备注',
    temporaryDebitStatement: '临时挂账报表',
    membercompany: '会员/公司',
  },
  financeInventoryInOut: {
    inOutDate: '出入库日期',
    storageType: '出入库方式',
    storageTypeOut: '出库',
    fileName: '出入库报表',
    columns: {
      inStoragePrice: '入库金额',
      outStoragePrice: '出库金额',
    },
  },
  financeHousekeeping: {
    cleaningDate: '打扫日期',
    cleanType: '打扫类型',
    cleaner: '保洁员',
    status: '工单状态',
    dailyCleaningAndLinen: '日常清扫+更换床品',
    dailyCleaning: '日常清扫',
    dispatchTime: '派单时间',
    cleanTime: '打扫时间',
    checkRoomTime: '查房时间',
    recleaningReason: '重新打扫原因',
    checkerName: '查房主管',
    statuses: {
      toBeCleared: '待清扫',
      finishCleaning: '完成清扫',
      noCleaning: '无需清扫',
      cancelOrder: '取消派单',
      unauditedRoom: '待查房',
      wardRoundRejection: '查房驳回',
    },
  },
  settingHousekeeping: {
    cleaners: '保洁员',
    selectCleaners: '请选择保洁员',
    onDutyConfig: '保洁员在岗时间配置',
    roomAssign: '房间分配',
    assignMode: {
      free: '自由分配',
      byFloor: '按楼层分配',
      byRoom: '按房间分配',
    },
    viewAssign: '查看分配',
    cleanerPrefix: '保洁:',
    autoDispatchConfig: '客房打扫自动派单配置',
    autoDispatch: {
      off: '关闭自动派单',
      on: '开启自动派单',
    },
    autoDispatchRoomType: '自动派单房间类型',
    leaveRoom: '离店房',
    stayRoom: '在住房',
    dispatchRule: '保洁分配规则',
    rules: {
      byTotal: '每人处理工单总数平均分配',
      byPending: '每人待处理工单平均分配',
    },
    leaveCleanType: '离店房自动派单打扫类型',
    stayCleanType: '在住房自动派单打扫类型',
    dispatchTimeForStay: '在住房派单时间',
    afterCleanCheck: '客房打扫后是否需要查房',
    needCheck: {
      no: '不需要',
      yes: '需要',
    },
    dialog: {
      assignRelation: '分配关系',
      selectFloor: '请选择楼层',
    },
    messages: {
      selectCleaners: '请选择保洁人员',
      dutyTimeInvalid: '保洁员在岗时间配置结束时间不能小于开始时间',
    },
  },
  financeBreakfastDetails: {
    mealDate: '用餐日期',
    includeWaitingForCheckIn: '是否统计待入住房',
    title: '早餐明细报表',
    columns: {
      guestNum: '人数',
      roomContainsBreakfastNum: '房包含早',
      buyBreakfastNum: '购早',
      useBreakfastNum: '核销数',
    },
  },
  breakfastVerification: {
    checkedInRoomList: '在住房间列表',
    roomNo: '房号',
    breakfastCount: '早餐数',
    verified: '已核销',
    buyBreakfast: '购早',
    verificationRecord: '核销记录',
    verificationTime: '核销时间',
    cardReading: '读卡中',
    swipeCardVerification: '刷卡核销',
    breakfastVerification: '早餐核销',
    pendingBreakfast: '待核销早餐',
    verificationCount: '核销数量',
    confirmVerification: '确认核销',
    noRoomRead: '未读取到房间信息',
    cardReadFailed: '读卡失败，请检查房卡或读卡器',
    noPendingBreakfast: '该房间暂无待核销早餐',
    verificationCountPositive: '核销数量必须大于0',
    verificationCountExceedsPending: '核销数量不能大于待核销早餐数量',
    verificationSuccess: '核销成功',
  },
  buyBreakfastDialog: {
    title: '购早',
    entryAccount: '入账账号',
    count: '份数',
    totalAmount: '总金额',
    payVerificationCode: '支付验证码',
    positiveMoney: '请输入大于0的金额，最多两位小数',
    positiveInteger: '请输入大于0的整数',
    priceRequired: '请输入单价',
    countRequired: '请输入份数',
    roomOrderNoMissing: '未获取到房单号，不能购早',
    selectAccountSet: '请选择账套',
    onlinePaymentFailed: '在线收款失败',
    paymentIncomplete: '支付未完成，未生成购早账务',
    buySuccess: '购早成功',
  },
  financeBreakfastVerificateDetail: {
    title: '早餐核销明细报表',
  },
  readDoorCardRoom: {
    lockNotConfigured: '未配置门锁或门锁未启用',
    getLockInfoFailed: '获取门锁信息失败',
    readCardTimeout: '读卡超时，请检查读卡器',
    emptyCard: '此卡为空卡，请先制卡',
    notGuestCard: '该卡不是宾客卡，请重新制卡',
    readCardServiceFailed: '读卡失败，请联系技术支持检查硬件服务是否可用',
    readCardFailed: '读卡失败，请检查房卡或读卡器',
    noRoomInfo: '未读取到房间信息',
    unsupportedLockReadMode: '暂不支持当前门锁读卡方式',
  },
  financePreauth: {
    authorizationStatus: '授权状态',
    authorizationDate: '授权日期',
    settlementDate: '结算日期',
    expirationDate: '有效日期',
    preAuthorizationStatement: '预授权报表',
    settlementTime: '结算时间',
  },
  financeRedeemDetail: {
    dateType: '日期类型',
    writeOffDate: '核销日期',
    dateOfPosting: '挂账日期',
    dateOfEntry2: '入账日期',
    bookType: '账套类型',
    businessDayOfHangingAccount: '挂账营业日',
    hangTheAccountOperator: '挂账操作人',
    theRoomNumberIsCharged: '挂账房间号',
    writeOffTheAmountCredited: '核销入账金额',
    writeOffTheEntryTime: '核销入账时间',
    writeOffTheAccountOperator: '核销入账操作人',
    amountWrittenOff2: '核销金额',
    writeOffTime: '核销时间',
    writeOffTheOperator: '核销操作人',
    channelWriteOffDetailReport: '渠道核销明细报表',
  },
  financeRushCash: {
    financialStatement: '财务流水',
    occurrenceTime: '发生时间',
    debitStatement: '冲账报表',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: '协议单位消费排名表',
  },
  financeTodayGuestBalance: {
    roomFee3: '房费',
    balanceSheetForGuestsInResidence: '在住客人余额表',
  },
  financeTransferCash: {
    turnOutOfRoom: '转出房间',
    bookkeepingTime: '记账时间',
    turnIntoARoom: '转入房间',
    transferTime: '转账时间',
    transferStatement: '转账报表',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: '零房费报表',
  },
  incomeBaseprice: {
    totalRevenue: '总营收',
    roomNight: '总间夜',
    storeRevenue: '门店营收',
    interstoreNight: '门店间夜',
    directRevenuebasePrice: '直连营收（底价）',
    straightInternight: '直连间夜',
    miniProgramRevenuebasePrice: '小程序营收（底价）',
    smallProgramNight: '小程序间夜',
    xinmeituanDirectRevenuebasePrice: '新美团直连营收（底价）',
    newUnitedStatesGroupStraightInternight: '新美团直连间夜',
    ctripDirectRevenuebasePrice: '携程直连营收（底价）',
    ctripDirectConnectionBetweenNight: '携程直连间夜',
    directRevenuebasePrice2: '同程直连营收（底价）',
    theSameJourneyDirectlyConnectedToTheNight: '同程直连间夜',
    qunarDirectRevenuebasePrice: '去哪儿直连营收（底价）',
    whereToGoStraightToTheNight: '去哪儿直连间夜',
    tiktokDirectRevenuebasePrice: '抖音直连营收（底价）',
    tiktokStraightBetweenNight: '抖音直连间夜',
    flyingPigDirectRevenuebasePrice: '飞猪直连营收（底价）',
    flyingPigsStraightInternight: '飞猪直连间夜',
    baiduMapRevenuebasePrice: '百度地图营收（底价）',
    baiduMapNight: '百度地图间夜',
    jingdongDirectRevenuebasePrice: '京东直连营收（底价）',
    jingdongDirectConnectionBetweenNight: '京东直连间夜',
    lightResidentialAndCommercialTravelRevenuebasePrice: '轻住商旅营收（底价）',
    lightStayBusinessNights: '轻住商旅间夜',
    lightHomeDistributionRevenuebasePrice: '轻住分销营收（底价）',
    lightNightInTheDistributionRoom: '轻住分销间夜',
    storeAdr: '门店ADR',
    usGroupEbRevenue: '美团EB营收',
    usGroupEbNight: '美团EB间夜',
    meituanEbadr: '美团EB ADR',
    ctripEbRevenue: '携程EB营收',
    ctripEbNight: '携程EB间夜',
    ctripEbadr: '携程EB ADR',
    flyingPigEbRevenue: '飞猪EB营收',
    flyingPigEbNight: '飞猪EB间夜',
    ebadrTheFlyingPig: '飞猪EB ADR',
    douyinGroupPurchaseEbRevenue: '抖音团购EB营收',
    douyinGroupPurchaseEbNight: '抖音团购EB间夜',
    douyinGroupPurchaseEbadr: '抖音团购EB ADR',
    directAdrbasePrice: '直连ADR（底价）',
    miniProgramAdrbasePrice: '小程序ADR（底价）',
    newMeituanDirectAdrbasePrice: '新美团直连ADR（底价）',
    directRouteAdrbasePrice: '携程直连ADR（底价）',
    sameRouteDirectAdrbasePrice: '同程直连ADR（底价）',
    whereToDirectAdrbasePrice: '去哪儿直连ADR（底价）',
    tiktokDirectAdrbasePrice: '抖音直连ADR（底价）',
    flyingPigDirectAdrbasePrice: '飞猪直连ADR（底价）',
    baiduMapAdrbasePrice: '百度地图ADR（底价）',
    jingdongDirectLinkAdrbasePrice: '京东直连ADR（底价）',
    lightResidentialAndBusinessAdrbasePrice: '轻住商旅ADR（底价）',
    lightLiveDistributionAdrbasePrice: '轻住分销ADR（底价）',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: '消费科目统计报表',
    accountId: '账号ID',
    roomNumbername: '房号/姓名',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: '自用房',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics: '间夜数据是根据查询的营业日统计',
    calculationMode: '计算方式',
    guestCheckInDetailsReport: '客源入住明细报表',
    freeRoom: '免费房',
    teamRoom: '团队房',
    singleRoom: '长包房',
    roomRate2: '房费金额',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: '交班汇总统计报表',
    income: '收入',
    disburse: '支出',
    totalAmount: '合计金额',
    shiftSummaryReport: '交班汇总报表',
  },
  incomeManageSingle: {
    category: '类别',
    today: '本日',
    accumulatedThisMonth: '本月累计',
    lastMonthCumulative: '上月同期累计',
    monthlyGrowthRate: '月增长率',
    currentYearAccumulation: '本年累计',
    accumulatedInTheSamePeriodOfLastYear: '上年同期累计',
    annualGrowthRate: '年增长率',
    operatingStatementsingleDay: '经营报表（单日）',
    operatingStatementOneDayxlsx: '经营报表单日.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights: '订单来源间夜：包含免费房、自用房间夜数',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms: '出租率(扣自用房、免费房) = 出租间夜数(扣自用房、免费房) / 客房总数',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms: '总房费收入(包含佣金)：不含免费房、自用房',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission: '您未开通“客源入住明细”报表查看权限',
    averageRoomRate: '平均房价(扣自用房、免费房) = 总房费收入 / 出租间夜数(扣自用房、免费房)',
    revparFormula: 'RevPAR = 总房费收入 / 客房总数',
    totalRevenueFormula: '营业总收入=总房费收入+所有其它收入(包含佣金,不包含会员充值)',
  },
  incomeManageTotal: {
    generalLedger: '总账',
    totalAverageRoomRateyuan: '总平均房价(元)',
    rentalTotalRoomNightroom: '出租总间夜(间)',
    fullDayRoomNightroom: '全日房间夜(间)',
    longBagRoomNightroom: '长包房间夜(间)',
    hourRoomNightroom: '钟点房间夜(间)',
    teamRoomNightroom: '团队房间夜(间)',
    freeRoomNightroom: '免费房间夜(间)',
    privateRoomNightroom: '自用房间夜(间)',
    totalRoomRateyuan: '总房费(元)',
    smallCommoditiesyuan: '小商品(元)',
    mealFeeyuan: '餐费(元)',
    serviceChargeyuan: '服务费(元)',
    membershipFeermb: '会员费(元)',
    otherExpensesyuan: '其他费用(元)',
    totalRevenue: '营业总收入(元)',
    totalRevenueWithTax: '营业总收入（含税）',
    roomNightsroom: '间夜数(间)',
    averageRoomRateyuan: '平均房价(元)',
    totalRoomRateyuan2: '房费合计(元)',
    operatingStatementcumulative: '经营报表（累计）',
    theQueryTimeRangeCannotBeLongerThanOneYear: '查询时间范围不能大于一年',
    totalOccupancyRate: '总出租率(%)',
    fullDayOccupancyRate: '全日房出租率(%)',
    hourlyOccupancyRate: '钟点房出租率(%)',
    lettingRate: '出租率(%)',
    internightRatio: '间夜占比(%)',
    totalRevpar: '总REVPAR(元)',
    cumulativeOperatingStatementxls: '经营报表累计.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms: '出租率(扣自用房、免费房) = 出租间夜数(扣自用房、免费房) / 客房总数',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms: '总房费收入(包含佣金)：不含免费房、自用房',
    averageRoomRate: '平均房价(扣自用房、免费房) = 总房费收入 / 出租间夜数(扣自用房、免费房)',
    totalRevenueFormula: '营业总收入=总房费收入+所有其它收入(包含佣金,不包含会员充值)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: '昨日余额',
    todaysBalance: '今日余额',
    statisticalStatementOfBusinessIncome: '营业收入统计报表',
    totalconsumptionTotalPaymentTotal: '总计=消费合计-付款合计',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal: '昨日余额=酒店之前营业日累计的消费合计-付款合计',
    todaysBalancetotalyesterdaysBalance: '今日余额=总计+昨日余额',
  },
  incomeBusinessIncomeDetail: {
    reportTitle: '营业收入明细报表',
    consumeTotal: '消费合计',
    settleTotal: '收款合计',
    roomFee: '房费',
    mealFee: '餐费',
    goodsFee: '小商品',
    serviceFee: '服务费',
    memberFee: '会员费',
    otherConsume: '其他消费',
    dailyBalance: '当日余额',
    orderNo: '订单号',
    roomOrderNo: '房单号',
    roomNo: '房号',
    guestName: '姓名',
    noData: '暂无数据',
  },
  incomeOverduty: {
    category: '类别',
    firstLevelSubject: '一级科目',
    description: '描述',
    shiftStatisticsReport: '交班统计报表',
  },
  incomePayExpense: {
    cashPaymentStatement3: '现付账消费明细报表',
    abstract: '摘要',
  },
  incomePayment: {
    paymentAccountStatisticsReport: '付款科目统计报表',
    submitted: '已提交',
    earlyMorningWatch: '凌晨班',
    roomNumberName: '房间号-姓名',
    dateRangeCannotExceedThreeMonths: '查询日期跨度不能超过3个月',
  },
  incomeRoomTypeReport: {
    totalRoomRate: '总房费',
    numberOfOutages: '停用数',
    numberOfNightsForRent: '出租间夜数',
    roomTypeReport: '房型报表',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime: '营业日结束时间不可以超过当前时间',
    theSelectionPeriodCannotBeLongerThan31Days: '选择时间不能大于31天',
  },
  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics: '间夜数据是根据查询的营业日统计',
    calculationMode: '计算',
    salesPerformanceStatement: '销售业绩报表',
    roomFee3: '房费',
  },
  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: '小商品销售明细报表',
  },
  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: '小商品销售汇总报表',
    averageUnitPrice: '平均单价',
  },
  kanbanIndex: {
    yesterday: '昨日',
    last7Days: '近7日',
    lastWeek: '上周',
    last30Days: '近30日',
    lastMonth: '上月',
    managementProfile: '经营概况',
    flowConversion: '流量转化',
    serviceIndicator: '服务指标',
    competitiveCircleAnalysis: '竞争圈分析',
    writeAReport: '撰写报告',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest: '时间维度和筛选的日期一致，预订金额按照客人实际支付金额统计',
    operationPersonnelManagementOverviewSuggestions2: '运营人员经营概况建议',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu: '时间维度与筛选的日期一致，包含美团、携程、飞猪旗下所有平台的数据汇总',
    operationPersonnelFlowConversionSuggestions2: '运营人员流量转化建议',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu: '时间维度为当前选择日期的结束日期与开始日期的前一天，包含美团、携程、飞猪旗下所有平台的数据汇总',
    operationPersonnelServiceIndicatorsSuggestions2: '运营人员服务指标建议',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip: '时间维度与筛选的日期一致，包含美团、携程旗下所有平台的数据汇总',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2: '运营人员竞争圈分析建议',
    amountOfExposure: '曝光量',
    pageView: '浏览量',
    orderQuantity: '下单量',
    myExposureCount: '我的曝光人数',
    numberOfPeopleExposedInThePreviousIssue: '上期曝光人数',
    myExposureConversionRate2: '我的曝光转化率',
    previousExposureConversionRate2: '上期曝光转化率',
    myNumberOfViewers: '我的浏览人数',
    numberOfVisitorsInTheLastIssue: '上期浏览人数',
    myConversionRate2: '我的成交转化率',
    conversionRateOfLastPeriodTransaction2: '上期成交转化率',
    paymentOrderNumber: '支付订单数',
    myPaymentOrderNumber: '我的支付订单数',
    previousPaymentOrderNumber: '上期支付订单数',
  },
  kanbanReportManage: {
    reportTitle: '报告标题',
    reportWriter: '报告撰写人',
    reportDate: '报告日期',
    reportNumber: '报告编号',
    draft: '草稿',
    haveReleased: '已发布',
    reportTime: '报告时间',
    exportDaily: '导出日报',
  },
  kanbanSeeKanban: {
    dataBoard: '数据看板',
    managementProfile: '经营概况',
    operationPersonnelManagementOverviewSuggestions2: '运营人员经营概况建议',
    flowConversion: '流量转化',
    operationPersonnelFlowConversionSuggestions2: '运营人员流量转化建议',
    serviceIndicator: '服务指标',
    operationPersonnelServiceIndicatorsSuggestions2: '运营人员服务指标建议',
    competitiveCircleAnalysis: '竞争圈分析',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2: '运营人员竞争圈分析建议',
    theProportionOfSalesAmount: '销售金额占比',
    salesRoomNightProportion: '销售间夜占比',
    noProposal: '暂无建议',
  },
  componentsDataReport: {
    compose: '撰写',
    dataReport: '数据报告',
    reportType: '报告类型',
    pleaseSelectAReportType: '请选择报告类型',
    dailyOperationReport: '运营日报',
    weeklyOperationsReport: '运营周报',
    monthlyOperatingReport: '运营月报',
    runCustomReports: '运营自定义报告',
    reportTitle: '报告标题',
    analysisDate: '分析日期',
    businessDataAnalysisDimension: '经营数据分析维度',
    businessAnalysisAndSuggestion: '经营分析建议',
    trafficAnalysisSuggestion: '流量分析建议',
    serviceIndicatorSuggestion: '服务指标建议',
    competitiveCircleAnalysisSuggestion: '竞争圈分析建议',
    previewReport: '预览报告',
    saveReport: '保存报告',
    saveReleaseReport: '保存发布报告',
    pleaseEnterTheTitleOfTheReport: '请输入报告标题',
    pleaseEnterBusinessAnalysisSuggestions: '请输入经营分析建议',
    pleaseEnterTrafficAnalysisSuggestions: '请输入流量分析建议',
    pleaseEnterTheServiceIndicatorSuggestion: '请输入服务指标建议',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion: '请输入竞争圈分析建议',
  },
  componentsFlowLine: {
    myExposureConversionRate2: '我的曝光转化率',
    previousExposureConversionRate2: '上期曝光转化率',
    myConversionRate2: '我的成交转化率',
    conversionRateOfLastPeriodTransaction2: '上期成交转化率',
    exposureToViewConversionRate: '曝光到浏览的转化率',
    browseToTheConversionRateOfTheTransaction: '浏览到成交的转化率',
  },
  componentsRatioPieChart: {
    directConnection3: '直连',
  },
  competeCChannelData: {
    lostOrders: '流失订单数',
    single: '单',
    numberOfLostNights: '流失间夜数',
    lossAmount: '流失金额',
    distanceFromMe: '离我距离',
    mark: '评分',
    startingPrice: '起价',
    theProportionOfLostOrders: '流失订单占比',
    drainType: '流失房型',
    orderConversionRate: '下单转化率',
    viewTheProportionOfUsers: '浏览用户占比',
    finalPurchaseRatio: '最终购买比例',
  },
  flowFChart: {
    browseToTheConversionRateOfTheTransaction: '浏览到成交的转化率',
    exposureToViewConversionRate: '曝光到浏览的转化率',
  },
  flowFTable: {
    myHotel: '我的酒店',
    monthOnMonth: '环比同期',
    onlinePaymentSingular: '线上支付单数',
    single: '单',
  },
  flowFlowTable: {
    payForOrderQuantity: '支付订单量',
    exposureConversionRate: '曝光转化率',
    transactionConversionRate: '成交转化率',
  },
  reportManageLog: {
    dataReportOperationLogs: '数据报告操作日志',
    logNumber: '日志编号',
    operationName: '操作名称',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: '评分分布情况图',
    article: '条',
    numberOfCommentsWithChart: '带图点评数',
    newBadReviewsThisPeriod: '条  本期新增差评数：{num}条',
    unrepliedBadReviews: '  未回复差评数：{num}条',
  },
  serveindexServeRadarChart: {
    radarMap: '雷达图',
  },
  serveindexServelist: {
    basicScore: '基础分',
    awardPoints: '奖励分',
    penaltyPoint: '惩罚分',
  },
  situationSChannelTable: {
    salesNight: '销售间夜',
    averageSalesRate: '销售平均房价',
    consumptionNight: '消费间夜',
    averageHousePriceOfConsumption: '消费平均房价',
    cancelNight: '取消间夜',
    cancellationRate: '取消率',
    noSingleRoomNights: '拒单间夜',
    rejectRate: '拒单率',
    onlinePermeability: '线上渗透率',
    channelOnlineStatus: '渠道在线状态',
    lightHoldTheDirectConnection: '轻住直连',
  },
  situationSGrid: {
    onAYearOnYearBasis: '同比',
    chainRatio: '环比',
    cancellationRate: '取消率',
    rejectRate: '拒单率',
    theBookingAmountIncludesCancelledAndRejectedOrders: '预订金额包含取消、拒绝的订单',
    reservationAmountCancelAndRejectOrders: '预订金额去掉取消、拒绝的订单',
    accessSource: '访问来源',
    onlineChannelConsumptionBedNightstotalAvailableInventory: '线上渠道消费间夜/总可售库存',
    advanceBookingBedNightstotalSalesBedNights: '提前预订间夜/总销售间夜',
    cancelBedNightssalesBedNights: '取消间夜/销售间夜',
    rejectBedNightssalesBedNights: '拒单间夜/销售间夜',
  },
  situationSalePieChart: {
    salesRoomNightProportion: '销售间夜占比',
    theProportionOfSalesAmount: '销售金额占比',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: '操作停用时间',
    disableStartEndTime: '停用开始结束时间',
    releaseTime2: '解除时间',
    inactiveRoomReport: '停用房间报表',
    deactivationOperator: '停用操作人',
    releaseOperator: '解除操作人',
    normalExchange: '正常换房',
    freeUpgrade: '免费升级',
    chargeEscalation: '收费升级',
  },
  orderGuest: {
    reportType2: '报表类型',
    sameDayCheckIn: '当日入住',
    sameDayCheckOut: '当日离店',
    dailyArrivalsAndDepartures: '当日入离',
    contractCompany: '协议公司',
    firstDayRate: '首日房价',
    nation2: '国家',
    roomListRemarks: '房单备注',
    guestStatement: '宾客住店报表',
  },
  orderRoomChange: {
    unterracedHouse: '未排房',
    typeOfExchange: '换房类型',
    normalExchange: '正常换房',
    freeUpgrade: '免费升级',
    chargeEscalation: '收费升级',
    originalRoomNumber: '原房号',
    existingRoomNumber: '现房号',
    currentHouseType: '现房型',
    roomChangeTime: '换房时间',
    changeRoomsAfterCheckIn: '入住后换房',
    originalRoomRate: '原房价',
    spotRate: '现房价',
  },
  checkInIndex: {
    viewListingDetails: '查看房单详情',
    message: '信息',
    individualStepIntoSuccess: '散客步入成功',
    automaticallyRedirectsToListingDetails: '自动跳转至房单详情',
    successfulCodeScanning: '扫码成功',
    thereIsNoCorrespondingProductForTheCurrentRoomType: '当前房型暂无对应产品',
    memberBalanceIs: '会员余额为',
    pleaseSelectAnotherRecipient: '元，请选择其他收款方',
  },
  checkInNewindex: {
    committedParameter: '提交的参数',
    individualStepIntoSuccess: '散客步入成功',
  },
  checkInRoomerItem: {
    moreInformation: '更多信息',
    number: '号码',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery: '请输要查询的会员信息',
    enterTheInformationAboutTheProtocolUnitToBeQueried: '请输要查询的协议单位信息',
  },
  componentsDepositsection: {
    selectPaymentMethod: '选择支付方式',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: '房态',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType: '该房型在预订日期未查询到产品',
  },
  componentsRoomerItem: {
    moreInformation: '更多信息',
    genderBirthday: '性别-生日',
    nationalityNationality: '国籍-民族',
    pleaseEnterTheFullAddress2: '请输入详细地址',
    validityPeriod: '有效期限',
  },
  utilsLehuimixin: {
    viewListingDetails: '查看房单详情',
    automaticallyRedirectsToListingDetails: '自动跳转至房单详情',
    successfulCodeScanning: '扫码成功',
    callbackRoute: '回调的路由',
    checkInSuccessful: '入住成功',
    listingDetails: '房单详情',
    orderDetails: '订单详情',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType: '该房型在预订日期未查询到产品',
    thisRoomTypeIsSoldOutWithinTheBookingDate: '该房型在预订日期内已售完',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate: '该房型在预订日期内未设置价格',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod: '会员余额不足，请选择其他付款方式',
  },
  componentsAuthcode: {
    laterOn: '稍后',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck: '验证码发送成功，请注意查收',
  },
  componentsBookingcommonmixin: {
    reset: '重置',
  },
  componentsBookingmixin: {
    nineHours: '九小时',
    tenHours: '十小时',
    elevenHours: '十一小时',
    twelveHours: '十二小时',
    hourStore: '小时-门店',
    noRoomTypesAvailable: '暂无可预订房型',
    houseList: '排房列表',
    totalPrice: '总价格',
  },
  componentsLimitinput: {
    insufficientStock: '库存不足',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled: '会员信息不存在或已被禁用',
    pleaseEnterTheMemberInformationYouWantToQuery3: '请输入要查询的会员信息',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod: '会员余额不足，请选择其他付款方式',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed: '会员手机号不正确，无法使用储值支付',
    memberNamephoneNumbermembershipNumber: '会员姓名/手机号/卡号',
  },
  componentsPaytip: {
    memberPaymentFailure: '会员支付失败',
    pleaseReEnterTheAccount: '请重新入账',
  },
  futureIndex: {
    roomTypeSummary: '房型汇总',
    roomDetail: '房间明细',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber: '已售数 / 可售数(超售数) / 停用数',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms: '总房数：酒物理总房间数',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber: '可售数：总房数-已售数-停用数+全日房超售数',
    disabledNumberNumberOfDisabledRoomsInTheHotel: '停用数：酒店停用房间数',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom: '已售数：预订当日的房间+当日在住的房间不含今日预离及钟点房',
  },
  groupbookingIndex: {
    pleaseEnterTeamName: '请填写团队名称',
    memberBalanceNotEnough: '会员余额为 {balance} 元，请选择其他收款方式',
    bookingRoomCannotBeZero: '预订间数不能为 0',
    roomTypeStockNotEnough: ' 房型库存不足',
    pleaseEnterContractNo: '请输入合同号',
    remarkPlaceholder: '最多输入 150 个字',
    discountPricePlaceholder: '请输入优惠价',
    leftRoomsTip: '还有 {count} 间未排房',
    searchMemberPlaceholder: '姓名 / 手机号 / 会员号',
    groupBooking: '团队预订',
    contractNumber: '合同编号',
    teamBookingSuccessful: '团队预订成功',
  },
  longbookingIndex: {
    singleRoom: '长包房',
  },
  longbookingProductionlist: {
    houseList: '排房列表',
    inAddition: '还有',
  },
  onlinedataIndex: {
    chainRatio: '环比',
    onAYearOnYearBasis: '同比',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel: '直连渠道未开通，为防止订单损失，请尽快联系轻住运营经理开通直连渠道',
    relevance: '关联',
    onlineRevenue: '线上营收',
    onlineNight: '线上间夜',
    channelProportion: '渠道占比',
    channelOnlineStatus: '渠道在线状态',
    directConnection3: '直连',
    temporarilyWithoutAuthority: '暂无权限',
    totalOnlineRevenue: '线上总营收',
    onlineTotalNight: '线上总间夜',
    online: '线上',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement: 'EB账号未绑定，请到EB账号管理绑定EB账号',
  },
  realTimeIndex: {
    allBuildings: '全部楼栋',
    allFloors: '全部楼层',
    depositShort: '押',
    roomRateShort: '价',
    totalShort: '总',
    preAuthShort: '预',
    balanceShort: '余',
    powerOff: '断',
    powerOn: '通',
    new2: '新',
    al: '联',
    openChannelsForDirectConnection: '开通渠道直连',
    createRoomType: '创建房型',
    createARoom: '创建房间',
    renewalOrder2: '续住单',
    roomChangeConfirmationForm3: '换房确认单',
    checkInSlip4: '入住登记单',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2: '续住时房间显示的为续住首日价格，提前时/变更预离时间时，均显示的是最后一晚的价格',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3: '温馨提示：请务必核对无误后签字确认，换房后记得将原房间的私人物品带上',
    continuationRoomsShowTheFirstDayPrice2: '续住房间显示的是首日价格',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3: '温馨提示：请务必核对无误后签字确认，私人物品带上',
    liveLightlyInTheDirectCamp: '轻住直营',
    whereToConnectDirectly: '去哪儿直连',
    baiduMap: '百度地图',
    jingdong: '京东',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2: '飞猪信用住订单不支持联房',
    flyingPigCreditOrdersCanNotBeSustained2: '飞猪信用住订单无法支持续住',
    itHasPassedTheCheckOutDateAndCannotBeExtended2: '已超过离店日期，无法续住',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2: '当前时间已超过离店时间，不支持升级房间',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2: '当前时间已超过离店日期六点，不支持升级房间',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2: '当前时间已超过离店时间，不支持更换房间',
    successfulRoomExchange2: '换房成功',
    successfulDisposal: '置脏成功',
    cleanAndSuccessful: '置干净成功',
    deactivateSuccessfully: '解除停用成功',
    temporaryPassword: '临时密码',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse: '此密码30分钟内有效，使用后立即失效',
    quickSearch: '房号或姓名快速查询',
    batchModify: '批量改房态',
    ignore: '忽 略',
    goAndOperate: '去 操 作',
    bookingInfo: '待入住预订信息',
    orderNo: '订单号',
    channelName: '渠道名称',
    bookerName: '预订人姓名',
    arrivalTime: '预抵时间',
    roomRate: '房价',
  },
  realTimeServicemsg: {
    dateOfService: '服务日期',
    applicationTime2: '申请时间',
    serviceType: '服务类型',
    serviceTime: '服务时间',
    serviceSuccess: '服务成功',
    serviceFailure: '服务失败',
    serviceCompletion: '服务完成',
    theRoomRequestHasBeenServiced: '客房请求已服务完成',
  },
  componentsCommon: {
    roomBalance: '房间余额',
    depositWithPreAuth: '押金（含预授权）',
    madeCardCount: '已制卡数',
    stayOver: '续住',
    checkOut4: '退房',
    temporaryPassword: '临时密码',
    sendPassword: '发送密码',
    muck: '置脏',
    setAside: '置净',
    deactivate: '解除停用',
    faceEast: '朝东',
    faceWest: '朝西',
    faceSouth: '朝南',
    faceNorth: '朝北',
    decorativeFalseWindow: '装饰性假窗',
    stayAwayFromElevators: '远离电梯',
    nearTheStairs: '靠近楼梯',
    closeToTheRoad: '靠近马路',
    windowWall: '窗外墙体',
    bedTypeDescription: '床型描述',
    guestControl: '客控',
    latestCheckIn: '最近入住',
    noHistoricalCheckInInfo: '该房间没有历史入住信息',
    temporaryMakeCard: '临时制卡',
  },
  componentsEmpty: {
    searchNull: '搜索为空',
  },
  componentsGrouphandle: {
    batchModify: '批量改房态',
    pleaseSelectAnActiveArea: '请选择活动区域',
    selectStartDate: '选择开始日期',
    selectEndDate: '选择结束日期',
    emptyCleanToEmptyDirty: '空净转空脏',
    emptyDirtyToEmptyClean: '空脏转空净',
    stayCleanAndTurnDirty: '住净转住脏',
    stayDirtyAndTurnClean: '住脏转住净',
    batchOutage: '批量停用',
    batchDeactivation: '批量解除停用',
    pleaseEnterTheStartTime: '请输入开始时间',
    pleaseEnterTheEndTime: '请输入结束时间',
    pleaseSelectTheRoomForBatchOperation: '请选择要批量操作的房间',
    batchOperationSuccessful: '批量操作成功',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms: '是否确定停用，批量停用中包含（已排房）房间?',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: '入住时间确认',
    continuousHousing: '继续排房',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime: '已超过预抵时间，请您确认客人入住时间',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing: '已经被占用,继续办理后请您手工排房',
  },
  componentsOperationlog: {
    operationRecord: '操作记录',
  },
  componentsStopservice: {
    successfulDeactivation: '停用成功',
    selectStartDate: '选择开始日期',
    selectEndDate: '选择结束日期',
    noteAtLeast3Words: '备注最少3个字',
    startMustAfterNow: '开始日期必须大于等于当前日期',
    endMustAfterStart: '结束日期必须大于开始日期',
  },
  serviceHandle: {
    accept: '接受',
    turnDown2: '拒绝',
    serviceProcessing: '服务处理',
    whetherToProcess: '是否处理',
    reasonForRefusal: '拒绝原因',
    pleaseEnterTheReasonForTheRejection: '请输入拒绝原因',
    accepted: '已接受',
    denialOfService: '服务拒绝',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain: '无可排房间，请确认后重试',
    upgradeNumberOfRooms: '升级房间数量',
    pleaseEnterRoomChangeRemarks: '请输入换房备注',
    conditionOfTheHouse2: '房态',
    pleaseSelectTheRoomYouWantToUpgrade: '请选择要升级的房间',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade: '当前没有可升级的房型',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms: '排房数量不能大于预订间数',
    thisRoomTypeIsNotOnline: '该房型未上线',
    hourProductPleaseSelectAnotherRoomType: '小时产品，请选择其他房型',
    thisRoomType: '该房型',
    productsAreSoldOutPleaseChooseAnotherRoomType: '小时产品已售完，请选择其他房型',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType: '小时产品未设置价格，请选择其他房型',
    yourUpgradedRoomTypeIsAllThatIsLeft: '您升级的房型仅剩',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades: '间，请更换其他房型或减少房间升级数量',
  },
  sankebookingIndex: {
    channelOrderRoomType: '渠道下单房型',
    operationPrompt: '操作提示',
    furtherBooking: '继续预定',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat: '该订单已经办理了预订，请不要重复办理',
    floorPriceModel: '底价模式',
    sellingPriceModel: '卖价模式',
    theNumberOfReservedRoomsCannotBe: '预订间数不能为',
    reservationNumber: '预订单数',
    inAddition: '还有',
    useEbInformation: '使用eb信息',
    useEbOrderInformation: '使用EB订单信息',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking: '预订间数和渠道订单间数不一致，是否继续办理预订',
    thisOrderCannotBeBooked: '该订单不能办理预订',
  },
  activityData: {
    dailySpecial: '天天特价',
    keepPricesLow: '保持低价',
    motivateUsersToBuyMore: '刺激用户多买',
    earlyRush: '提早抢客',
  },
  componentsActivitydetail: {
    discount: '折扣',
    promotionInfo: '活动报名成功提交后即生效，活动进行过程中酒店可修改或退出，但已完成订单按照既有规则进行。活动参与房型原价不得高于其他渠道价格，否则可能无法展现。',
    offerDetails: '活动参与房型促销前价格不高于其他渠道，将获得更多曝光机会。建议商户中最低价房型参与活动，将获得更多流量入口曝光机会。',
    backToActivityList: '返回活动列表',
    quantitySold: '售卖数量',
    sellLowEachNight: '每间夜低卖',
    pleaseSelectAnEventProduct: '请选择参加活动产品',
    noRoomTypeInformationAvailable: '暂无房型信息',
    productsHaveBeenSelectedForTheEvent: '已选参加活动产品',
    selectOffer: '选择优惠',
    iHaveReadAndAgree: '我已阅读并同意',
    activityRelatedClause: '活动相关条款',
    selectedOffer: '已选优惠',
    signUpNow: '立即报名',
    activeTime: '活动时间',
    activityProfile: '活动简介',
    activityRequirement: '活动要求',
    preferentialDetails: '优惠明细',
    specialSpecification: '特殊说明',
    entryAndExitRules: '生效及退出规则',
    costAttribution: '成本归属',
    midAutumnFestival: '中秋佳节',
    specialProduct: '特殊产品',
    areYouSureYouWantToCommitYourChanges: '确认要提交修改吗',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: '请选择参加活动的房型',
    pleaseSelectDiscount: '请选择折扣',
    pleaseReadAndAgreeToTheTermsOfTheEvent: '请阅读并同意活动相关条款',
    successfulRegistration: '报名成功',
  },
  componentsSelfactivitylist: {
    expired: '已过期',
    copyPromotion: '复制促销',
    promotionType: '促销类型',
    marginOfPreference: '优惠幅度',
    eventDate: '活动日期',
    beOffline: '已下线',
    merchantsPushThemselvesOffline: '商家自促下线',
    offlineSuccess: '下线成功',
    areYouSureYouWantToDeleteTheActivity: '确认要将活动删除吗',
  },
  componentsActivitycontent: {
    activityRequirement: '活动要求',
    quantitySold: '售卖数量',
    signUpNow: '立即报名',
    cancelRegistration: '取消报名',
    reEnroll: '再次报名',
    areYouSureYouWantToCancelYourRegistration: '确认要取消报名吗',
  },
  componentsSelfactivitylog: {
    inquire: '查 询',
    back: '返回',
  },
  componentsDialog: {
    rule: '规则',
    new: '新建',
    content: '内容',
    activityRelatedClause: '活动相关条款',
  },
  componentsSelfactivitydetail: {
    discountInfo: '打开自动延期会在促销结束日期前30天自动延期，创建一条新促销。如果促销结束日期距离当前日期不足30天，会自动将促销延长至30天。',
    chooseToParticipateInPromotionalProducts: '选择参与促销产品',
    noRoomTypeInformationAvailable: '暂无房型信息',
    selectedProductsForPromotion: '已选参与促销产品',
    selectTheChannelWhereThePromotionIsEffective: '选择促销生效的渠道',
    allChannels: '全部渠道',
    designatedChannel: '指定渠道',
    noEffectiveChannelInformationIsAvailable: '暂无生效渠道信息',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect: '已选促销生效的渠道',
    activeConfiguration: '活动配置',
    setForAtLeast2Days: '最少设置2天',
    setThisParameterForAtLeast1Day: '最少设置1天',
    discount: '折扣',
    theDiscountValueIsSetToAtLeast95Off: '折扣数值最少设置为95折',
    theMinimumAmountOfImmediateReductionIsSetAt5: '立减金额最少设置为5元',
    immediateReductionPromotionIsNotEffectiveForCtrip: '立减类促销对携程不生效',
    thePromotionIsValidOnlyOnCtrip: '该促销仅在携程生效',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng: '该促销仅在携程、同程生效',
    link: '连住',
    advanceBooking: '提前预订',
    preferentialMode: '优惠方式',
    firstStayDiscount: '首住折扣',
    automaticExtension: '自动延期',
    saleTime: '甩卖时间',
    theFollowingDay: '次日',
    theIntervalShallNotBeLessThan30Days: '间隔时间不得小于30天',
    areYouSureYouWantToCommitYourChanges: '确认要提交修改吗',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: '请选择参加活动的房型',
    pleaseSelectAnEventCheckInDate: '请选择活动入住日期',
    pleaseFillInTheDiscountAmount: '请填写优惠金额',
    atLeast95OffUpTo30Off: '折扣金额至少95折,至多3折',
    theDiscountAmountIsAtLeast5AndUpTo500: '优惠金额至少5元,至多500元',
    pleaseFillInTheNumberOfConsecutiveDays: '请填写连住天数',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days: '连住天数必须大于等于1天，小于等于10天',
    pleaseFillInTheAdvanceBookingDays: '请填写提前预订天数',
    pleaseFillInTheSaleTime: '请填写甩卖时间',
    congratulationsOnYourPromotionCreation: '恭喜您促销创建成功',
    congratulationsOnYourSuccessfulCopyPromotion: '恭喜您促销复制成功',
    back: '返回',
  },
  componentsSelfactivitytemp: {
    createNow: '立即创建',
  },
  productOversaleSetting: {
    timePeriod: '时间段',
    numberSold: '已售数',
    oversold: '可超售',
    oversoldQuantity: '超售数量',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay: '当日超售不可大于当日酒店剩余物理房量',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay: '超售库存在当日房型实际物理库存售罄时启用',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout: '请在更多-系统设置-基础设置-直连接单打开超售时自动接单设置，避免超售订单超时自动拒单',
    timeSelectionIsOutOfRange: '时间选择超过范围',
    configurationSuccessful: '配置成功',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo: '设置超售数量必须大于等于',
  },
  productDelayprice: {
    holidayFactorRange: '节假日系数可输入范围：1~5的小数，最多保留一位小数。',
    holidayPricingRule: '设置节假日系数之后，中国大陆法定节假日价格将会变成平日价格的。例如：当系数为2，平日价格为100元时，系统将自动把节假日价格设置为2*100=200元。',
    holidayFactor: '设置节假日系数之后，中国大陆法定节假日价格将会变成平日价格的',
    priceCopy: '复制2个月的价格',
    open: '已开启',
    deferredProduct: '延价产品',
    allDayRoomProducts: '全日房产品',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType: '只针对入住类型为全日房的产品进行延价',
    priceExtensionTime: '延价时长',
    holidayCoefficient: '节假日系数',
    statutoryHolidayPricesAreWeekdays: '法定节假日价格为平日的',
    times: '倍',
    automaticDeferralDescription: '自动延价说明',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem: '系统将最近一周的价格复制给未来没有价格的日期，已经有价格的日期，不会被系统覆盖',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken: '自动延价的价格来源为自动延价日期之前一周的价格，如遇节假日则跳过，取更前一周的价格',
    turnOffAutomaticDeferral: '关闭自动延价',
  },
  productManageSetting: {
    advanceSale: '预售',
    needChannelConnection: '该产品须开通渠道直连后方可创建，是否确认开通渠道直连？',
    confirmChangeProductType: '修改产品类型会将产品发布渠道和全部产品规则清空，是否确认操作？',
    limitSale: '限售 (间)',
    checkInDay: '入住当天',
    beforeCheckIn: '入住前',
    atLatest: '最晚',
    theHourlyIncreaseCannotBeGreaterThanThePrice: '每小时加收不可大于价格',
    physicalRoomType: '物理房型',
    earliestCheckInTime: '最早入住时间',
    latestCheckOutTime: '最晚退房时间',
    howLongNoAdditionalRoomChargeminutes: '延长多久不加收房费(分钟)',
    howLongIsTheFullDayRoomChargehours: '满多长时间收全天房费(小时)',
    cancelRule: '取消规则',
    paymentPolicy: '支付政策',
    validForOnlineSalesOnly: '仅对线上售卖生效',
    releaseChannel: '发布渠道',
    productRegulation: '产品规则',
    effectiveChannel: '生效渠道',
    priceyuan: '价格 (元)',
    inputPrice: '输入价格',
    extraChargePerHourrmb: '每超1小时加收 (元)',
    forSaleOnly: '限售 (间)',
    inputSpace: '输入间数',
    enjoyHotelStayLight: '轻住悦享酒店',
    pleaseEnterTheNumberOfRooms: '请输入间数',
    additionalRule: '增加规则',
    found: '创建',
    containing: '含',
    pleaseEnterTheNumberOfRestrictedRooms: '请输入限售间数',
    nonDeletable: '不可删除',
    early: '早',
    withoutBreakfast: '不含早',
    liveLightAndEnjoy: '轻住优享',
    confirmToDeleteThisRule: '确定删除此规则',
    areYouSureToKeepItForSale: '确定保存售卖吗',
    areYouSureToCreateASale: '确定创建售卖吗',
    areYouSureYouWantToLeave: '确定要离开吗',
  },
  productPriceCalendar: {
    is: '吗?',
    confirmDeleteWarning: '请确认当前产品是否有尚未离店的房单，以免对续住产生影响。如确认删除，请点击下方的‘确认删除’按钮',
    totalAvailableRooms: '总可售房间10间/(含超售余量3间)',
    limitZeroFull: '限售数为0时则是满房状态；关房后将不对外网售卖。',
    openRoomAvailable: '开房时有剩余房间外网可售，关房后将不对外网售卖',
    allProducts3: '全部产品',
    onlineProduct2: '在线产品',
    offLineProduct2: '不在线产品',
    theReckoner: '计算器',
    preSaleFullDayRoom: '预售全日房',
    presaleHourRoom: '预售钟点房',
    viewIsNotSupported: '暂不支持查看',
    channelPricesCannotBeSet: '渠道价格不可设置',
    smallProgramChannelPriceCanBeAdjustedToUpdate: '可调整小程序渠道价格进行更新',
    switchRoom: '开关房',
    limitedSalesNumber: '限售数',
    unlimitedSale: '不限售',
    packUpAllProducts: '收起全部产品',
    expandAllProducts: '展开全部产品',
    modifyProductPrice: '修改产品价格',
    extraChargeForMoreThan1Hour: '超过1小时加收',
    enjoyHotelStayLight: '轻住悦享酒店',
    pleaseEnterLimitedNumber: '请输入限售数',
    maintenancePrice: '维护价格',
    priceNotMaintained: '价格未维护',
    amendTheSalesRestrictionRules: '修改限售规则',
    confirmOrNot: '是否确认',
    areYouSureYouWantToContinue: '确定继续修改吗',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: '当前价格超过酒店设置阈值',
    definiteModification: '确定修改',
  },
  productPriceCalendarNew: {
    open: '开房',
    iss: '吗?',
    remainingContractReservedRooms: '剩余合同保留房',
    roomsCannotBeLower: '间，保留房量不能低于此数值',
    confirmDeleteWarning: '请确认当前产品是否有尚未离店的房单，以免对续住产生影响。如确认删除，请点击下方的‘确认删除’按钮',
    Thenumberofremainingcontractreservedroomsforthisproduct: '该产品剩余合同保留房数量不为0，已提交关房申请，请等待审核。',
    cannotCloseRoom: '该产品剩余合同保留房数量不为0，无法关房，请联系渠道业务经理进行关房.',
    confirmModification: '确认修改',
    EBDeepOperationFailed: 'EB深度运营失败',
    syncCurrentPageEBData: '同步当前页EB数据',
    previousTwoWeeks: '上两周',
    nextTwoWeeks: '下两周',
    batchChangeInventory: '批量改库存',
    theReckoner: '计算器',
    preSaleFullDayRoom: '预售全日房',
    presaleHourRoom: '预售钟点房',
    underRevision: '修改中',
    viewIsNotSupported: '暂不支持查看',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute: '数据同步中，请1分钟后重新查询',
    lightLiveDistributionChannelPriceCannotBeSet: '轻住分销渠道价格不可设置',
    smallProgramChannelPriceCanBeAdjustedToUpdate: '可调整小程序渠道价格进行更新',
    switchRoomSetup: '开关房设置',
    notModify: '不修改',
    roomSetting: '房量设置',
    unlimitedSale: '不限售',
    reserveRoomSetup: '保留房设置',
    pleaseSelectRoomType: '房型',
    pleaseSelectCheckInType: '入住类型',
    notShowPreSaleProduct: '不显示预售产品',
    showPreSaleProduct: '显示预售产品',
    notShowEbProduct: '不显示EB产品',
    showEbProduct: '显示EB产品',
    allCheckInTypes: '全部入住类型',
    holiday: '节假日',
    packItAllUp: '收起全部',
    expandAll: '展开全部',
    extraChargeForMoreThan1Hour: '超过1小时加收',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms: '保留房数量可以增加，最多不能超过当前库存数量，最少不能低于剩余合同保留房数量',
    offLineProduct2: '不在线产品',
    onlineProduct2: '在线产品',
    allProducts3: '全部产品',
    showFloor: '显示底价',
    theReservePriceIsNotDisplayed: '不显示底价',
    directChannel4: '直连渠道',
    goWhereTheDirectConnection: '去哪直连',
    unboundChannel: '未绑定渠道',
    synchronizationFailure: '同步失败',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate: '前两周开始日期不能小于当前日期',
    pleaseSelectTheCurrentStartEndDate: '请选择当前开始结束日期',
    pleaseEnterTheNumberOfReservedRooms: '请输入保留房数',
    pleaseEnterLimitedNumber: '请输入限售数',
    maintenancePrice: '维护价格',
    priceNotMaintained: '价格未维护',
    modifyProductPrice: '修改产品价格',
    modifyProductInventory: '修改产品库存',
    confirmOrNot: '是否确认',
    theCurrentRateExceedsTheThresholdSetByTheHotel5: '当前价格超过酒店设置阈值',
    areYouSureYouWantToContinue: '确定继续修改吗',
    definiteModification: '确定修改',
    ebChannel: 'eb渠道',
    ebMeituan: 'eb美团',
    ebCtrip: 'eb携程',
    ebFeizhu: 'eb飞猪',
  },
  productPriceAudit: {
    allRejectedSuccessfully: '全部驳回成功',
    pass: '通过',
    turnDown: '驳回',
    revisedPrice: '改后价格',
    rangeOfVariation: '变价范围',
    priceChanger: '改价人',
    auditor: '审核人',
    auditTime: '审核时间',
    toBeReviewed: '待审核',
    passTheExamination: '审核通过',
    expired: '过期',
    successfulAudit: '审核成功',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: '总可售房间10间/(含超售余量3间)',
    ebPriceSoldRemaining: '房价(EB卖价)/已售房量/剩余房量',
    ebPriceSoldCloseStatus: '房价(EB卖价)/已售房量/关房状态',
    ebBasePriceReservedUnlimited: 'EB底价/剩余保留房数量(包含合同保留房和临时保留房)/无限售卖',
    hourRoomProductsShowHourRoomIdentification: '钟点房产品显示钟点房标识',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective: '产品改价或是改房态后，没有立即生效在审核中时，显示审核中标识，审核通过修改生效后审核中标识隐藏',
    underRevision: '修改中',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure: '房价或库存有正在修改的数据，还未获取到修改结果时显示标识，只有成功或失败后才会隐藏标识',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus: '产品改价或是改房态失败后显示失败标识，只有在下次操作改价或改房态成功后才会隐藏标识',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged: '产品获取失败，需要联系运营经理确认该产品是否发生变更',
    statusDeclaration: '状态说明',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState: '限售数为0时满房状态，关房后不可对外售卖，无限量状态只有关房才会停止售卖',
    ctripEbPrepaidProductsShowThePrepaidLogo: '携程EB预付产品显示预付标识',
    ctripEbCashProductsShowTheCashLogo: '携程EB现付产品显示现付标识',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip: 'EB产品剩余保留房不为0时，无法关房',
    roomSettingTip: '房量调整的是限售数，针对房型下所有产品。直连产品和EB产品库存取限售数和物理库存的最小值',
    infiniteQuantityTip: '无限量对应EB美团的无限量、飞猪的不限量、携程的freesale。直连渠道的不限售',
    notModify: '不修改',
    roomSetting: '房量设置',
    restrictedSalesIncrease: '限售增加',
    restrictedSalesReduction: '限售减少',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory: '直连产品仅支持修改开关房状态，不支持修改库存',
    batchChangeInventory: '批量改库存',
    productSelection: '产品选择',
    whetherToDisplayPreSaleProducts: '是否显示预售产品',
    channelSelection: '渠道选择',
    paymentType: '支付类型',
    selectionWeek2: '选择星期',
    switchRoomSetup: '开关房设置',
    open: '开房',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2: '部分产品修改失败，以下为失败产品，请获取最新价格库存后再次修改',
    pleaseSelectADateRange2: '请选择日期区间',
    pleaseSelectAWeek2: '请选择星期',
    pleaseEnterTheNumberOfRestrictedRooms: '请输入限售间数',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms: '请输入限售增加间数',
    pleaseEnterTheNumberOfRestrictedReducedRooms: '请输入限售减少间数',
  },
  pcncomponentPriceunified: {
    weekend: '周末',
    officialWebsiteDirect: '官网直营',
    dateCannotRepeat: '日期不能重复',
    displayNextPage: '显示下一页',
    priceCannotBeLessThan20: '卖价不能小于等于20',
    lowSellingPriceTip: '以下产品卖价过低，请确认是否继续修改',
    priceExceedsThresholdTip: '本次改价超过预设范围，请联系店长进行改价审核',
    selectProduct: '选择产品',
    weekdays: '平日',
    noDifference: '不区分',
    distinguish: '区分',
    bulkAdjustment: '批量调整',
    increase: '增加',
    reduce: '减少',
    weekdayWeekend: '平日/周末',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2: '部分产品修改失败，以下为失败产品，请获取最新价格库存后再次修改',
    weekendPrice: '区分周末价',
    repricingDate: '改价日期',
    effectiveWeek: '生效星期',
    maxFiveDates: '最多选择5个日期',
    priceChangeModeTip: '改价模式可以选择修改卖价+佣金或是底价，卖价+佣金模式下仅携程产品支持修改佣金且可以向上调整，底价模式仅携程产品可以修改',
    sellPriceCommission: '卖价+佣金',
    ebChannel: 'EB渠道',
    ebMeituan: 'EB美团',
    ebCtrip: 'EB携程',
    ebFeizhu: 'EB飞猪',
    splitPricing: '分开改价',
    uniformPriceChange: '统一改价',
    productSelection: '产品选择',
    paymentType: '支付类型',
    selectionWeek2: '选择星期',
    thePreviousStepReselectTheProduct: '上一步 重选产品',
    methodOfRepricing: '改价方式',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches: '分开改价可以设置每个产品的价格，统一改价可以批量进行加减价操作',
    priceModel: '价格模式',
    priceBeforeModification: '修改前价格',
    extraChargeAfterOneHour: '超一小时加收',
    commission: '佣金',
    directChannel4: '直连渠道',
    goWhereTheDirectConnection: '去哪直连',
    value: '值',
  },
  pcncomponentTable: {
    passTheVerification: '验证通过',
    verificationFail: '验证不通过',
  },
  pcncomponentLog: {
    revisedPrice3: '修改后价格',
    pleaseEnterTheRevisedPrice: '请输入修改后价格',
    pleaseSelectAStandardProduct: '请选择标准产品',
    straight: '直',
  },
  giftPro: {
    bindUnbind: '绑定/解绑',
    giftValueInfo: '礼包价值只做展示，不产生实际费用',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts: '礼包只可以配置全日房产品',
    eachProductCanBeConfiguredWithOnlyOnePackage: '每个产品只可以配置一种礼包',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts: '礼包只对美团直连产品生效',
    packageDescription: '礼包说明',
    allProducts2: '所有产品',
    modifiedGiftPack: '修改礼包',
    packageName: '礼包名称',
    giftPackageGiving: '赠送方式',
    packageType: '礼包类型',
    packageStatus: '礼包状态',
    activeProduct: '生效产品',
    createPackage: '新增',
    packageValue: '礼包价值',
    packageEffectiveDate: '礼包生效日期',
    upperLimit1500: '上限1500',
    upperLimit: '上限',
    packageDetails: '礼包详情',
    maximum80Characters: '上限80个字',
    wayOfGiving: '赠送方式',
    thePackageValueCannotBeEmpty: '礼包价值不能为空',
    oneDeliveryPerRoom: '每间房送一次',
    complimentaryOnceADayPerRoom: '每间房每日赠送一次',
    pleaseEnterThePackageName: '请输入礼包名称',
    pleaseSelectTheGiftMethod: '请选择赠送方式',
    pleaseSelectAPackageType: '请选择礼包类型',
    pleaseSelectPackageDetails: '请选择礼包详情',
    pleaseSelectAnEffectiveProduct: '请选择生效产品',
    pleaseSelectAnEffectiveDate: '请选择生效日期',
    whetherToDropTheGiftPackage: '是否下线礼包',
    giftBagOffLine: '礼包下线',
    offlineSuccess: '下线成功',
    offlineFailure: '下线失败',
    methodOfCancellation: '取消的方法',
    createdSuccessfully: '创建成功',
    creationFailure: '创建失败',
  },
  giftLog: {
    packageOperationLog: '礼包操作日志',
  },
  pullnewMember: {
    memberInformationEntry: '会员信息录入',
    areRequiredFieldsOtherFieldsAreNotRequired: '为必填项，其他非必填',
    idNumber: '证件号',
    inputResult: '录入结果',
    recordSuccessfully: '录入成功',
    entryFailure: '录入失败',
    memberSale: '会员特卖',
    enter: '录入',
    passport: '护照',
    pleaseEnterTheIdNumber: '请输入证件号',
    theNameFormatIsIncorrect: '姓名格式不正确',
    theMobilePhoneNumberCannotBeEmpty: '手机号码不允许为空',
    theMobilePhoneNumberFormatIsIncorrect: '手机号码格式不正确',
    theFormatOfTheIdCardNumberIsIncorrect: '身份证号码格式不正确',
    memberInformationEnteredSuccessfully: '会员信息录入成功',
  },
  pullnewNewlist: {
    promoter: '推广人',
    pullTime: '拉新时间',
    pleaseEnterYourPromoterName: '请输入推广人姓名',
    memberNickname: '会员昵称',
    pulsingType: '拉新类型',
  },
  pullnewQrcode: {
    aboutHalfA4: '约A4纸一半',
    sizeLarge: '大',
    sizeSmall: '小',
    sizeMedium: '中',
    lShapedStand: 'L形台卡',
    paperSize: '纸大小',
    downloadPicture: '下载图片',
    memberPullNewCodeGenerationPleaseWait: '会员拉新码生成中，请稍后',
    memberPoster: '会员海报',
    frontDeskStaff: '前台员工',
    foreground: '前台',
    commonArea: '公区',
    corridor: '走廊',
    elevator: '电梯',
    displayStand: '展架',
  },
  tiktokpresalecouponDetail: {
    name: '名称',
    totalGoodsPrice: '商品总价（划线价）',
    uploadImageTips: '上传1-5张，图片尺寸：5M以内；建议分辨率为375*280px；图片比例为4:3',
    unavailableCheckInDates: '不可入住日期：',
    otherInStoreOffers: '可享用店内其他优惠(详询商家)',
    createACoupon: '创建预售券',
    support: '支持',
    nonsupport: '不支持',
    putUp: '住宿',
    bindAvailableProducts: '绑定可用产品',
    bindAtLeastOneProduct: '至少绑定一个产品',
    meal: '餐食',
    addMeal: '添加餐食',
    courteousReception: '礼遇',
    addItem: '添加项目',
    unlimitedInventory: '不限库存',
    stockLimit: '限库存',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate: '开启自动延期后商品售卖日期到期后会自动延期30天',
    namedDate: '指定日期',
    specifiedDays: '指定天数',
    fromTheDateOfPurchase: '自购买之日起',
    availableWithinDays: '天内可用',
    unavailableWeek: '不可用星期',
    unavailableHolidays: '不可用节假日',
    unavailableDate: '不可用日期',
    subjectToAMarkup: '需加价',
    noMarkup: '无需加价',
    allStores: '全部门店',
    addMarkupRules: '添加加价规则',
    limitOnePurchasePerOrder: '每单限购一张',
    purchaseLimitPerPerson: '每人限购',
    maximumPurchasePerPerson: '每人最多购买',
    zhang: '张',
    noAdvanceReservationRequired: '不需要提前预约',
    advanceReservationRequired: '需要提前预约',
    aheadOfSchedule: '提前',
    dailyReservation: '天预约',
    beforeCheckIn: '入住前',
    cannotBeCombinedWithOtherInStoreOffers: '不可与店内其他优惠同享',
    theMealTypeCannotBeEmpty: '餐食类型不能为空',
    theNameOfTheOfferCannotBeEmpty: '礼遇名称不能为空',
    ticketName: '预售券名称',
    pleaseEnterTicketNamemaximum24Words: '请输入预售券名称（最多60个字）',
    fractionalAppointment: '分次预约',
    commodityContent: '商品内容',
    lunch: '午餐',
    automaticExtension: '自动延期',
    availabilityDate: '可入住日期',
    markUpPolicy: '加价政策',
    additionalChargesApply: '需额外付费项目',
    purchaseRestrictionRule: '限购规则',
    reservationRule: '预约规则',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio: '上传1-10张，图片尺寸：5M以内；建议分辨率为375*280px；图片比例为',
    preSaleTicketHeadChart: '预售券头图',
    longMapOfAdvanceTickets: '预售券长图',
    reservationValidity: '预约有效期',
    markupStore: '加价门店',
    markupSession: '加价时段',
    unit: '单位',
    pleaseEnterTheUnit: '请输入单位',
    priceyuan: '价格 (元)',
    cancellationRules: '取消预约规则',
    rulesOfUse: '使用规则',
    otherDescriptiveInformation: '其他说明信息',
    pleaseEnterAdditionalExplanatoryInformation: '请输入其他说明信息',
    found: '创建',
    picturePreview: '图片预览',
    theNameOfTheVoucherCannotBeEmpty: '预售券名称不能为空',
    theNameOfTheVoucherCannotExceed24Characters: '预售券名称不能超过60个字',
    pleaseSelectASaleDate: '请选择售卖日期',
    pleaseSelectTheReservationValidityPeriod: '请选择预约有效期',
    pleaseSelectTheHeaderDiagram: '请选择头图',
    pleaseSelectALongMap: '请选择长图',
    thePurchaseLimitPerPersonCanOnlyBeANumber: '每人限购数只能为数字',
    pleaseFillInTheLengthOfStay: '请填写入住时长',
    mealPriceMustBeGreaterThan: '餐食价格必须大于',
    theCourtesyPriceMustBeGreaterThan: '礼遇价格必须大于',
    theTotalPriceOfTheGoodsCannotBeEmpty: '商品总价不能为空',
    theTotalPriceOfTheGoodsMustBeGreaterThan: '商品总价必须大于',
    pleaseFillInTheActualPricePaidByTheGuest: '请填写客人实际支付价',
    theActualPricePaidMustBeGreaterThan: '客人实际支付价必须大于',
    theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct: '客人实际支付价不能大于商品总价',
    youCanOnlyUploadPictureFiles: '只能上传图片文件',
    pleaseUploadAtLeast1HeaderImage: '请上传至少1张头图',
    pleaseUploadAtLeast1LongPicture: '请上传至少1张长图',
    pleaseEnterTheMaximumPurchasePerPerson: '请输入每人最多购买',
    pleaseFillInTheDailyLimit: '请填写每日限制',
    confirmTheDateToDeleteThis: '确定删除此日期',
    confirmToDeleteThisProduct: '确定删除此产品',
    confirmToDeleteThisMeal: '确定删除此餐食',
    removeMarkupRules: '删除加价规则',
    confirmToRemoveThisMarkupPolicy: '确定删除此加价政策',
    newMarkupRules: '新增加价规则',
    confirmToDeleteThisOffer: '确定删除此礼遇',
    addProjectData: '新增项目数据',
    popUpsAreClosed: '弹窗已关闭',
    beSureToRemoveThisRestriction: '确定删除此限制',
    imageUploadFailed: '图片上传失败',
  },
  tiktokpresalecouponList: {
    deleteConfirm: '删除后后商品不可恢复，确认删除？',
    shelveConfirm: '下架后商品不可售卖，确认下架？',
    unrestrictedInventory: '不限制库存',
    theRemovalHasBeenCancelled: '已取消下架',
    productId: '商品ID',
    product: '商品',
    createACoupon: '新增',
    listing: '上架',
    delist: '下架',
    auditFailure: '审核失败',
    soldInventory: '已售库存',
    modifiedPricePool: '修改价库',
    copy: '复制',
    exportListOfPreSaleTickets: '预售券导出列表',
    itemDeletion: '商品删除',
    goodsOffTheProductionLine: '商品下线',
    removedSuccessfully: '下架成功',
  },
  assemblyAddpriceruledialog: {
    allStores: '全部门店',
    byDate: '按日期',
    byHoliday: '按节假日',
    addMarkupRules: '添加加价规则',
    markupStore: '加价门店',
    markUpPeriod: '加价时间段',
    pleaseEnterTheAmountOfTheIncrease: '请输入加价金额',
    theIncreaseMustBeGreaterThan: '加价金额必须大于',
    pleaseSelectTheIncreasePeriod: '请选择加价时间段',
    pleaseSelectAFestival: '请选择节日',
    pleaseSelectTheWeekOfIncrease: '请选择加价星期',
  },
  assemblyAddmeals: {
    addMeal: '添加餐食',
    typeOfMeal: '餐食类型',
    pleaseSelectTheTypeOfMeal: '请选择餐食类型',
    lunch: '午餐',
    dinner: '晚餐',
    copies: '份数',
    pleaseEnterTheNumberOfCopies: '请输入份数',
    theNumberOfCopiesMustBeGreaterThan: '份数必须大于',
  },
  settingHardware: {
    hardwareManagementToBeDeveloped: '硬件管理,待开发',
  },
  settingMessage: {
    messageManagementToBeDeveloped: '消息管理,待开发',
  },
  baseinfotabBase: {
    orientation: '定位',
    china: '中国',
    province: '省份',
    hotelRating: '酒店星级',
    detailedAddress: '详细地址',
    city: '城市',
    hotelPrice: '酒店价格',
    hotelReceptionCellPhone: '酒店前台手机',
    hotelFrontDesk: '酒店前台座机',
    areaCode: '区号',
    landlineNumber: '座机号',
    extensionNumber: '分机号',
    serviceStatus: '服务状态',
    ctripHotelStars: '携程酒店星级',
    noStarLevel: '无星级',
    starLevel: '{num}星',
    whetherToSellItOnTheInternet: '是否在外网售卖',
    currency: '币种',
    longitude: '经度',
    latitude: '纬度',
    baiduLatitudeAndLongitude: '百度经纬度',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits: '请输入正确手机号，且最多11位',
    theLengthIs78Characters: '长度在7-8个字符',
    theLengthIs34Characters: '长度在3-4个字符',
    pleaseEnterAnInteger: '请输入整数',
    pleaseEnterTheHotelName: '请输入酒店名称',
    lengthOf250ChineseCharacters: '长度在2-50个汉字',
    theValueContains34Digits: '长度在3-4位数值',
    theValueContains78Characters: '长度在7-8位数值',
    pleaseEnterTheValue: '请输入数值',
    pleaseSelectAProvince: '请选择省份',
    pleaseSelectCity: '请选择城市',
    pleaseSelectACounty: '请选择区县',
    pleaseEnterTheFullAddress2: '请输入详细地址',
    theDetailedAddressDoesNotExceed50ChineseCharacters: '详细地址不超过50个汉字',
    pleaseSelectHotelClass: '请选择酒店星级',
    pleaseSelectACtripHotelStar: '请选择携程酒店星级',
    selectWhetherTheExternalNetworkIsVisible: '请选择是否外网可见',
    pleaseSelectHotelServiceStatus: '请选择酒店服务状态',
    economical: '经济型',
    quasi1Star: '准1星',
    true1Star: '真1星',
    quasi2Star: '准2星',
    true2Star: '真2星',
    quasi3Star: '准3星',
    true3Star: '真3星',
    quasi4Star: '准4星',
    true4Star: '真4星',
    quasi5Star: '准5星',
    true5Star: '真5星',
    inOperation: '营业中',
    suspendBusiness: '暂停营业',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty: '腾讯地图经纬度不能为空',
    theNameAndAddressOfTheHotelAreUnderReview: '酒店名称、地址进入审核中',
    districtcounty: '区/县',
    tencentamapLatitudeAndLongitude: '腾讯/高德经纬度',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits: '请输入正确手机号,且最多11位',
  },
  baseinfotabFull: {
    hotelTimezone: '酒店时区',
    fixedRoomNumber: '是否固定房间数',
    businessCircle: '所属商圈',
    hotelBuildingHeight: '酒店楼高',
    subordinateBusinessCircle: '所属副商圈',
    totalNumberOfRooms: '客房总数',
    hotelOpeningHours: '酒店开业时间',
    pleaseSelectADate5: '请选择年月',
    affiliatedGroup: '所属集团',
    hotelRenovationTime: '酒店装修时间',
    affiliatedBrand: '所属品牌',
    hotelTypeupToThree: '酒店类型(最多只能选三个)',
    hotelThemeupToThreeCanBeSelected: '酒店主题(最多只能选三个)',
    settlementMethod: '结算方式',
    hotelProfile: '酒店简介',
    hotelTransportationLocation: '酒店交通位置',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits: '请输入大于等于0的数字，不超过3位',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits: '请输入大于等于0的数字，不超过2位',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters: '请输入酒店简介且长度不超过800个字符',
    pleaseEnterTheHotelTransportationLocation: '请输入酒店交通位置',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters: '请输入酒店交通位置且长度不超过800个字符',
    pleaseEnterTheTotalNumberOfRooms: '请输入客房总数',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2: '请输入大于等于0且不超过3位的数字',
    pleaseSelectYourBrand: '请选择所属品牌',
    pleaseEnterTheHotelBuildingHeight: '请输入酒店楼高',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2: '请输入大于等于0且不超过2位的数字',
    pleaseEnterHotelRenovationTime: '请输入酒店装修时间',
    pleaseEnterHotelOpeningHours: '请输入酒店开业时间',
    pleaseEnterTheCheckoutSupportCardType: '请输入结账支持卡种',
    pleaseSelectHotelType: '请选择酒店类型',
    pleaseSelectAHotelTheme: '请选择酒店主题',
    bizumi: '美住',
    theBusinessCircleIsUnderReview: '所属商圈进入审核中',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages: '包括但不限于：酒店地址,酒店设施,酒店提供的各项服务,酒店特色和优势',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km: '包括但不限于：酒店附近的交通设施,如：距离公交车站100米，距离高铁站2.5km',
  },
  baseinfotabInfo: {
    commission2: '税费',
    bookingInstructions: '预订须知',
    variousFaults: '各类故障',
    earliestCheckInTime: '最早入住时间',
    latestDepartureTime: '最晚离店时间',
    hourRoomEarliestCheckInTime: '钟点房最早入住时间',
    hourRoomLatestCheckOutTime: '钟点房最晚离店时间',
    aMaximumOf30Characters: '最多不超过30个字符',
    taxTitle: '税费名称',
    chargingStandard: '收费标准',
    reservationNotes: '预订须知备注',
    chineseDescription: '中文描述',
    pleaseEnterYourEarliestCheckInTime: '请输入最早入住时间',
    pleaseEnterTheLatestDepartureTime: '请输入最晚离店时间',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom: '请输入钟点房最早入住时间',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom: '请输入钟点房最晚离店时间',
    pleaseSelectTheBookingInstructions: '请选择预订须知',
    noMoreThan10ChineseCharactersInLength: '长度不超过10个汉字',
    theLengthCannotExceed20Characters: '长度不超过20个字符',
    noMoreThan20ChineseCharactersInLength: '长度不超过20个汉字',
    noMoreThan30ChineseCharactersInLength: '长度不超过30个汉字',
    theLengthCannotExceed60Characters: '长度不超过60个字符',
    cutOffTheWaterSupply: '停水',
    powerFailure: '停电',
    elevatorFailure: '电梯故障',
    cantUseBankCard: '不能刷银行卡',
    networkFault: '网络故障',
    pleaseEnterTheStartTimeAndEndTime: '请输入开始时间和结束时间',
    theStartTimeMustBeYoungerThanTheEndTime: '开始时间必须小于结束时间',
  },
  baseinfotabServer: {
    squareMeter: '平方米',
    parkingLot: '停车场',
    elevator2: '电梯',
    pleaseEnterArea: '请输入面积',
    internetAccessInPublicAreas: '公共区域上网',
    hotelFacilities: '酒店设施',
    otherFacilities: '其他设施',
    hotelService: '酒店服务',
    otherServices: '其他服务',
    fallow: '休闲',
    otherLeisure: '其他休闲',
    pleaseEnterAMaximumOf10DigitsInEnglish: '请输入英文中文数字长度不超过10位',
    pleaseSelectParking: '请选择停车场',
    pleaseSelectTheHall: '请选择大厅',
    pleaseEnterTheHallArea: '请输入大厅面积',
    pleaseSelectElevator: '请选择电梯',
    pleaseSelectPublicAreasToAccessTheInternet: '请选择公共区域上网',
    pleaseSelectHotelFacilities: '请选择酒店设施',
    pleaseSelectHotelServices: '请选择酒店服务',
    pleaseSelectLeisure: '请选择休闲',
    oneToFiveStars: '准1-5星',
    true15Stars: '真1-5星',
    walkUp: '无电梯',
    thereIsAnElevator: '有电梯',
    lobbyless: '无大厅',
    haveALobby: '有大厅',
    noInternetAccess: '不能上网',
    freeParking: '免费停车',
    noParking: '无停车场',
    parkingLotAvailable: '有停车场',
    paidParking: '收费停车',
    charge: '收费',
  },
  borrowBorrowrecord: {
    loanDate2: '借用日期',
    newBorrowing: '新增',
    return: '归还',
    cannotBeGreaterThanTheAvailableAmount: '不能大于可用量',
    enterItemNameAndRoomNumber: '物品名称、房间号',
    unitPriceOfGoods2: '物品单价',
    quantityBorrowed: '借用数量',
    borrowARoom: '借用房间',
    dateOfReturn: '归还日期',
    returnQuantity: '归还数量',
    borrowedState: '借用状态',
    amountOfCompensation: '赔偿金额',
    serviceSuccess: '服务成功',
    serviceFailure: '服务失败',
    reasonForRefusal: '拒绝原因',
    enterAMaximumOf30Characters: '最多输入30个字',
    returnOrNot: '是否归还',
    hasItBeenReturned: '是否已归还',
    onlyNumbersGreaterThan0CanBeEntered: '只能输入大于0的数字',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed: '归还数量不能大于或等于借用数量',
    upTo20Characters: '最多20字符',
    pleaseEnterTheReturnQuantity: '请输入归还数量',
    onLoan: '借用中',
    theRoomRequestHasBeenServiced: '客房请求已服务完成',
    serviceCompletion: '服务完成',
    returned: '已归还',
    noReturn: '未归还',
    enterAMaximumOf9Characters: '最多输入9字符',
    chooseToBorrowRoom: '选择借用房间',
  },
  borrowBorrowset: {
    newItem: '新增',
    usable: '可用',
    notAvailable: '不可用',
    alreadyRemoved: '已删除',
    enterItemName: '物品名称',
    unitPriceOfGoods2: '物品单价',
    inventory: '库存',
    amountBorrowed: '已借用量',
    loanableQuantity: '可借用量',
    theNameCannotExceed9CharactersPleaseEnterANewName: '名称长度不能超过9个字，请重新输入',
    priceCannotBeLessThan0PleaseReEnter: '价格不能小于0，请重新输入',
    priceCannotBeGreaterThan9999PleaseReEnter: '价格不能大于9999，请重新输入',
    theInventoryCannotBeLessThan0PleaseReEnter: '库存量不能小于0，请重新输入',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter: '库存量不能小于借用量，请重新输入',
    areYouSureYouWantToDeleteThisItem: '确定要删除该物品吗',
    areYouSureYouWantToDisableThisItem: '确认要禁用该物品吗',
    thisItemHasNotBeenReturnedConfirmToDelete: '该物品尚有无归还，确认删除吗？',
  },
  businessCardIndex: {
    pleaseUploadPictures: '请上传图片',
    pleaseEnterRoomType: '请输入房型',
    uploadBackground: '上传背景',
    saveOperation: '保存操作',
    uploadProfilePicture: '上传头像',
    pleaseEnterAValidNumber: '请输入有效的数字',
    businessCardType: '名片类型',
    currentPriceOfRoomType: '房型现价',
    roomTypeOriginalPrice: '房型原价',
    backgroundImage: '背景图',
    avatar: '头像',
    hotelRecommendation: '酒店推荐',
    roomTypeRecommendation: '房型推荐',
    theNameCannotBeBlank2: '姓名不能为空',
    thePhoneNumberCannotBeEmpty: '手机号不能为空',
    pleaseEnterAValidPhoneNumber: '请输入有效的手机号',
    roomTypeNameCannotBeEmpty: '房型名称不能为空',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty: '房型现价不能为空',
    roomTypeOriginalPriceCannotBeEmpty: '房型原价不能为空',
    pleaseUploadTheBackgroundImage: '请上传背景图',
    pleaseUploadPhoto: '请上传头像',
    areYouSureYouWantToLeaveTheCurrentPage: '确定要离开当前页面吗',
    pleaseSelectImageUpload: '请选择图片上传',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan: '房型现价不得小于',
    roomTypeOriginalPriceMustNotBeLessThan: '房型原价不得小于',
  },
  businessCardUploadavatar: {
    selectPicture: '选择图片',
    uploadProfilePicture: '上传头像',
    pleaseSelectImageUpload: '请选择图片上传',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m: '仅支持JPG，PNG格式图片，图片大小不超过',
  },
  ctnhotelHotelserver: {
    applicationTime2: '申请时间',
    toDealWith: '去办理',
    pleaseRenewYourStayOnTheDayOfDeparture: '请在离店日办理续住',
    applicant: '申请人',
    originalExpectedArrivalDate: '原预抵日期',
    originalDepartureDate: '原预离日期',
    applicationType: '申请类型',
    renewTheNewOrderNumber: '续住新单号',
    renewalDate: '续住日期',
  },
  ebaccountLogin: {
    accountLogin: '账号登录',
    gotTheMessage: '收到消息了',
  },
  ebaccountSetting: {
    accountBinding: '账号绑定',
    goToMaintain: '去维护',
    priceModel: '价格模式',
    automaticOrder: '自动搬单',
    comingSoon: '即将开通',
    hourlyRoomOrder: '钟点房接单',
    orderCancellation: '订单取消',
    bound: '已绑定',
    roomTypeSetting: '房型设置',
    goToSettings: '去设置',
    lastStep: '上一步',
    correlationState: '关联状态',
    bindAccount: '绑定账号',
    synchronizationTime: '同步时间',
    onSale: '在售',
    associated: '已关联',
    uncorrelated: '未关联',
    bind: '绑定',
    noDataIsQueried: '未查询到数据',
    whetherToUnbindTheAccount: '是否需解绑账号',
    pleaseEnterTheCommissionRate: '请输入佣金率',
    channelSetting: '渠道设置',
    floorPriceModel: '底价模式',
    sellingPriceModel: '卖价模式',
    viewSettings: '查看设置',
    orderSetup: '订单设置',
    pleaseSelectAPriceModel: '请选择价格模式',
    pleaseSelectHourRoomPickUp: '请选择钟点房接单',
    dataSynchronization: '数据同步',
    ctripRoomType: '携程房型',
    usGroupRoomType: '美团房型',
    lightWinTreasureRoomTypeName: '轻赢宝房型名称',
    commissionRate: '佣金率',
    pleaseEnterTheSmsVerificationCode: '请输入短信验证码',
    pleaseEnterTheContentInThePicture: '请输入图片中的内容',
    groggery: '酒店',
    ctripProductName: '携程产品名称',
    meituanProductName: '美团产品名称',
    ctripProducts: '携程产品',
    meituanProducts: '美团产品',
    lightWinTreasureProductName: '轻赢宝产品名称',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: '佣金率大于等于0小于100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces: '佣金率为数字，并保留两位小数',
    pleaseSelectTheHourlyOrderSetting: '请选择钟点房搬单设置',
    automaticCancellation: '自动取消',
    manualCancellation: '人工取消',
    automaticConfirmation: '自动确认',
    manualValidation: '人工确认',
    meituancom: '美团网',
    ctrip: '携程旅行',
    pleaseEnterTheImageVerificationCode: '请输入图片验证码',
    pleaseSelectHotel: '请选择酒店',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater: '数据同步成功，请十分钟后重新查询数据',
    unbind: '去绑定',
    whetherToUnbindTheProduct: '是否解绑该产品的绑定关系',
    pleaseSelectTheProductName: '请选择轻赢宝产品名称',
    unbindSuccessfully: '解绑成功',
    whetherToUnbindTheBindingRelationshipOfTheHouseType: '是否解绑该房型的绑定关系',
    pleaseSelectLightWinTreasureRoomTypeName: '请选择轻赢宝房型名称',
    feizhu: '飞猪网',
    notYetUnlocked: '未开启',
    pleaseBindTheAccountFirst: '请先进行账号绑定',
    areYouSureYouWantToUnbindTheAccount: '确定要解绑账号吗',
    notYetBound: '未绑定',
    pleaseConfirmTheHotelYouWantToBindTo: '请确认要绑定的酒店',
    ctripEbAccount: '携程EB账号',
    meituanEbAccount: '美团EB账号',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid: '请联系您的酒店运营经理设置携程HotelID',
    useEbOrderInformation: '使用EB订单信息',
    pleaseSelectEbOrderCancellation: '请选择EB订单取消',
    meituanEbRoomType: '美团EB房型',
    lightWinTreasureRoomTypeId: '轻赢宝房型ID',
    lightWinTreasureProductId: '轻赢宝产品ID',
    pleaseSelectTheEbOrderCancellationSettings: '请选择EB订单取消设置',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually: '自动搬单时，如您未进行房型设置则转为手工搬单',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder: '手动搬单时，将为您优先匹配设置的房型，节省搬单时间',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible: 'EB订单设置完成，请尽快进行',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager: '温馨提示：如您需要设置或新增房型，请联系您的运营经理',
    orderSetupCompletedPleaseProceedAsSoonAsPossible: '订单设置完成，请尽快进行',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo: '您的“携程旅行”EBK账号“未绑定”，将无法进行',
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible: '关联。为避免影响EB搬单，请尽快绑定',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo: '您的“携程旅行”EBK账号“已失效”，将无法进行',
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe: '关联。为避免影响EB搬单，请“解绑”后重新绑定',
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo: '您的“美团网”EBK账号“未绑定”，将无法进行',
    automaticallyCreditedToArAccount: '自动入AR账',
    noticeOfMovingOrderEb: '搬单成功后EB自动接单',
    checkInSuccessNoticeEb: '入住通知',
    meituanMovingOrderDeductsPublicGoods: '美团搬单扣减公益金',
    meituanMovingOrderServiceRate: '美团运营服务费率%',
    yourctripTravelEbkAccounthasExpired: '您的携程旅行EB账号已失效，请点击“去维护”重新设置EB账号”',
    yourmeituanEbkAccounthasExpired: '您的美团网EB账号已失效，请点击“去维护”重新设置EB账号”',
  },
  ebmanagementIndex: {
    accountBinding: '账号绑定',
    commissionRate: '佣金率',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously: '账号绑定成功，并同步开启深度运营',
    whetherToUnbindTheAccount: '是否需解绑账号',
    pleaseEnterTheCommissionRate: '请输入佣金率',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest: '时间维度和筛选的日期一致，预订金额按照客人实际支付金额统计',
    pleaseEnterTheSmsVerificationCode: '请输入短信验证码',
    pleaseEnterTheContentInThePicture: '请输入图片中的内容',
    groggery: '酒店',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: '佣金率大于等于0小于100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces: '佣金率为数字，并保留两位小数',
    pleaseSelectHotel: '请选择酒店',
    pleaseEnterTheImageVerificationCode: '请输入图片验证码',
    accountUntying: '账号解绑',
    unbindSuccessfully: '解绑成功',
    pleaseConfirmTheHotelYouWantToBindTo: '请确认要绑定的酒店',
    noEbAccountHasBeenBound: '暂无绑定任何EB账号',
    ebAccountLogin: 'EB账号登录',
  },
  hardwareBluetoothlock: {
    smartDoorLock: '智能门锁',
    configurationFailure: '配置失败',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience: '此功能专指密码、蓝牙等智能门锁对接，可通过小程序及APP使用密码、蓝牙等方式开门，提升客户入住体验',
  },
  hardwareChoseroom: {
    selectARoom2: '选择房间',
  },
  hardwareCreatepassworddialog: {
    createPassword: '创建密码',
    selectType: '选择类型',
    pleaseEnterAgain: '请再次输入',
    validUntil: '有效期至',
    pleaseEnterA6DigitPassword: '请输入6位数字密码',
    passwordIsDifferentPleaseReEnter: '密码不一致，请重新输入',
    oneTimePassword: '一次性密码',
    timePeriodCipher: '时间段密码',
    offlinePassword: '离线密码',
    longAgingOfflinePassword: '长时效离线密码',
  },
  hardwareEditpassworddialog: {
    oneTimePassword: '一次性密码',
    timePeriodCipher: '时间段密码',
    offlinePasswordForALongTime: '长时间离线密码',
    offlinePassword: '离线密码',
    recover2: '恢复',
    currentPassword: '当前密码',
    pleaseEnterAgain: '请再次输入',
    validUntil: '有效期至',
    pleaseEnterA6DigitPassword: '请输入6位数字密码',
    passwordIsDifferentPleaseReEnter: '密码不一致，请重新输入',
    longAgingOfflinePassword: '长时效离线密码',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow: '会员权益展示，门店活动展示',
    openThePriceBoard: '打开房价牌',
    downloadRateBoard: '下载房价牌',
    failedToConfigureElectronicPriceBoard: '配置电子房价牌失败',
  },
  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox: '当证件类型为身份证时，可通过身份证读卡器读取客人证件信息自动填充到文本框内',
    idCardReader: '身份证读卡器',
    failedToConfigureTheIdCardReader: '配置身份证读卡器失败',
  },
  hardwareLock: {
    doorLockType: '门锁类型',
    selectiveLock: '选择门锁',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom: '确认要删除该房间门锁配置吗',
    pleaseEnterRoomNumberAndEquipmentModel: '请输入房间号、设备型号',
    doorLockCardPrintingRecord: '门锁制卡记录',
    roomDoorLockConfiguration2: '房间门锁配置',
    passwordSetting2: '密码设置',
    deviceType: '设备类型',
    equipmentBrand: '设备品牌',
    equipmentType: '设备型号',
    versionNumber: '版本号',
    roomLockNumber: '房间锁号',
    doorLock: '门锁',
    doorLockPower: '门锁电量',
    editDoorLockConfiguration: '编辑门锁配置',
    selectDevice: '选择设备',
    setTheDoorLock: '设置门锁',
    setTheRoomLockNumber: '设置房间锁号',
    pleaseEnterDoorLock: '请输入门锁',
    settingNmsParameters: '设置网管参数',
    pleaseEnterNetworkManagementParameters: '请输入网管参数',
    traditionalDoorLock: '传统门锁',
    smartDoorLock: '智能门锁',
    pleaseEnterTheLockId: '请输入门锁ID',
    pleaseEnterLockmac: '请输入lockMac',
    batchDelete: '批量删除',
    confirmBatchDeleteText: '确认要批量删除选中的房间门锁配置吗？',
    pleaseSelectRecordsToDelete: '请先选择要删除的记录',
    batchDeleteSuccess: '批量删除成功',
    batchDeleteFail: '批量删除失败',
  },
  hardwareLockpassword: {
    createPassword: '创建密码',
    comeIntoForce: '生效',
    activationCode: '激活码',
    applicableRoom: '适用房间',
    expirationDate3: '有效截止日期',
    theDoorLockThatSupportsThePasswordIsNotEnabled: '未开通支持密码相关的门锁',
    passwordSetting: '密码设置',
    invalidate: '置失效',
    restore: '恢复',
    confirmInvalidatePassword: '确认要将当前密码置失效吗？',
  },
  hardwareLockroom: {
    importTemplateFileName: '门锁导入模版.xlsx',
    downloadSuccess: '门锁导入模版下载成功',
    downloadFail: '门锁导入模版下载失败',
    importDialogTitle: '门锁批量导入',
    roomDoorLockConfiguration: '房间门锁配置',
    customRule: '自定义规则',
    rule: '规则',
    deviceType: '设备类型',
    selectDevice: '选择设备',
    empty: '空',
    selectLock: '选择门锁',
    deviceBrand: '设备品牌',
    deviceModel: '设备型号',
    version: '版本号',
    configurationInfo: '配置信息',
    selectRoom: '选择房间',
    lockDeviceId: '门锁设备ID',
    remainingPower: '剩余电量',
    remoteOpenDoorType: '远程开门方式',
    gatewayOpen: '网关开门',
    bluetoothOpen: '蓝牙开门',
    rule1: '锁号 = 房间号',
    rule2Prefix: '锁号 =',
    rule3Prefix: '锁号 =',
    trimRoomNumber: '去掉首位的房间号',
    import: '导入',
    clickUpload: '点击上传',
    imported: '已导入',
    rulePrefix: '规则：',
    generateLockId: '生成锁号',
    lockIdLabel: '门锁ID',
    roomLockNumberLabel: '房间锁号',
    enterRoomLockNumber: '请输入房间锁号',
    enterLockId: '请输入门锁ID',
    gatewayParams: '网关参数',
    enterGatewayParams: '请输入网关参数',
    enterLockMac: '请输入 lockMac',
    getFreeGoLock: '获取 FreeGo 门锁',
  },
  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure: '此功能专指碰卡门锁对接，可通过PMS制作宾客的房卡，提升办理入住的效率',
    traditionalDoorLock: '传统门锁',
    doorLockInformationConfiguration2: '门锁信息配置',
    functionCardManagement2: '功能卡管理',
    failedToConfigureATraditionalDoorLock: '配置传统门锁失败',
  },
  hardwarePricecard: {
    full: '满',
    serviceHotline: '服务热线',
    downloadRateBoard: '下载房价牌',
  },
  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: '自助机支付配置',
    depositAllocationCollection: '押金配置收取',
    orderRetentionTimeConfiguration: '订单保留时间配置',
    whetherTheUnpaidOrderIsCancelledImmediately: '未支付订单是否立即取消',
    minutes: '分钟',
    checkOutArrangement: '离店配置',
    checkOutAccountingConfiguration: '退房账务配置',
    temporaryCheckOut: '临时挂账退房',
    checkOut2: '结账退房',
    autoAddRoomFeeConfig: '自动加收房费配置',
    whetherToEnableAutoAddRoomFee: '是否启用自动加收房费',
    occupancyConfiguration: '入住配置',
    whetherToSupportHourRoomWithoutReservation: '是否支持钟点房无预订入住',
    supportForTimePeriodsWithoutReservation: '支持钟点房无预订入住的时间段',
    theSelfServiceMachineIsSuccessfullyConfigured: '自助机配置成功',
    selfServiceMachineConfiguration2: '自助机配置',
    pleaseFillInTheDepositConfiguration: '请填写押金配置',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked: '请选择钟点房无预订入住的时间段',
  },
  hardwareSelfservice: {
    selfServiceMachine: '自助机',
    selfServiceMachineConfiguration2: '自助机配置',
    failedToConfigureTheSelfServiceMachine: '配置自助机失败',
    thereIsNoSelfServiceMachineInTheHotel: '酒店暂未配置自助机',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch: '此开关为开通自助机与PMS系统的接口开关，若酒店需对接自助入住机，需打开开关',
  },
  hardwareSetWitness: {
    "title": "人证刷脸设备",
    "desc": "人证刷脸，自助入住",
    "setting": "设置",
    "configSuccess": "开启人证配置成功",
    "configClose": "关闭人证配置成功",
    "configFailed": "配置失败"
  },
  hardwareWitness: {
    "deviceSnSetting": "设备编码设置",
    "deviceSn": "设备SN",
    "addSn": "新增SN",
    "enterSn": "请输入SN",
    "addSnBtn": "+ 新增SN",
    "saveSuccess": "保存成功",
    "deleteSuccess": "删除成功",
    "snRepeatError": "SN不能重复",
    "deleteConfirmMsg": "确认删除该设备SN吗？",
    "deleteConfirmTitle": "提示",
  },

  hardwareSethouserpricecard: {
    transversePlate: '横板',
    verticalVersion: '竖版',
    addPictureUpload: '添加图片上传',
    show: '展示',
    doNotShow: '不展示',
    format: '版式',
    storePicture: '门店图片',
    pleaseEnterADescription: '请输入描述',
    hourRoomRates: '钟点房价格',
    pleaseSelectTheNumberOfHours: '请选择小时数',
    whetherToDisplayMemberPrices: '是否展示会员价格',
    roomReservationPhone: '订房电话',
    pleaseEnterTheReservationNumber: '请输入订房电话',
    bookingGuide: '预订引导文案',
    pleaseEnterThePreOrderGuideCopy: '请输入预定引导文案',
    hotelAnnouncement: '酒店公告',
    pleaseEnterTheHotelBulletin: '请输入酒店公告',
    uploadedPictures: '已上传图片',
    storePicturesMustBeUploaded: '门店图片必传',
    onlyJpgjepgpngFormatIsSupported: '仅支持jpg jepg png格式!',
  },
  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: '挂失之前的授权卡',
    authorizationCard: '授权卡',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess: "一般情况下，只需要在锁上刷授权卡，门锁发出'滴滴'两声表示授权成功",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock: '当门锁的房号或时间信息丢失，可用房号设置卡或时钟设置卡来设置门锁；或者连续刷3次授权卡，再用此房间客人卡开门即可',
  },
  functionalcardExtendssetting: {
    after: '后',
    inMinutes: '分钟内',
    findRoomNumber: '查找房号',
    timeDeviation: '时间偏差',
    roomNumberRequired: '房号必填',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock: '当门锁的房号或时间信息丢失，可用房号设置卡或时钟设置卡来设置门锁；或者连续刷3次授权卡，再用此房间客人卡开门即可',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess: "一般情况下，只需要在锁上刷授权卡，门锁发出'滴滴'两声表示授权成功",
  },
  functionalcardIndex: {
    selectiveClassification: '选择分类',
    functionCardManagement2: '功能卡管理',
    authorizationCard: '授权卡',
    extendedSettingsClass: '扩展设置类',
    openCategory: '开门类',
    specificFunctionClass: '特定功能类',
    businessCardFailure: '制卡失败',
  },
  functionalcardOpendoor: {
    beforeTheLossWasReported: '挂失之前的',
    publicDoorsCanBeOpened: '可以开启公共门',
    canOpenTheLock: '可以开反锁',
    availablePeriod: '可用时段',
    startTimeRequired: '开始时间必填',
    theEndTimeIsRequired: '结束时间必填',
    floorFill: '楼层必填',
    theFloorMustConsistOf4PureDigits: '楼层必须为4位纯数字组成',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding: '层控卡：用于开启某个楼栋中的某一层的所有门锁',
    totalCardCanOpenAllLocksInThisSystem: '总卡：可以开启本系统的所有门锁',
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: '挂失之前的退房卡',
    theMissingCardNumber: '遗失的卡号',
    pleaseEnterTheCardNumberToFind: '请输入卡号查找',
    theLostCardNumberIsRequired: '遗失的卡号必填',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard: '挂失卡：如果某张卡遗失了，可以挂失此卡，输入选择遗失的卡号，制一张挂失卡，到遗失卡能开门的门锁上刷一遍',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard: '退房卡：给服务员用的，一般来说，服务员有两张卡，一张是层控卡，用于开门，另一张是退房卡，在客人通知退房，服务员查完房后，在门锁上刷一下退房卡，此前的客人卡就不能开门了，不影响新发的客人卡',
  },
  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure: '门锁信息初始化成功',
    afterEnteringTheCardManagement: '后进入卡管理',
    performTheInitialConfigurationOfDoorLockInformationFirst: '请先进行门锁信息初始化配置',
    hardwareDeviceType: '硬件设备类型',
    hardwareBrand: '硬件品牌',
    configurationInformation: '配置信息',
    thisParameterIsMandatory: '配置信息必填',
    initialConfiguration: '初始化配置',
    doorLockInformationConfiguration2: '门锁信息配置',
    theDoorLockInformationIsConfiguredSuccessfully: '门锁信息配置成功',
    configurationFailure: '配置失败',
  },
  hotelBaseInfo: {
    basicInformation3: '基本信息',
    detailedInformation: '详细信息',
    hotelFacilitiesAndServices: '酒店设施及服务',
    hotelPoliciesAndNotices: '酒店政策与通知',
  },
  hotelFloor: {
    floorInformationToBeDeveloped: '楼层信息,待开发',
  },
  hotelPicture: {
    acquiesce: '默认',
    theLatestTime: '时间最近',
    theFarthestTime: '时间最远',
    batchDeletion: '批量删除',
    undelete: '取消删除',
    cover: '封面',
    firstMap: '首图',
    setAsHotelCover: '设为酒店封面',
    noPictureInformationIsAvailable: '暂无图片信息',
    submit2: '提 交',
    photoEditor: '图片编辑',
    setAsTheFirstPictureOfTheRoomType: '设为房型首图',
    recentRevision: '最近修改',
    appearance: '外观',
    guestRoom: '客房',
    publicFacilities: '公共设施',
    catering: '餐饮',
    surroundingEnvironment: '周边环境',
    theCoverImageAndFirstImageCannotBeDeletedDirectly: '封面图、首图不可直接删除',
    areYouSureToDeleteThePicture: '确定删除图片吗',
    operate: '运营',
    pleaseSelectAtLeastOnePicture: '请至少选择一张图片',
    pleaseSelectCategory: '请选择分类',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting: '请上传图片成功后再提交',
    imagesCannotBeUploadedInBatchEditingMode: '批量编辑状态下不可上传图片',
    logoOnlyOne: 'Logo 只能上传一张图片',
    logoSizeLimit: 'Logo 图片大小不能超过 500KB',
    logoRatioError: 'Logo 必须为 1:1 的正方形图片，当前尺寸为 {width}×{height}',
  },
  assemblyModifyinventoryprice: {
    unlimitedInventory: '不限库存',
    stockLimit: '限库存',
    modifiedPricePool: '修改价库',
    soldInventory: '已售库存',
  },
  hotelPreview: {
    viewPicture: '查看图片',
  },
  hotelRoomType: {
    batchImportRoomType: '房型批量导入',
    importTemplateFileName: '房型导入模版.xlsx',
    downloadSuccess: '房型导入模版下载成功',
    downloadFail: '房型导入模版下载失败',
    newHousingType: '新建房型',
    partialWindow: '部分窗',
    skylight: '天窗',
    closedWindow: '封闭窗',
    bayWindow: '飘窗',
    hotelCode: '酒店编码',
    roomTypeCode: '房型编码',
    externalRoomTypeCode2: '外部房型编码',
    whetherToSellOnline: '是否在线售卖',
    bedType2: '床型',
  },
  hotelRoom: {
    newRoom: '新建房间',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate: '请按照模版中的要求整理房间信息',
    downloadTemplate: '下载模版',
    downloadFailureData: '下载失败数据',
    batchImport: '批量导入',
    floor2: '所在楼层',
    building: '所在楼栋',
    housingType: '所属房型',
    faceEast: '朝东',
    faceWest: '朝西',
    faceSouth: '朝南',
    faceNorth: '朝北',
    stayAwayFromElevators: '远离电梯',
    nearTheStairs: '靠近楼梯',
    closeToTheRoad: '靠近马路',
    windowWall: '窗外墙体',
    decorativeFalseWindow: '装饰性假窗',
    theRoomNumberCannotBeEmpty: '房间号不能为空',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty: '房间所在楼层不能为空',
    theRoomTypeCannotBeEmpty: '房间所属房型不能为空',
    editSuccessfully: '编辑成功',
    newSuccess: '新增成功',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty: '所属房型及名称不能为空所在楼层不能为空',
    currentLimitSelect1FilePleaseRemoveAndAdd: '当前限制选择 1 个文件,请移除再添加',
    definitiveRemoval: '确定移除',
    abnormalDataInformationTemplate: '异常数据信息模板',
    xlsFormatOnly: '仅支持XLS格式文件',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt: '删除房间后数据无法恢复，是否确定删除',
  },
  hotelTypedetail: {
    newHousingType: '新建房型',
    editRoomType: '编辑房型',
    viewRoomType: '查看房型',
    basicInformation3: '基本信息',
    squareMeter: '平方米',
    bedSize: '床型尺寸',
    extraBedCondition: '加床情况',
    internetAccess: '上网情况',
    roomTypeFacilities: '房型设施',
    roomTypeStatus: '房型状态',
    saveAndSubmit: '保存并提交',
    roomTypeNameAMaximumOf50Characters: '房型名称最多输入50个字符',
    floorArea: '建筑面积',
    roomTypeEnglishName: '房型英文名称',
    floorType: '所在楼层类型',
    floor2: '所在楼层',
    pleaseEnter1511: '请输入-1,5,11',
    chineseRemarks: '中文备注',
    capacity: '可容纳人数',
    englishRemarks: '英文备注',
    externalRoomTypeCode2: '外部房型编码',
    extraBed: '加床',
    internetAccess2: '能否上网',
    roomInternetInformation: '房间上网信息',
    broadbandTariff: '宽带资费',
    disposableToiletries: '一次性洗漱用品',
    bathroomType: '卫生间类型',
    numberOfToilets: '卫生间数量',
    computer: '电脑',
    showerRoom: '洗浴间',
    smokeFreeInformation: '无烟信息',
    bathroom: '卫浴',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits: '请输入不超过两位的整数',
    pleaseEnterAnIntegerGreaterThan0: '请输入大于0的整数',
    dataDuplicationPleaseConfirm: '数据重复请确认',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500: '请输入三位整数且不超过500的值',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters: '最多输入两位小数，不超过6个字符长度',
    pleaseEnterBuildingArea: '请输入建筑面积',
    pleaseEnterTheCapacity: '请输入可容纳人数',
    pleaseEnterAnIntegerOfUpToTwoDigits: '请输入不超过两位整数',
    roomTypeNameCannotBeEmpty: '房型名称不能为空',
    roomTypeNameCannotExceed50Characters: '房型名称长度不能超过50个字符',
    theLengthCannotExceed30Characters: '长度不超过30个字符',
    theTotalNumberOfRoomsCannotBeEmpty: '房间总数不能为空',
    theLengthCannotExceed60Characters: '长度不超过60个字符',
    pleaseSelectBedSize: '请选择床型尺寸',
    pleaseSelectWindowType: '请选择窗型',
    pleaseSelectRoomTypeStatus: '请选择房型状态',
    pleaseSelectExtraBedCondition: '请选择加床情况',
    pleaseSelectWhetherYouCanAccessTheInternet: '请选择能否上网',
    pleaseSelectAPhone: '请选择电话',
    pleaseSelectDisposableToiletries: '请选择一次性洗漱用品',
    pleaseSelectABathroomType: '请选择卫生间类型',
    pleaseSelectTheNumberOfBathrooms: '请选择卫生间数量',
    pleaseSelectComputer: '请选择电脑',
    pleaseSelectABathRoom: '请选择洗浴间',
    pleaseSelectSmokeFreeInformation: '请选择无烟信息',
    pleaseSelectOther: '请选择其他',
    pleaseSelectBathroom: '请选择卫浴',
    commonFloor: '普通楼层',
    executiveFloor: '行政楼层',
    businessFloor: '商务楼层',
    noExtraBed: '不可加床',
    freeExtraBed: '免费加床',
    payExtraBed: '付费加床',
    haveInternetAccess: '可以上网',
    someInternetAccess: '部分可以上网',
    noInternetAccess: '不能上网',
    freeWireless: '免费无线',
    tollWireless: '收费无线',
    freeWire: '免费有线',
    tollWire: '收费有线',
    nationalTollCall: '国内长途电话',
    internationalCall: '国际长途电话',
    freeDomesticLongDistanceCalls: '免费国内长途电话',
    disposableToiletriesAreNotProvided: '不提供一次性洗漱用品',
    disposableToiletriesAreProvidedForFree: '免费提供一次性洗漱用品',
    disposableToiletriesAreProvidedForAFee: '收费提供一次性洗漱用品',
    indoor: '室内',
    commonality: '公共',
    aroom: '一间',
    twoRooms: '两间',
    moreThanTwoRooms: '两间以上',
    allRoomsChargeComputers: '全部房间收费电脑',
    freeComputersInAllRooms: '全部房间免费电脑',
    freeComputersInSomeRooms: '部分房间免费电脑',
    nonSmokingRoomsAreNotAvailable: '不可提供无烟房',
    nonSmokingRoomsAvailable: '可提供无烟房',
    noSmoking: '不可吸烟',
    partialWindow: '部分窗',
    skylight: '天窗',
    closedWindow: '封闭窗',
    bayWindow: '飘窗',
    roomTypeNameAndBedSizeAreUnderReview: '房型名称、床型尺寸进入审核中',
    roomTypeAddedSuccessfully: '房型添加成功',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered: '长度不超过7个字符,只允许输入数字.-',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters: '请输入整数，并保证合法性：如3平方米-5平方米',
    personbed: '人/间',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: '账号、员工姓名',
    staffPosition: '员工岗位',
    createAnAccount: '新建',
    employeeName: '员工姓名',
    employeeRole: '员工角色',
    confirmTo: '确认要',
    user: '用户',
    areYouSureYouWantToDeleteThisUser: '确认要删除该用户吗',
    isThisMaterial: '该物料吗',
  },
  managementRoleList: {
    enterARoleName: '角色名称',
    newRole: '新增',
    roleName: '角色名称',
    roleDescription: '角色描述',
    editorRole: '编辑角色',
    modifyPermission: '修改权限',
    deletingARole: '删除角色',
    areYouSureYouWantToDeleteThisRole: '确认要删除该角色吗',
  },
  componentsCreateaneditingrole: {
    roleName: '角色名称',
    roleDescription: '角色描述',
    standardPostBased: '基于标准岗位',
    limitsOfAuthority: '权限',
    pleaseEnterARoleName: '角色名称',
    modifyRole: '修改角色',
    newRole: '新增',
    succeededInModifyingTheRole: '修改角色成功',
    creatingTheRoleSucceeded: '创建角色成功',
  },
  componentsPopupeditingpermission: {
    editPermission: '编辑权限',
  },
  componentsUpdatematerial: {
    staffPosition: '员工岗位',
    employeeRole: '员工角色',
    thePhoneNumberCannotBeEmpty: '手机号不能为空',
    pleaseEnterYourConfirmationPassword: '请输入确认密码',
    pleaseEnterEmployeeName: '请输入员工姓名',
    pleaseSelectEmployeeStatus: '请选择员工状态',
    pleaseSelectAnEmployeePosition: '请选择员工岗位',
    modifyAccount: '修改账号',
    viewInformation: '查看信息',
    addAnAccount: '新增账号',
    theTwoPasswordEntriesAreDifferent: '两次密码输入不相同',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation: '修改物品信息会影响已入库的商品信息，请谨慎操作',
    materialUnit: '规格单位',
    pleaseSelectTheMaterialType: '请选择物品类型',
    pleaseFillInTheMaterialName: '请填写物品名称',
    pleaseSelectMaterialUnit: '请选择物品规格',
    modifyMaterial: '修改物品',
    newMaterial2: '新增物品',
    materialModificationSucceeded: '修改物品成功',
    newMaterialSuccessfully: '新建物品成功',
    pleaseEnterTheCorrectPhoneNumber3: '请输入正确账号',
  },
  smallwareMaterial: {
    newMaterial: '新增',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse: '当前物品下有库存，不支持删除物品，请出库后再删除',
    areYouSureYouWantToDeleteThisMaterial: '确认要删除该物品吗',
    confirmTo: '确认要',
    isThisMaterial: '该物品吗',
  },
  smallwareRealtimestock: {
    saleStatus: '售卖状态',
    exportedInventory: '导出',
    resumptionOfSale: '恢复售卖',
    banOnSale: '禁售',
    averagePurchasePriceyuan: '进货均价(元)',
    sellingPriceyuan: '售卖单价(元)',
    unmarketable: '不可销售',
    vendibility: '可销售',
    exportFileName: '实时库存列表',
    areYouSureYouWantToStopSellingThisMaterial: '确认要停售该物品吗',
    successfulClosure: '停售成功',
    successfulResumptionOfSale: '恢复售卖成功',
  },
  smallwareStockshift: {
    undoSuccessfully: '撤销成功',
    outboundTime: '出库时间',
    newDelivery2: '新增',
    outboundMode: '出库方式',
    theNumberOfTheWarehouseReceipt: '出库单编码',
    deliveryFromStorage: '出库',
    cancel: '撤销',
    exportFileList: '出库文件导出列表',
    doYouConfirmTheCancellation: '确认撤销吗',
  },
  smallwareStockunshift: {
    warehousingTime: '入库时间',
    newStorage: '新增',
    theCodeOfTheEntrySlip: '入库单编码',
    purchasePriceyuan: '进货单价(元)',
    importFileExportList: '入库文件导出列表',
  },
  componentsAddnewstock: {
    adjustableQuantity: '可冲调数量',
    purchasePrice: '进货单价',
    whetherToSell: '是否售卖',
    unitSellingPrice: '售卖单价',
    pleaseFillInTheUnitPrice: '请填写售卖单价',
    pleaseFillInTheQuantityOfStorage: '请填写入库数量',
    pleaseSelectTheMaterialType: '请选择物品类型',
    pleaseSelectAMaterialName: '请选择物品名称',
    modifiedEntry: '修改入库',
    newStorage: '新增',
    createdSuccessfully2: '创建成功',
    theStorageQuantityCannotBe: '入库数量不能为',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity: '修改后的数量不能小于已产生的消耗数量',
  },
  componentsAddoutstock: {
    selected: '已选择',
    newDelivery2: '新增',
    pleaseSelectOutgoingMaterials: '请选择出库物品',
    pleaseSelectTheMaterialToBeShippedOut: '请选择要出库的物品',
    successfulDelivery: '出库成功',
  },
  componentsSellricedialog: {
    unitSellingPrice: '售卖单价',
    pleaseFillInThePrice: '请填写价格',
  },
  systemsetBase: {
    requireIdNumberEnabled: '必需输入证件号功能已成功开启',
    requireIdNumberDisabled: '必需输入证件号功能已成功关闭',
    requireIdNumberForCheckin: '办理入住是否输入证件号',
    enableAutomaticDepositRefund: '开启自动退押金',
    refundImmediatelyAfterCheckOut: '客人操作退房后立即退',
    refundAfter: '客人退房后',
    hoursAutoRefund: '小时自动退',
    pleaseEnterDelayRefundHours: '请输入延迟退押金时间',
    delayRefundHoursRangeError: '延迟退押金时间不能小于1小时，不能大于48小时',
    depositConfigSuccess: '入住押金配置成功',
    tempMakeCardEnabled: '临时制卡是否开启',
    tempMakeCardEnabledSuccess: '已开启临时制卡',
    tempMakeCardDisabledSuccess: '已关闭临时制卡',
    hideCheckInRegisterRoomPrice: '入住登记单隐藏房价',
    hideCheckInRegisterRoomPriceEnabledSuccess: '已开启入住登记单隐藏房价',
    hideCheckInRegisterRoomPriceDisabledSuccess: '已关闭入住登记单隐藏房价',
    weeHours: '凌晨',
    shiftPattern: '交班模式',
    messageVoiceReminder: '消息语音提醒',
    directConnectionSingleSettings: '直连接单设置',
    automaticHouseSetting: '自动排房设置',
    sameDayAdvanceOrders: '当日预抵订单',
    allOrders: '所有订单',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod: '未排房订单自动排房时间段',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted: '该时间段内会自动将未排房订单执行自动排房',
    inventorySyncSetup: '库存同步设置',
    orderSynchronizationSettings: '订单同步设置',
    nightAuditSetup: '夜审设置',
    nightTrialMethod: '夜审方式',
    manualOperation: '手动',
    auto: '自动',
    storeOrdersHaveNotArrived: '门店订单预抵未到',
    preArrivalDepartureHandle: '预抵预离订单处理',
    preArrivalDepartureHandleTip: '设置预抵订单和预离订单的自动处理方式，夜审时系统将根据配置自动执行相应操作',
    preArrivalHandle: '预抵订单处理',
    preDepartureHandle: '预离订单处理',
    noHandle: '不处理',
    autoCheckIn: '自动办理入住',
    autoNoshow: '自动noshow',
    autoCheckOut: '自动退房',
    autoExtendStay: '自动续住',
    autoSkip: '自动跳过',
    shiftSetting: '班次设置',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay: '班次时间不允许有重叠，总时间区间必须覆盖全天24小时',
    morningShiftSetting: '凌晨班次设置',
    shiftReportimprestMode: '交班报表（备用金模式)',
    hourRoomCheckOutMessage: '钟点房退房消息',
    fullDayCheckOutMessage: '全日房退房消息',
    onlineChannelNewOrderAlerts: '线上渠道新订单提醒',
    onlineChannelOrderCancellationAlerts: '线上渠道订单取消提醒',
    hourCheckOutReminder: '钟点房退房提醒',
    fullDayCheckOutReminder: '全日房退房提醒',
    automaticOrderSettingWhenOversold: '超售时自动接单设置',
    hourRoomAutomaticOrderSetting: '钟点房自动接单设置',
    automaticRowHouseConfiguration: '自动排房房态',
    automaticHouseRules: '自动排房规则',
    supportBillingTypes: '支持开票类型',
    '30MinutesBeforeCheckOut': '退房前30分钟',
    '15MinutesBeforeCheckOut': '退房前15分钟',
    atCheckOut: '退房时',
    pleaseEnterTheTime: '请输入时间',
    automaticCancellation: '自动取消',
    manualCancellation3: '手动取消',
    automaticOverbookingSetReminders: '超售自动接单设置提醒',
    hourRoomAutomaticOrderSettingReminder: '钟点房自动接单设置提醒',
    autoEnterArAccountText: '直连订单自动入AR账',
    pleaseSelectABusinessDay: '请选择营业日',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit: '操作成功，请手动触发夜审',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame: '凌晨班开始结束时间不能相同',
    earlyMorningWatch: '凌晨班',
    theAutomaticRowHouseIsSetSuccessfully: '自动排房设置成功',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull: '满房后自动关闭eb房态',
    supportSwitchOrderSynchronization: '支持switch订单同步',
    inventoryAutomaticSynchronizationSystemInventory: '库存自动同步系统库存',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation: '预离订单续住优先级高于预抵订单入住，如果系统自动办理入住没有空房则自动NoShow，如果系统自动续住没有空房则自动退房',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing: '预离订单续住优先级高于预抵订单入住，如果系统自动办理入住没有空房则自动NoShow，如果系统自动续住没有空房则自动退房',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff: '满房后自动关闭eb房态开关设置保存',
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved: '库存自动同步系统库存开关设置保存',
    atLeastOneMessageReminderSettingMustBeSelected: '消息提醒设置至少选择一项',
    closeturnOnToAutomaticallySortRoomsAtNight: '关闭 (开启后新订单全天自动排房)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations: '跨营业日班次，可单独设置凌晨班，方便班次账务统计。凌晨班不参与正常班次时间计算',
    dailyPredeparture: '当日预离',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving: '酒店支持同步switch订单渠道设置保存',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay: '夜审时间必须为21:00到次日08:00之间',
    theScheduleNeedsToCover24HoursADayPleaseReset: '班次时间需覆盖全天24小时，请重新设置',
    showMemberRechargeAmount: '交班报表是否展示会员充值金额',
    splitDeposit: '交接班报表是否拆分押金',
    splitArAccount: '交接班报表是否拆分AR账',
    allowTimeConflict: '排房允许时间冲突',
    selfCheckInDepositSetting: '自助入住押金设置',
    depositConfig: '收押金配置',
    defaultDepositAmount: '默认押金金额',
    defaultDepositError: '入住押金默认值输入错误，请重新输入',
    roomDepositError: '房型“{roomName}”设置错误，请重新设置',
    additionalRoomFeeSetting: '加收房费设置',
    fulldayAddFeeRule: '全日房加收房费规则',
    fulldayAddFeeType: '全日房加收房费类型',
    memberRechargeSetting: '会员储值收款设置',
    noVerificationPayment: '免验证码支付',
    enforceAdditionalRoomCharge: '后强制加收房费',
    manualAdditionalRoomFee: '手工加收房费',
    halfDayAdditionalRoomFee: '加收半日房费',
    fullDayAdditionalRoomFee: '加收全日房费',
    popUpMethodSetting: '新页面打开方式',
    newTab: '打开新页签',
    originalTabRedirection: '原页签跳转',
    popupNotification: '弹窗',
    sidebar: '右侧抽屉',
    morningOrderCheckInAddFee: '凌晨房入住是否加收房费',
    morningOrderAddFeeEnabled: '已开启凌晨房入住加收房费',
    morningOrderAddFeeDisabled: '已关闭凌晨房入住加收房费',
    breakfastReportCtrl: '早餐报表统计规则',
    repotShowByUserNums: '按实际入住人数统计',
    repotShowByProductNums: '按房间包含早餐数统计',
    breakfastReportCtrlSuccessByUserNums: '早餐报表统计规则已设置为「按实际入住人数统计」',
    breakfastReportCtrlSuccessByProductNums: '早餐报表统计规则已设置为「按房间包含早餐数统计」'
  },
  systemsetConditionConfig: {
    unspaced: '不分行排列',
    arrangeByFloorBranch: '按楼层分行排列',
    lineUpByRoomType: '按房型分行排列',
    theSizeOfTheCell: '房态格大小',
    small: '小',
    inThe: '中',
    big: '大',
    wide: '宽',
    high: '高',
    custom: '自定义',
    roomTypeFont: '房型字体',
    size: '大小',
    colour: '颜色',
    roomNumberFont: '房号字体',
    whetherFullGuestNamesAreDisplayed: '是否显示完整客人姓名',
    alreadyRowHouseStatusDisplayContent: '已排房房态显示内容',
    alreadyRowHouseStatusDetailsDisplayContent: '已排房房态详情显示内容',
    noRowRoomStatusDetailsDisplayContent: '未排房房态详情显示内容',
    arrearsIncludeToday: '欠费是否计算当日待生成房费',
    bedType2: '床型',
    restoreDefault: '恢复默认',
    roomDiagramArrangement: '房态图排列方式',
    theAppletTakesEffectAtTheSameTime: '小程序同时生效',
    cellColor: '房态格颜色',
    unarrangedRoomStatusContent: '未排房房态显示内容',
    powerSwitch: '取电器',
    roomBalance: '房间余额',
    depositAmount: '押金金额',
  },
  systemsetConfiguration: {
    changePriceRangeSettings: '改价范围设置',
    revaluationRange: '改价范围',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed: '系统会根据每个房型近30天的平均价判断是否超过改价范围，超过改价范围后将会进入改价审核，审核后价格才会生效。1小时内未处理改价申请系统自动驳回改价',
  },
  systemsetLog: {
    operationRecord: '操作记录',
  },
  systemsetPrint: {
    documentType: '单据类型',
    paperSize: '纸张规格',
    typeSize: '字号',
    printingMode: '打印方式',
    noticeToGuests: '宾客须知',
  },
  systemsetTarget: {
    monthlyGoalSetting: '月目标设定',
    goal: '目标',
    goalAchievementRate: '目标达成率',
    intertargetNight: '目标间夜',
    targetOccupancyRate: '目标出租率',
    recommendedTargetValue: '建议目标值',
    actualAchievement: '实际达成',
    reachedLastMonth: '上月达成',
    theSamePeriodLastYear: '去年同期',
    commitFailure: '提交失败',
  },
  systemsetWarning: {
    earningsWarning: '收益达成预警',
    dailyWarning: '日常预警',
  },
  systemsetWifi: {
    commonality: '公共',
    batchModification: '批量修改',
    pleaseCompleteTheWiFiAccountPassword: '请填写完整Wi-Fi账号密码',
    pleaseEnterAValidWifiName: '请输入有效的WiFi名称',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn: '无密码或手机验证的WiFi无需填写',
    pleaseFillInTheWiFiAccount: '请填写Wi-Fi账号',
    roomWifiSettings: '房间WiFi设置',
    wifiName: 'WiFi名称',
    wifiPassword: 'WiFi密码',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: '绑定可用产品',
    bindAtLeastOneProduct: '至少绑定一个产品',
  },
  componentsWarning: {
    byTheMonth: '每月',
    achievedOnDays: '日 达成',
    below: '以下',
    viewRemainingConditions: '查看剩余条件',
    newEarlyWarningItems: '新增预警项目',
    achieved: '达成',
    additionalCondition: '增加条件',
    internightMoonTargetReachWarning: '间夜月目标达成预警',
    earlyWarningOfMonthlyTargetOfRentalRate: '出租率月目标达成预警',
    surplusRoom: '剩余房量',
    pointScoring: '点评分',
    gmvMonthlyTargetWarning: 'GMV月目标达成率预警',
    revparMonthlyTargetWarning: 'RevPAR月目标达成率预警',
  },
  componentsWarningday: {
    overallHotel: '酒店整体',
    everyday: '每日',
    theDayBefore: '前一日',
    viewRemainingConditions: '查看剩余条件',
    newEarlyWarningItems: '新增预警项目',
    additionalCondition: '增加条件',
    lessThan: '小于',
    greaterThan: '大于',
    pointScoring: '点评分',
    surplusRoom: '剩余房量',
  },
  payLehuipaySetting: {
    youHaveNotOpenedOnlinePayment: '您还未开通线上支付',
    contactOperationOrTechnicalSupportToEnableTheService: '请联系运营或技术支持进行开通',
    lehuiPay: '乐惠支付',
    download: '下载',
    inquire: '查询',
    withdraw: '提现',
    withdrawalRecord: '提现记录',
    billDownload: '账单下载',
    accountBalanceInquiry: '账户余额查询',
    theWithdrawalAmountIsRequired: '提现金额必填',
    theAmountRangeIs: '金额填写范围为',
    doYouWantToChangeThePaymentMethod: '确认要修改支付方式吗',
    modifyingThePaymentModeSucceeded: '修改支付方式成功',
    pleaseFillInTheWithdrawalAmount: '请填写提现金额',
    ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan: '提现失败，提现金额不能小于10元',
  },
  foodLogin: {
    cashierSystem: '餐饮收银系统',
    shopSystem: '餐饮商户系统',
    pleaseEnterYourAccount: '请输入账号',
    noFoodSystemPermission: '您没有{system}权限',
    systemConfigurationError: '系统配置错误，请联系技术支持',
    loginFailed: '登录失败，请稍后再试',
  },
  loginIndex: {
    hotelManagementSystem: '酒店管理系统',
    qrCodeExpired: '二维码过期',
    pleaseClickRefresh: '请点击刷新',
    openWechatScanTheQrCode: '打开微信，扫描二维码',
    customerServiceNumber: '客服电话',
    theAccountOrPasswordYouEnteredIsIncorrect: '您输入的账号或密码不正确',
    forgotPassword: '忘记密码',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes: '验证码已发送至您的手机，5分钟内有效',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes: '输入8-20位，字母、数字和符号两种以上的组合',
    submit2: '提 交',
    loginPasswordUpdateSuccessful: '登录密码更新成功',
    reLogin: '重新登陆',
    bind: '绑定',
    findPassword: '找回密码',
    pleaseEnterTheVerificationCode: '请输入验证码',
    mobilePhoneSmsVerificationCode: '手机短信验证码',
    pleaseEnterTheMobilePhoneVerificationCode: '请输入手机验证码',
    pleaseVerifyTheNewPassword: '请验证新密码',
    bindWechat: '绑定微信',
    pleaseEnterTheLoginPassword: '请输入登录密码',
    theTwoPasswordsEnteredAreInconsistent: '两次输入密码不一致',
    pleaseEnterTheVerificationCode3: '请输入图形验证码',
    loggingIn: '正在登录',
    acquire: '获取',
    resendVerificationCode: '重新发送验证码',
    loginNow: '立即登录',
    currentPhoneNumber: '当前手机号',
    changeSuccessful: '更改成功',
    afterReGetting: '后重新获取',
    pleaseEnterCorrectAccount: '请输入正确的账号',
  },
  accountIndex: {
    scope: '应用范围',
    confirmDelete: '确定要删除该账套吗？',
    onlyDeleteDisabled: '只能删除禁用状态的账套',
    cancelDelete: '已取消删除',
  },
  accountsetMember: {
    accountSubject: '账套科目',
    addCash: '添加现付账',
    roomAccount: '挂房账',
    pleaseEnterTheExternalOrderNumber: '请输入外部单号',
    consumptionStatement: '消费结账单',
    submitted: '已提交',
    pleaseFillInTheAmountSpent: '请填写消费金额',
    theAmountSpentMustBeGreaterThan: '消费金额必须大于',
    blanked: '已冲',
    pleaseFillInTheRoomAccount: '请填写是否挂房账',
    pleaseSelectAnAccount: '请选择账号',
    pleaseSelectASmallItem: '请选择小商品',
    newSuccess: '新增成功',
    goAndCheck: '去查看',
  },
  pcncomponentRoomtypesortingcomponent: {
    roomTypeRanking: '房型排序',
  },
  activitySelfHelp: {
    selfHelpPromotionDescription: '自助促销说明',
    promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent: '促销优惠全部由商家承担，不同渠道结算方式不同',
    inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant: '若发生虚假促销，后果由商家承担',
    onceCreatedThePromotionWillTakeEffectAcrossAllChannels: '促销创建成功后会在所有渠道生效',
    promotionType: '促销类型',
    promotionalProduct: '促销产品',
    effectiveChannel: '生效渠道',
    promotionStatus: '促销状态',
    noRegistrationIsAvailable: '暂无可报名活动',
    dailySpecial: '天天特价',
    tonightSpecial: '今夜特价',
    firstStayDiscount: '首住折扣',
    travelSpecial: '出行特惠',
    festivalCoverage: '节日覆盖',
    studentOnly: '学生专享',
    batchOffLine: '批量下线',
    thereAreNoRegisteredActivities: '暂无已报名活动',
    thereAreNoCanceledEvents: '暂无已取消活动',
    pleaseSelectThePostPromotionOperationBatchOfflineFeature: '请选择促销后操作批量下线功能',
    massMerchantsSelfPromotionOffline: '批量商家自促下线',
    allChannels: '全部渠道',
  },
  componentsPrintsettingdialog: {
    previewEditing: '预览编辑',
    printTheFullIdNumber: '打印完整证件号',
    printGuestAddress: '打印客人地址',
    printPaymentInformation: '打印付款信息',
    modifySettings: '修改设置',
    documentType: '单据类型',
    paperSize: '纸张规格',
    typeSize: '字号',
    printingMode: '打印方式',
    noticeToGuests: '宾客须知',
    thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords: '打印时该内容会显示在单据上，请填写后务必进行打印测试，避免因行数或字数过多影响显示效果',
    defaultPrint: '默认打印',
    manualSelection: '人工选择',
    standard: '标准',
    larger: '较大',
    pleaseSelectPaperSize: '请选择纸张规格',
    pleaseSelectAPrintingMethod: '请选择打印方式',
    pleaseSelectTheSize: '请选择字号',
  },
  assemblyAddprojectdialog: {
    addItem: '添加项目',
    projectName: '项目名称',
    pleaseEnterAProjectName: '请输入项目名称',
    copies: '份数',
    pleaseEnterTheNumberOfCopies: '请输入份数',
    pleaseEnterTheNameOfTheOffer: '请输入礼遇名称',
    theNumberOfCopiesMustBeGreaterThan: '份数必须大于',
  },
  viewsHomePageIndex: {
    commonFunctions: '常用功能',
    roomStatusOverview: '房态总览',
    todayData: '今日数据',
    thisMonthData: '本月数据',
    dataAsOf: '数据截止：',
    todoList: '待办事项',
    allRead: '全部已读',
    noTodos: '您已经处理完了所有的待办事项',
    efficientDay: '真是高效的一天！',
    logUpdates: '日志更新',
    selectedFunctionsTitle: '已选择功能',
    selectedFunctionsTip: '点击拖动调整排序，至少选择1个功能',
    maxSix: '最多选择6个功能',
    allReadSuccess: '全部已读成功',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: '交易日期',
    billType: '账单类型',
    platform: '支付平台',
    qzTradeNo: '支付流水号',
    qzTradeNoPlaceholder: '请输入支付流水号',
    amountTotal: '金额合计',
    feeTotal: '费用合计',
    reportName: '线上对账报表',
    pleaseSelectAtLeastOneDateType: '请选择至少一种查询日期',
    income: '收款',
    alipay: '支付宝',
    wechat: '微信',
    merchantCode: '商家编号',
    merchantName: '商户名称',
    qzTradeNoColumn: '支付流水号',
    externalOrderNo: '外部订单号',
    orderAmount: '订单金额',
    merchantRate: '商家费率',
    commission: '手续费',
    billTypeColumn: '账单类型',
    finishTime: '完成时间',
    oriQzTradeNo: '原收款订单号',
    platformColumn: '支付平台',
  },
  appShop: {
    label1: '🔥「收款佣金立省25%成本」',
    label2: '💰「商家必看！月省千元佣金秘籍」',
    label3: '⚠「还在为高额提现手续费头疼？」',
    label4: '⏳「前100名开通领扫码盒子」',
    label5: '❓「为什么大品牌都用这个收款？」',
    label6: '🛡「银行级安全认证｜万家商户的选择」',
    label7: '📞「立即申请｜费率立降25%」',
    label8: '💼「酒店老板亲述：靠它多赚3千元/月」',
  },
  settleDialog: {
    entryRoom: '入账房间',
    selectEntryRoom: '请选择入账房间',
    confirmTotalRoomRate: '确认总房费',
    preAuthorizationSettlement: '预授权结算',
    completeCheckout: '完成结账',
    additionalChargeAmount: '加收金额',
    hourlyRoomTip: '钟点房：请确认实际应收取的房费',
    fullDayRoomTip: '全日房：请输入需额外加收的房费',
    noAdditionalCharge: '不加收费用',
    generateRoomFee: '生成房费',
    hangAccount: '挂账',
    hangToMaster: '挂到主单',
    hangAccountReason: '挂账原因',
    hangAccountTip: '挂账操作将保存到主单账户中。',
    inputAdditionalAmount: '请输入加收金额',
    detail: '明细',
    selectAtLeastOneRoom: '请选择至少一个房单',
    transferBeforeHangAccount: '请将“待入住”的房间转出后再进行挂账操作',
    pleaseAddRoomFee: '请先加收房费',
    noRoomOrderFound: '未获取到要结账的房单号，请刷新页面后重试',
  },
  notUploadList: {
    searchPlaceholder: '输入姓名、房号',
    uploadStatus: '上传状态',
    notUploaded: '未上传',
    uploaded: '已上传',
    loggedOut: '已退出',
    downloadAllGuestInfo: '下载全部客人信息',
    idAddress: '证件地址',
    uploadStatusColumn: '是否上传公安',
    downloadInfo: '下载信息',
    finishUpload: '完成上传',
  },
  notification: {
    markAllRead: '一键已读',
    expand: '展开 ({count})',
    collapse: '收起 ({count})',
    ignore: '忽略',
  },
  adjustFinance: {
    title: '调整财务',
    adjustAccount: '调账',
    balanceZeroWarning: '请保证余额为0才可以提交',
    addOneRecordWarning: '请至少添加一条入账记录',
  },
  roomStatusStatistics: {
    details: '详细信息',
  },
  hotelStateDialog: {
    title: '房态统计',
    checkIn: '在住',
    prepareCheckIn: '预抵',
    sold: '已售',
    available: '可售',
    fetchError: '获取房型数据失败',
  },
  futureRoomIndex: {
    quickSearch: '快速查询',
    reEnable: '解除停用',
    confirmChangeRoomTitle: '是否将原房间换至新房间？',
    originalRoom: '原房间',
    newRoom: '新房间',
    dragTargetInvalid: '拖拽失败：未找到目标格子',
    selectSameRoomTypeSameStayDate: '请选择同房型入离日期相同的房间',
    differentRoomTypeSwapNotSupported: '不同房型暂不支持与已有房单交换',
    AVL: '余',
  },
  financePaymentIndex: {
    addPaymentSubject: '新增',
    paymentSubjectName: '付款科目名称',
    symbol: '符号',
    confirmDelete: '确认要删除该科目吗？',
  },
  financeAccountDialog: {
    pleaseEnterSubject: '请输入{type}科目',
    pleaseSelectCategoryType: '请选择{type}类目类型',
    addTitle: '添加{type}科目',
    editTitle: '修改{type}科目',
    subjectName: '{type}科目',
    subjectCategory: '{type}科目类别',
    isEnabled: '是否启用',
  },
  financeConsumerAccount: {
    subjectCategory: '科目类别',
    addSubject: '新增',
    subjectName: '消费科目名称',
    symbol: '符号',
    confirmDelete: '确认要删除该科目吗？',
  },
  financeSubjectSorting: {
    consumeSortTitle: '消费科目排序',
    paySortTitle: '付款科目排序',
    consumeSubjectName: '消费科目名称',
    paySubjectName: '付款科目名称',
    sortSuccess: '排序成功',
  },
  aiPms: {
    common: {
      noData: '暂无数据',
      aiDriven: 'AI 驱动',
      justNow: '刚刚',
      minutesAgo: '{count}分钟前',
      hoursAgo: '{count}小时前',
    },
    aiConfig: {
      pricingSelloutTimeTitle: '定价目标售罄时间策略', pricingSelloutTimeTip: '用于当天实时提价、慢销降价和同行引流的时间紧迫度', custom: '自定义策略', legalHoliday: '法定节假日', weekend: '周五、周六', defaultDate: '其他日期（含周日）', selectTime: '请选择时间', pricingSelloutTimeInvalid: '后端返回的策略数据异常，请明确处理售罄时间策略后再保存。', pricingSelloutTimeRequired: '定价目标售罄时间策略的三项时间必须为HH:mm格式，且时间必须为14:00至23:59或00:00至06:00',
      pageTitle: 'AI配置', save: '保存', hotelSection: '酒店维度配置', roomTypeSection: '房型维度配置', priceGuard: '价格护栏', enabled: '开启', disabled: '关闭', hotelFloorPrice: '酒店底价', hotelCeilingPrice: '酒店上限价', floorPrice: '底价（元）', ceilingPrice: '上限价（元）', floorPricePlaceholder: '请输入底价', ceilingPricePlaceholder: '请输入上限价', yuan: '元', roomTypeName: '房型名称', roomTypeCode: '房型编码', amountNonNegative: '金额必须大于等于0', floorGreaterThanCeiling: '底价不能高于上限价', hotelLabel: '酒店', roomTypeLabel: '房型“{name}”', noChanges: '未检测到配置变更', saveSuccess: '保存成功',
    },
    roomPricingReport: {
      reportTitle: '房型定价报告', reportTip: '展示 AI 建议、经营数据依据及定价因素', hotelInfo: '酒店公共信息', sellDate: '售卖日期', metricDate: '指标营业日', hotelOcc: '酒店当前 OCC', hotelRevpar: '酒店当前 RevPAR', currentPrice: '当前价', aiRecommendedPrice: 'AI 建议价', aiCurrentDelta: 'AI 相对当前价', sameDayOcc: '当日 OCC', sameDayRevpar: '当日 RevPAR', confidence: 'AI 置信分', inventorySnapshot: '已售 / 可售(超售) / 停用', operatingBasis: '房型经营数据依据', aiDecision: 'AI 决策', tradeoff: '多因素权衡：', aiFactors: 'AI 定价因子', historicalPrice: '历史价格', operation: '经营数据', market: '市场位置', timeEvent: '时间与事件', guardrailRisk: '约束与风险', status: '状态：', priceImpact: '价格影响：', conclusion: '结论：', reason: '原因：', evidence: '证据：', riskReminder: '风险提醒', noRisk: '暂无额外风险提醒', severity: '严重程度：', suggestion: '处理建议：', used: '已采用', notUsed: '未采用', notAvailable: '无可用数据', up: '支持上调', hold: '建议维持', down: '支持下调', limit: '护栏限制', none: '无直接影响', yes: '是', no: '否', yuan: '元', priceAdjustment: '产品改价', priceAdjustmentDialogTitle: '智能定价一键改价', noAdjustableProducts: '当前房型暂无可改产品', roomTypeName: '房型名称：', roomTypeCode: '房型编码：', roomTypeCurrentPrice: '房型当前价', algorithmRecommendedPrice: '算法建议价', aiAdjustmentDelta: 'AI 涨跌', currencySymbol: '¥', snapshotPriceNote: 'AI 建议基于本次智能定价通知的价格快照', product: '产品：', channel: '渠道', channelId: '渠道 ID：{id}', channelCurrentPrice: '渠道当前售价', aiAdjustedPrice: 'AI 调整后售价', operationLabel: '操作', oneClickAdjustment: '一键改价', confirmGroupAdjustment: '确认对该产品下 {count} 个渠道执行改价？', confirmChannelAdjustment: '确认对该渠道产品执行改价？', confirmAdjustmentTitle: '确认改价', confirm: '确定', cancel: '取消', adjustmentSuccess: '改价成功', bookingHourPreference: '近7日分时段预订偏好', bookingHourNoData: '暂无分时段预订数据', bookingHourDateRange: '{start} 至 {end}', bookingHourTooltip: '{hour}:00<br/>订单占比：{value}%',
    },
    roomPricingFeedback: {
      button: '采纳', dialogTitle: '提交反馈', accept: '采纳', reject: '不采纳', rejectReasonPlaceholder: '请填写不采纳原因', actionRequired: '请选择反馈结果', rejectReasonRequired: '请填写不采纳原因', rejectReasonTooLong: '不采纳原因不能超过100字', acceptSuccess: '采纳成功', rejectSuccess: '已提交不采纳反馈',
    },
    roomPricing: {
      empty: '暂无可展示的定价结果',
      roomTypeFallback: '房型{index}',
      decisionTitle: '决策说明',
      riskLabel: '风险提示：',
      modeLabel: '模式：',
      floorPriceLabel: '价格护栏：',
      confidenceLabel: '可信度：',
      directionFlat: '平价建议',
      directionUp: '涨价建议',
      directionDown: '降价建议',
      priorityLow: '低优先级',
      priorityMedium: '中优先级',
      priorityHigh: '高优先级',
    },
    roomPricingCard: { pricingTime: '定价时间：', expand: '展开', collapse: '收起' },
    noticeCenter: {
      unreadCount: '未读 {count} 条',
      readAll: '全部已读',
      defaultTitle: 'AI 通知',
      browserNotificationTitle: 'AI 通知提醒',
      browserNotificationBody: '您收到一条新的 AI 通知',
      browserPermissionGuide: '开启后，新的 AI 通知会在浏览器后台显示提醒。',
      enableBrowserNotification: '开启浏览器通知',
      skipBrowserNotification: '暂不开启',
      statusRead: '已读',
      statusUnread: '未读',
      emptySummary: '暂无通知摘要',
      like: '赞',
      dislike: '踩',
      viewDetail: '查看详情',
      markRead: '点我已读',
      emptyList: '暂无通知',
      dislikeDialogTitle: '提交点踩原因',
      dislikePlaceholder: '请留下您的建议',
      categoryAll: '全部',
      readAllSuccess: '全部已读成功',
      markReadSuccess: '已读成功',
      likeSuccess: '点赞成功',
      dislikeReasonRequired: '请填写点踩原因',
      dislikeSuccess: '提交成功',
      uncategorized: '未分类',
    },
    noticeDetail: {
      back: '返回消息通知',
      sendTime: '生成时间：',
      businessType: '一级分类：',
      businessSubType: '二级分类：',
      sideLabel: '消息详情',
      contentTitle: '通知正文',
      contentTip: '按 markdown 风格展示通知原文',
      badReviewTitle: '差评明细',
      badReviewTip: '展示差评正文与 AI 建议回复',
      badReviewContent: '差评正文',
      badReviewReply: '建议回复',
      structuredTitle: '结构化结果',
      structuredTip: '按 AI 报告内容分块展示结构化数据和分析文本',
      structuredEmptyTip: '当前内容暂未解析出可展示数据',
      missingNoticeNo: '缺少 noticeNo',
    },
    smartPricing: {
      pageTitle: '智能定价',
      empty: '暂无最新智能定价通知',
      peerHotelMonitor: {
        title: '竞对引流价格监控',
        refresh: '刷新',
        meituan: '美团',
        empty: '暂无竞对引流价数据',
        unnamedHotel: '未命名竞对酒店',
        crawlSubmitted: '请稍后刷新页面查看',
      },
    },
    futurePricing: { realtimeTab: '实时定价报告', futureTab: '远期定价报告', reportTitle: '房型远期定价报告', reportTip: '展示未来 14 天的冻结定价建议与分析', empty: '暂无房型远期定价报告', hotelOverview: '酒店远期定价概览', priceSource: '价格来源', pricingBusinessDate: '定价营业日', forecastDateRange: '预测日期范围', to: '至', confidence: '14 天综合置信度', dailyEmpty: '暂无每日定价结果', analysis: '分析', aiDecision: 'AI 决策', decisionSummary: '决策摘要', pricingFactors: '定价因子', noFactor: '暂无因子说明', status: '状态', priceImpact: '价格影响', reason: '原因', conclusion: '结论', tradeoff: '权衡说明', riskReminder: '风险提示', noRisk: '暂无风险提示', severity: '严重程度', suggestion: '建议', sellDate: '售卖日', algorithmReferencePrice: '算法参考价', aiRecommendedPrice: 'AI 建议价', historicalExpectedOcc: '历史预期 OCC', historicalExpectedRevpar: '历史预期 RevPAR', holidayEvent: '节假日 / 活动', systemRisk: '系统风险', yes: '是', no: '否', legalHoliday: '法定节假日', weekendPeak: '周末高峰', normalDate: '普通日期', reportGeneratedAt: '报告生成时间', listEmpty: '暂无已完成的远期定价报告', selectDate: '选择日期', dailyAverageOrders: '近 7 日平均每日订单', viewAllReports: '查看全部报告', backToAllReports: '返回报告列表', realtimeListEmpty: '暂无已完成的房型定价报告' },
    futurePricingCalendar: { calendarTitle: '房型远期定价日历', roomType: '房型', expectedOcc: '预期 OCC', expectedRevpar: '预期 RevPAR', pricingBasis: '定价依据', dataIntegrityRisk: '数据完整性提醒 / 风险提示', highRisk: '高风险', calendarEmpty: '暂无远期定价日历数据', priceUp: '上调', priceDown: '下调', priceHold: '持平', overallPricingBasis: '总体定价依据', roomOverallRisk: '房型总体风险提示', dailyRiskReminder: '每日风险提示' },
    storeManagerReport: {
      pageTitle: '店长报告',
      pageDesc: '按日报、周报、月报查看最新综合报告结果。',
      dailyButton: '日报',
      weeklyButton: '周报',
      monthlyButton: '月报',
      datePlaceholder: '请选择时间',
      empty: '当前时段暂无最新店长报告',
      contentTitle: '报告正文',
      contentTip: '按最新综合报告原文展示',
      analysisTitle: '结构化分析',
      analysisTip: '按结构化节点展示综合分析内容',
      monthLabel: '{year}年{month}月',
      weekLabel: '{start} 至 {end}',
      dailyTitle: '店长日报',
      weeklyTitle: '店长周报',
      monthlyTitle: '店长月报',
      periodLabel: '查询时段：{range}',
    },
    storeDiagnosis: {
      pageTitle: '门店诊断',
      pageDesc: '每日一份门店诊断报告，基于静态信息与近 31 天评论自动生成。每天限生成 1 次，页面展示最近一次结果。',
      refresh: '刷新',
      generate: '生成诊断报告',
      hotelInfoIncomplete: '当前酒店信息不完整，请确认已登录并选择酒店',
      emptyTitle: '尚未生成诊断报告',
      emptyDesc: '酒店档案、房型、图片等数据齐全后，自动发起 AI 诊断。生成后不可重复操作。',
      emptyMeta: '酒店编码 {hotelCode}　批次 {batchNo}',
      taskInfo: '任务信息',
      batch: '批次',
      todayTask: '今日任务',
      preparingData: '数据准备中',
      generating: '诊断生成中',
      failedNoRetry: '已失败，不可再生成',
      generated: '已生成',
      notGenerated: '未生成，可手动生成',
      noReport: '暂无报告',
      latestDone: '最近一次已完成',
      latestFailed: '最近一次失败',
      done: '已完成',
      failed: '生成失败',
      statusWait: '1 / 待校验',
      statusDiagnosing: '2 / 诊断中',
      statusDone: '3 / 完成',
      statusFailed: '4 / 失败',
      metaStatus: '状态',
      failSummary: '失败摘要',
      currentStage: '当前阶段',
      crawlRetry: '数据整合重试',
      diagnoseDone: '诊断完成',
      diagnosingStage: '诊断生成中',
      generateFailedShort: '生成失败',
      failTitle: '诊断未完成',
      failMessageToday: '诊断数据整合或 AI 生成失败，当日不可再次生成。',
      failMessageLatest: '最近一次诊断失败。今日尚未生成，可手动生成今日报告。',
      failHintToday: '当日不可再次生成。可次日重试，或联系运营排查。',
      failHintLatest: '以上为最近一次失败记录。今日尚未生成，需手动点击「生成诊断报告」。',
      stepCrawl: '① 触发数据整合',
      stepSuccess: '② 数据整合成功',
      stepSync: '③ 同步数据',
      stepAdp: '④ 发起诊断',
      progressDiagnosing: '数据整合与同步已完成，正在生成诊断报告。',
      progressWait: '正在拉取美团/携程档案、房型、图片，数据齐后自动诊断。',
      reportPending: '报告尚未产出，数据齐后将自动诊断，可离开页面稍后回来查看。',
      reportGenerating: '正在生成诊断报告，请稍候…',
      reportBody: '诊断报告正文',
      reportEmpty: '报告正文为空',
      generateSuccess: '已创建诊断任务，正在准备数据',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: '渠道分析',
      roomTypeAnalysis: '房型分析',
      commentAnalysis: '评论分析',
      marketAnalysis: '市场/商圈热度',
      momLabel: '环比：',
      yoyLabel: '同比：',
      dayMomLabel: '环比：',
      dayYoyLabel: '周同比：',
      weekMomLabel: '环比：',
      weekYoyLabel: '月同比：',
      monthMomLabel: '环比：',
      monthYoyLabel: '同比：',
      channel: '渠道',
      revenue: '营收',
      roomNight: '间夜',
      channelShare: '渠道占比',
      roomTypeName: '房型名称',
      totalRooms: '总房数',
      soldRoomNights: '出租间夜数',
      totalRoomRevenue: '总房费',
      occupancyRate: '出租率',
      averageRoomRate: '平均房价',
      disabledRooms: '停用数',
      commentType: '评价类型',
      count: '数量',
      share: '占比',
      goodMediumBad: '好/中/差',
      goodRate: '好评占比',
      eventName: '事件名称',
      eventFallback: '事件',
      summaryAnalysis: '综合分析',
      goodComment: '好评',
      mediumComment: '中评',
      badComment: '差评',
      channelRevenueChart: '渠道营收',
      roomTypeRevenueChart: '房型营收',
    },
    revenueManager: {
      pageTitle: '收益管家',
      adviceTitle: 'AI经营建议',
      pendingCount: '{count}条待处理',
      trafficTitle: '流量监控',
      trafficSubtitle: 'AI预测 · 实时更新',
      selectDate: '选择日期',
      todayShortcut: '今天',
      allDay: '全天',
      timeLabel: '时间',
      storeTrafficLabel: '本店流量',
      orderLabel: '订单',
      orderCount: '{count}单',
      summaryNote: '{channel}渠道 · 更新于 {time}',
      forecastLabel: '全天预测（AI模型）',
      meituanForecast: '美团预测流量',
      ctripForecast: '携程预测流量',
      allDayVisit: '全天访问量',
      occLabel: '出租率',
      roomNightLabel: '间夜',
      revenueLabel: '营业额',
      analysisTag: 'AI 分析',
      defaultStrategyTag: '定价策略',
      collapse: '收起',
      expandMore: '展开更多',
      badReviewLoading: '正在加载差评回复内容...',
      badReviewReply: '差评回复',
      badReviewEmpty: '暂无可展示的差评回复内容',
      realtimeTitle: '实时经营概览',
      revenueForecastTitle: '收益预测（{range}）',
      occForecastTitle: '出租率预测（{range}）',
      aiForecastBadge: 'AI预测',
      todayForecast: '今日预测{value}',
      peakLabel: '峰值',
      channelMeituan: '美团',
      channelCtrip: '携程',
      hours1: '近1小时',
      hours3: '近3小时',
      hours5: '近5小时',
      hours12: '近12小时',
      yesterdayValue: '昨日 {value}',
      futureSevenDays: '未来7天',
      dailyAdviceTitle: '{date} 当日AI建议',
      allDayAdviceTitle: '全天AI建议',
      hoursAdviceTitle: '近{hours}小时AI建议',
      adrForecastLabel: 'ADR预测',
      defaultAdviceDetail: '建议根据当前需求情况动态调整房价与投放策略。',
      displayDate: '{year}年{month}月{day}日',
      roomNightValue: '{count}间',
      revenueInsightCollapse: '收起 AI 收益推导说明',
      revenueInsightExpand: '展开 AI 收益推导说明',
      forecastForDate: '{date}预测{value}',
      revenueInsightTitle: 'AI 收益推导说明',
      revenueInsightJudgment: '收益判断',
      revenueInsightKeySteps: '关键推导',
      revenueInsightRisks: '风险提示',
      revenueInsightRecommendations: '经营建议',
      metricTips: {
        traffic: {
          meituan: { title: '美团流量说明', p1: '美团流量表示所选时间范围内，美团渠道带来的本店访问表现。', p2: '系统结合历史经营、近期走势、当天已发生访问和节假日等因素综合展示。', p3: '适合判断分时趋势与异常波动，不等同于全天最终累计值。' },
          ctrip: { title: '携程流量说明', p1: '携程流量表示所选时间范围内，携程渠道带来的本店访问表现。', p2: '系统参考历史同类日期、近期渠道表现、当天实时变化和节假日因素综合展示。', p3: '建议结合订单变化判断流量是否有效转化为预订。' },
          order: { title: '订单说明', p1: '订单表示当前渠道、日期和时间范围内产生的订单变化。', p2: '该指标反映实时预订转化情况，并结合当前筛选条件展示。', p3: '短时波动较大时，建议结合全天预测和历史经营表现判断。' },
        },
        hotelForecast: {
          meituan: { title: '美团预测流量说明', p1: '美团预测流量表示对美团渠道当天整体访问量的预估。', p2: '系统依据历史流量、近期渠道变化、当天表现、节假日和经营节奏综合判断。', p3: '适合提前判断客源热度，辅助价格、房量和运营安排。' },
          ctrip: { title: '携程预测流量说明', p1: '携程预测流量表示对携程渠道当天整体访问量的预估。', p2: '系统依据历史同类日期、近期走势、当天实时表现和节假日因素综合判断。', p3: '适合观察潜在需求强弱，并与美团预测流量进行对比。' },
          occ: { title: '出租率说明', p1: '出租率表示当天客房售出比例的预测。', p2: '系统结合历史出租率、近期预订节奏、当天流量订单和节假日因素综合判断。', p3: '适合判断入住压力、余房风险及调价促销方向。' },
          roomNights: { title: '间夜说明', p1: '间夜表示当天可能售出的房晚数量预测。', p2: '系统参考历史售卖、近期订单节奏、当天流量订单与节假日因素综合判断。', p3: '应与出租率结合，用于判断房量消化速度。' },
          adr: { title: 'ADR说明', p1: 'ADR表示当天已售客房平均房价的预测。', p2: '系统依据历史价格、近期成交、当天需求与节假日因素综合判断。', p3: '应与出租率、营业额一起看，避免只追求入住率。' },
          revenue: { title: '营业额说明', p1: '营业额表示当天客房销售收入的预测。', p2: '系统综合预测间夜、预测ADR、历史经营、近期需求和节假日因素判断。', p3: '适合判断经营结果是否达标及收益提升空间。' },
        },
        futureRevenue: { title: '收益预测说明', p1: '收益预测表示未来7天每日客房营业额的预测。', p2: '系统综合历史经营、近期预订、流量订单、当天表现和节假日因素判断。', p3: '适合识别高低峰日期并安排价格、房量与运营策略。' },
        occRevenue: { title: '出租率预测说明', p1: '出租率预测表示未来7天每日客房售出比例的预测。', p2: '系统参考历史出租率、近期预订、渠道流量、订单、当天变化和节假日因素判断。', p3: '适合提前识别满房或入住不足风险，并制定调价促销计划。' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: '收益管家',
    aiSmartPricing: '智能定价',
    aiNoticeCenter: '消息通知',
    aiStoreManagerReport: '店长报告',
    aiStoreDiagnosis: '门店诊断',
    aiNoticeDetail: '通知详情',
    aiConfig: 'AI配置',
    businessLog: '营业日变更日志',
    nightAuditLog: '夜审日志',
    turnoverSubmit: '营业收入上缴',
    channelConfig: '渠道配置',
  },
  systemsetNotice: {
    systemMessageReminder: '系统消息提醒',
    messageReminderSettingsAtLeastOneItem: '消息提醒设置（至少选择一项）',
    hourlyRoomCheckoutMessage: '钟点房退房消息',
    fullDayCheckoutMessage: '全日房退房消息',
    messageVoiceReminder: '消息语音提醒',
    onlineChannelNewOrderReminder: '线上渠道新订单提醒',
    onlineChannelOrderCancellationReminder: '线上渠道订单取消提醒',
    hourlyRoomCheckoutReminder: '钟点房退房提醒',
    fullDayCheckoutReminder: '全日房退房提醒',
    operationFailed: '操作失败',
    thirtyMinutesBeforeCheckout: '退房前30分钟',
    fifteenMinutesBeforeCheckout: '退房前15分钟',
    atCheckoutTime: '退房时',
    checkoutTimeUpdated: '退房提醒时间修改成功',
    voiceSettingUpdated: '语音提醒状态修改成功',
  },
  binding: {
    publicAccountMessageReminder: '公众号消息提醒',
    scanToBindUser: '扫码绑定人员',
    cancelEdit: '取消编辑',
    allMembers: '全部成员',
    scanToBindTitle: '扫码绑定公众号',
    scanWithWechat: '请使用微信扫码绑定',
    qrCodeGenerateFail: '二维码生成失败，请稍后重试',
    unbindSuccess: '解绑成功！',
    unbindFail: '解绑失败，请重试',
    confirmCloseQrDialog: '确定关闭二维码弹窗？',
    orderCreate: '新订单',
    orderCancel: '订单取消',
    orderConfirm: '订单待确认',
    orderCheckOutTip: '退房前',
    orderCheckOut: '退房',
    orderCreateEbk: 'EBK新订单',
    orderCancelEbk: 'EBK订单取消',
    roomCleanDone: '房间打扫完成',
    ebAccountOffline: 'EB账号掉线',
    computerHardwareOffline: '电脑硬件掉线',
    ebWarnNotice: '爆房预警',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: '预制门卡',
    effectiveTime: '生效时间',
    expiryTime: '失效时间',
    viewPassword: '查看密码',
    passwordStatusNotSent: '未发送',
    passwordStatusSending: '发送中',
    passwordStatusSent: '发送成功',
    passwordStatusFailed: '发送失败',
    generatePasswordOnly: '仅生成密码',
    generateAndSendPassword: '生成并发送密码',
    getLockInfoFailed: '获取房间门锁信息失败',
    makeCardFailedPrefix: '制卡失败：',
    deactivateFailedPrefix: '注销卡失败：',
    pleaseEnterValidPhoneNumber: '请输入正确的手机号',
    passwordSendSuccess: '密码发送成功',
    roomPasswordGeneratedAndSent: '房间密码已生成并发送给客人，请提醒客人留意短信获取开门密码',
    roomPasswordGenerated: '房间密码已生成',
    invalidTimeString: '无效的时间字符串',
    temporaryMakeCard: '临时制卡',
    validDoorCard: '当前有效门卡',
    makeCardLogTitle: '制卡记录',
    makeType: '制卡类型',
    operationResult: '操作结果',
    createTime: '创建时间',
  },
  operating: {
    total: '总计',
    index: '序号',
    businessDay: '营业日',
    totalAccount: '总账',
    totalOcc: '总出租率(%)',
    fullDayOcc: '全日房出租率(%)',
    hourDayOcc: '钟点房出租率(%)',
    avgPrice: '平均房价(元)',
    revPar: '总REVPAR(元)',
    totalRoomNight: '出租总间夜(间)',
    fullDayRoomNight: '全日房间夜(间)',
    busLongRoomNight: '长包房间夜(间)',
    hourRoomNight: '钟点房间夜(间)',
    teamRoomNight: '团队房间夜(间)',
    freeRoomNight: '免费房间夜(间)',
    privateRoomNight: '自用房间夜(间)',
    houseRent: '总房费(元)',
    smallGoods: '小商品(元)',
    meals: '餐费(元)',
    serviceFee: '服务费(元)',
    memberFee: '会员费(元)',
    otherFee: '其他费用(元)',
    generalIncome: '营业总收入(元)',
    roomNight: '间夜数(间)',
    avgRoomPrice: '平均房价(元)',
    totalHouseRent: '房费合计(元)',
    rentalRate: '出租率(%)',
    roomNightProportion: '间夜占比(%)',
    calcFormula: '计算公式',
    known: '知道了',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: '请检查搜索的起止时间',
    roomRateIncome: '房费收入',
    smallwareIncome: '小商品收入',
    mealFeeIncome: '餐费收入',
    reportTitle: '收入汇总表',
    cooperationModel: '合作模式',
    status: '新签/换签',
    roomsCount: '物理房间数',
    startBusiness: '开业时间',
  },
  commonImportDialog: {
    tip: '请按照模版中的要求整理信息',
    downloadTemplate: '下载模版',
    removeFileConfirm: '确定移除',
    limitOneFile: '当前限制选择 1 个文件，请移除再添加',
    uploadError: '上传失败，请重试',
    reupload: '重新上传',
  },
  orderAntiflyRoom: {
    powerOnTime: '通电时间',
    powerOffTime: '断电时间',
    isAntifly: '是否飞房',
    powerDuration: '通电时长',
  },
  roomOccupiedDetail: {
    title: '占房明细',
    unassigned: '未排房',
    roomOrderNo: '房单号',
    roomCount: '房间数',
    roomType: '房型',
    roomNo: '房间号',
    contact: '联系人',
    arrival: '预抵',
    departure: '预离',
    orderAndPayStatus: '订单状态（支付状态）',
    unpaidOrderNotAllowed: '未支付订单不能操作',
    invalidRoomOrderOperation: '未支付、待入住、未排房的房单不能操作',
  },
  hardware: {
    smartRoomControl: '智能客控',
    smartRoomControlDesc: '支持远程控制房间内的智能设备',
    smartRoomControlSetting: '智能客控设置',
    appKey: 'appKey',
    appKeyPlaceholder: '请输入appKey',
    appSecret: 'appSecret',
    appSecretPlaceholder: '请输入appSecret',
    thirdHotel: '三方酒店',
    thirdHotelPlaceholder: '请输入三方酒店',
    thirdGroup: '三方集团',
    thirdGroupPlaceholder: '请输入三方集团',
    enable: '开启',
    disable: '关闭',
    deviceType: '设备类型',
    fullDayAutoOff: '全日房到预离时间自动断电',
    hourAutoOff: '钟点房到预离时间自动断电',
  },
  lockpwd: {
    makeCardLogTitle: '制作门卡记录日志',
    operationType: '操作类型',
    operationTime: '操作时间',
    makeCard: '制卡',
    cancelCard: '注销卡',
    roomTypeCode: '房型编码',
    roomTypeName: '房型名称',
    roomNumber: '房间号',
    lockBrandName: '门锁品牌名称',
    lockId: '门锁ID',
    orderRoomNo: '房单号',
    operator: '操作人',
    makeType: '制卡类型',
    validPeriod: '制卡有效期',
    operationResult: '操作结果',
    errorMessage: '失败信息',
  },
  roomType: {
    createBundleRoomType: '新建包栋房型',
    roomTypeName: '房型名称',
    relatedRoomTypes: '关联房型',
    relateRoom: '关联房间',
    selectedRooms: '已选房间',
  },
  turnoverSubmit: {
    summaryLoadFailed: '钱柜数据加载失败，当前页面已禁止操作。',
    reload: '重新加载',
    initBeforeUse: '首次使用前请先初始化当前钱柜各项余额。',
    initCashier: '初始化钱柜',
    submitManage: '上缴管理',
    summaryTipPrefix: '注：这里统计的消费与结算为',
    to: '至',
    summaryTipSuffix: '的数据',
    consumeSubject: '消费科目',
    paymentSubject: '付款科目',
    serialNumber: '序号',
    subtotal: '小计',
    subject: '科目',
    amount: '金额',
    dataSummary: '数据汇总',
    lastBalanceSummary: '上期钱柜结存：{total} = 现金({cash}) + 银行卡({bankCard}) + 其他({other})',
    currentAmountSummary: '当前钱柜金额：{total} = 现金({cash}) + 银行卡({bankCard}) + 其他({other})',
    currentCash: '当前钱柜现金：',
    currentBankCard: '当前钱柜银行卡：',
    currentOther: '当前钱柜其它项：',
    submitCash: '上缴现金',
    submitBankCard: '上缴银行卡',
    submitOther: '上缴其它项',
    cashBalance: '钱柜现金余额：',
    bankCardBalance: '钱柜银行卡余额：',
    otherBalance: '钱柜其它项余额：',
    remark: '备注：',
    submit: '上缴',
    submitHistory: '上缴历史查询',
    submitTime: '上缴时间',
    startDate: '开始日期',
    endDate: '结束日期',
    operator: '操作员',
    pleaseEnter: '请输入',
    search: '查询',
    export: '导出',
    lastCashierBalance: '上期钱柜余额',
    cash: '现金',
    bankCard: '银行卡',
    other: '其他',
    currentCashierAmount: '本期钱柜金额',
    currentSubmitAmount: '本期上缴金额',
    currentCashierBalance: '本期钱柜余额',
    initTipLine1: '请按当前实际钱柜金额填写。',
    initTipLine2: '初始化完成后将生成一条备注为【初始化数据】的历史记录。',
    currentCashierCash: '当前钱柜现金',
    currentCashierBankCard: '当前钱柜银行卡',
    currentCashierOther: '当前钱柜其它项',
    skipInit: '暂不初始化',
    confirmInit: '确认初始化',
    pleaseEnterAmount: '请输入金额',
    invalidAmountFormat: '金额格式不正确，最多保留两位小数',
    notGreaterThanCurrentCash: '不能大于【当前钱柜现金】',
    notGreaterThanCurrentBankCard: '不能大于【当前钱柜银行卡】',
    notGreaterThanCurrentOther: '不能大于【当前钱柜其它项】',
    hotelHistoricalTotal: '酒店历史累计',
    currentTime: '当前时间',
    initBalanceCannotBeNegative: '初始化余额不能小于0',
    cashierInitSuccess: '钱柜初始化成功',
    exportFailed: '导出失败',
    checkSubmitAmount: '请检查上缴金额是否正确',
    confirmSubmitMessage: '确认提交本次营业收入上缴记录吗？',
    tip: '提示',
    submitSuccess: '上缴成功',
    submitFailed: '上缴失败',
    total: '合计',
    pushPriceLibrary: '推送价库',
    pushPriceLibrarySuccess: '推送价库成功',
    pushPriceLibraryFail: '推送价库失败',
  },
  channelConfig: {
    noChannelConfigData: '暂无渠道配置数据',
    directConnected: '已直连',
    notDirectConnected: '未直连',
    roomTypeMatch: '房型匹配',
    bindNewAccount: '绑定新账号',
    openDirectConnection: '开通直连',
    meituanHomestayStore: '美团民宿门店',
    tujiaHomestayAccount: '途家民宿账号',
    deleteAccount: '删除账号',
    noBoundAccount: '暂无绑定账号',
    breakDirectConnection: '断开直连',
    directConnectionStatus: '直连状态',
    channelDiscount: '渠道折扣',
    channelCommission: '渠道佣金',
    qzCommission: '轻住佣金',
    meituanRoomType: '美团房型',
    meituanRoomTypeId: '美团房型ID',
    tujiaHouse: '途家房屋',
    tujiaHouseId: '途家房屋ID',
    meituanHomestay: '美团民宿',
    tujiaHomestay: '途家民宿',
    homestay: '民宿',
    goodsTypeNormal: '标准产品',
    goodsTypeFree: '免费房产品',
    goodsTypeOnlineHour: '线上钟点房',
    goodsTypePresaleFullDay: '预售全日房',
    goodsTypePresaleHour: '预售钟点房',
    fetchChannelConfigFail: '获取渠道配置失败',
    goodsTypePrefix: '产品类型{type}',
    openDirectSuccess: '开通直连成功',
    openDirectFail: '开通直连失败',
    channelNotSupportRoomMatch: '该渠道暂不支持房型匹配',
    fetchRoomMatchFail: '获取房型匹配数据失败',
    pleaseSelectRoomType: '请选择轻赢宝房型',
    pleaseSelectProduct: '请选择轻赢宝产品',
    bindFail: '绑定失败',
    confirmUnbindRoomType: '确定解绑该房型吗？',
    unbindFail: '解绑失败',
    channelNotSupportAccountBind: '该渠道暂不支持账号绑定',
    bindAccountSuccess: '账号绑定成功',
    bindAccountFail: '账号绑定失败',
    fetchAccountDetailFail: '获取账号详情失败',
    confirmDeleteAccount: '确定删除该账号吗？',
    confirmBreakDirect: '确定断开直连吗？',
    breakDirectSuccess: '断开直连成功',
    breakDirectFail: '断开直连失败',
    pushPriceLibrary: '推送90天价库',
    pushPriceLibrarySuccess: '推送价库成功',
    pushPriceLibraryFail: '推送价库失败',
    pushPriceLibrarySwitch: '推送价库开关',
    pushSwitchOnSuccess: '推送开关已开启',
    pushSwitchOffSuccess: '推送开关已关闭',
    pushSwitchChangeFail: '切换推送开关失败',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: '价格来源', bookingHourOrderCountTitle: '分时段预订订单数', bookingHourOrderCountNoData: '暂无可用分时订单数据', bookingHourOrderCountDateRange: '近7日 {start} 至 {end} ｜ 当天 {date}', bookingHourOrderCountDateOnly: '当天 {date}', bookingHourOrderCountSevenDay: '近7日累计订单', bookingHourOrderCountToday: '今天订单', bookingHourOrderUnit: '单', bookingHourOrderAxis: '订单数', viewTodayReports: '查看当日报告', backToTodayReports: '返回当日报告', backToLatestReport: '返回最新报告', historyEmpty: '暂无该智能定价报告', todayReportTitle: '{date} 当日报告', pricingTime: '定价时间', reportTitle: '报告标题', pricingChannel: '定价渠道', viewDetail: '详情', todayReportEmpty: '当日暂无已完成的房型定价报告',
  },
  commonBook: {
    commonBooking: '统一预订', fitBooking: '散客预订', longStayBooking: '长包房预订', teamBooking: '团队预订', walkIn: '散客步入', ebkManualMove: 'EBK手工搬单',
    sourceType: '客源类型', externalChannel: '外部渠道', channelOrderNo: '渠道单号', arrivalTime: '入住时间', departureTime: '离店时间', retentionTime: '保留时间', stayDuration: '入住时长', days: '天数', contact: '联系人', contactPhone: '联系人电话', teamType: '团队类型', teamName: '团队名称', contractNo: '合同编号',
    paymentInfo: '付款信息', paymentMethod: '支付方式', amount: '金额', storedValueMember: '储值会员', paymentCode: '支付验证码', remark: '备注', totalRooms: '房间数', stayDays: '入住天数', taxAmount: '税价', roomPrice: '房价', totalPrice: '总价', submitBooking: '办理预订',
    addRoom: '增加房间', addRoomType: '添加房型', roomType: '房型', roomStatus: '房态', room: '房间', loading: '加载中', noAvailableRoomType: '暂无可选房型', noAvailableRoom: '无可选房间，请调整房型或房态', noValidRoomType: '暂无有效房型', selectedRoomCount: '已选房间：{count} 间，至少选择1间', emptyClean: '空净', emptyDirty: '空脏', selectRoomType: '请选择房型',
    availableRooms: '可订数', breakfast: '早餐', roomCount: '间数', bookedRoomCount: '预订间数', walkInRoomCount: '入住间数', arrangeRoom: '排房', dailyPrice: '每日价格', unassignedRooms: '待排房 {count} 间', assignedRoom: '已排房 {room}', selectedRoom: '已选 {room}', delete: '删除', to: '至', addGuest: '添加同住', channelRoomType: '渠道下单房型', currencyUnit: '元', tax: '税',
    pleaseSelect: '请选择', pleaseEnter: '请输入', enterChannelName: '请输入渠道名称', cancel: '取消', confirm: '确定', close: '关闭', roomDetail: '房单详情',
    selectSourceType: '请选择客源类型', selectMemberInfo: '请选择会员信息', selectCompany: '请选择协议单位', selectStayType: '请选择入住类型', selectArrivalTime: '请选择预抵时间', selectDepartureTime: '请选择预离时间', enterContact: '请填写联系人', selectTeamType: '请选择团队类型', enterTeamName: '请填写团队名称',
    basePriceMode: '底价模式', sellingPriceMode: '卖价模式', useEbkOrderInfo: '使用EB订单信息', initializationFailed: '统一预订初始化失败，请关闭后重试', dictionaryLoadFailed: '预订字典加载失败', companyNotFound: '未查询到相关协议单位信息',
    minimumStayDays: '当前场景最少入住{count}天', maximumStayDays: '当前场景最多入住{count}天', retentionBeforeArrival: '保留时间不能早于入住时间', retentionTooLate: '保留时间不能晚于当前场景允许的最晚时间', retentionOutOfRange: '保留时间不在当前场景允许范围内',
    invalidBreakfast: '{roomType}早餐数必须为0至999的整数且不能为空', invalidRoomCount: '{roomType}间数必须为非负整数且不能为空', enterExternalChannel: '请填写外部渠道名称', invalidHourDuration: '入住时长必须为1至12的整数小时', invalidStayDays: '当前场景入住天数必须为{min}至{max}的整数天', incompleteStay: '{roomType}存在不完整住期', arrivalBeforeBusinessDate: '{roomType}预抵日期不能早于当前营业日期', roomTypeStayRange: '{roomType}住期必须为1至{max}天', roomTypeDuplicateStay: '{roomType}不能添加重复住期',
    selectAtLeastOneRoomType: '请至少选择一个可预订房型', selectMember: '请选择会员', missingProductOrPrice: '已选择房型缺少商品或每日价格', roomCountExceedsAvailability: '已选择房型的预订间数超过当前可订数', walkInRequiresRoom: '散客步入必须完成具体排房', guestRequiredPerRoom: '请为每个房间填写入住人', completeGuestName: '请完整填写入住人姓名', selectPaymentForDeposit: '收取押金时请选择收款方式', selectMemberForStoredValue: '会员储值支付请选择会员', insufficientMemberBalance: '会员余额为{balance}元，请选择其他收款方式', enterStoredValueCode: '会员储值支付请填写支付验证码',
    bookingFailed: '预订失败，请调整后重试', bookingSuccess: '预订成功', overOccupancyConfirmation: '入住人数超过房间最大入住人数，是否继续办理入住？', overOccupancyPromptTitle: '提示', walkInMissingMasterRoom: '散客步入成功，但未返回主房单号', checkInSuccess: '入住成功', createdWithoutOrderNo: '创建成功但未返回订单号，请在财务页面补录收款', walkInWithoutMasterRoomForPayment: '入住成功但未返回主房单号，请在财务页面补录收款', onlinePaymentFailed: '在线收款请求失败', paymentStatusFailed: '支付状态查询失败',
    sameStayExists: '该房型已存在相同住期', departureAfterArrival: '预离时间必须晚于预抵时间', duplicateStayNotAllowed: '同一房型不能添加重复住期', selectUnaddedRoom: '请选择未添加的房间', keepOneWalkInRoom: '散客步入至少保留1间房', ebkRoomCountMismatch: '预订间数和渠道订单间数不一致，是否继续办理预订？', continueBooking: '继续预定', modify: '修改',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: '价格来源', bookingHourOrderCountTitle: '分时段预订订单数', bookingHourOrderCountNoData: '暂无可用分时订单数据', bookingHourOrderCountDateRange: '近7日 {start} 至 {end} ｜ 当天 {date}', bookingHourOrderCountDateOnly: '当天 {date}', bookingHourOrderCountSevenDay: '近7日累计订单', bookingHourOrderCountToday: '今天订单', bookingHourOrderUnit: '单', bookingHourOrderAxis: '订单数', viewTodayReports: '查看当日报告', backToTodayReports: '返回当日报告', backToLatestReport: '返回最新报告', historyEmpty: '暂无该智能定价报告', todayReportTitle: '{date} 当日报告', pricingTime: '定价时间', reportTitle: '报告标题', pricingChannel: '定价渠道', viewDetail: '详情', todayReportEmpty: '当日暂无已完成的房型定价报告',
  },
  inventoryPhase1: {
    itemType: '物品类型',
    itemSpec: '物品规格',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: '物品名称',
    itemCode: '物品编码',
    enterItemName: '输入物品名称',
    itemUnit: '规格单位',
    itemSort: '物品排序',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: '新建物品',
    modifyItem: '修改物品',
    warningQty: '预警数量',
    warningQtyLabel: '库存预警数量',
    salePoint: '销售点',
    scene: '使用场景',
    guestRoom: '客房',
    fnb: '餐饮',
    meeting: '会议',
    sceneSale: '支持售卖',
    sceneClean: '支持房间打扫添加',
    sceneBorrow: '支持借用',
    selectType: '请选择物品类型',
    selectSpec: '请选择物品规格',
    fillItemName: '请填写物品名称',
    selectSalePoint: '请至少选择一个销售点',
    warningCloseHint: '0表示关闭预警',
    inboundType: '入库方式',
    outboundType: '出库方式',
    manualInbound: '手工入库',
    sale: '商品售卖',
    roomClean: '房间打扫添加',
    roomBorrow: '房间借用',
    manualOutbound: '手工出库',
    newOutbound: '新增出库',
    selectOutboundType: '请选择出库方式',
    createTime: '创建时间',
    catalogSource: '来源',
    groupCatalog: '集团底账',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集团底账不能修改',
    groupCatalogCannotDelete: '集团底账不能删除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: '可售卖',
    filterRoomClean: '房间打扫可添加',
    filterRoomBorrow: '可借用',
    availableSalePoint: '可用销售点',
    borrowReturn: '借用归还',
    saleVoid: '售卖冲账',
    sortOrder: '排序',
    fillWarningQty: '请填写库存预警数量',
    warningQtyInvalid: '库存预警数量须为不小于0的整数',
  },
  aiPmsCtripPeerSync: {
    ctrip: '携程',
    account: '账号',
    mobilePlaceholder: '请输入手机号',
    code: '验证码',
    codePlaceholder: '请输入验证码',
    login: '登录',
    resend: '重新发送',
    send: '发送验证码',
    collectFailed: '携程竞对价格采集失败，请稍后刷新。',
    dataFailed: '数据获取失败',
    relogin: '重新登录',
    unbind: '解绑',
    updatedAt: '数据更新时间：{time}',
    hotelName: '酒店名',
    price: '价格',
    empty: '暂无{channel}竞对引流价数据',
    accountRequired: '请输入携程账号',
    codeRequired: '请输入短信验证码',
    loggingIn: '正在登录，登录完成会采集携程竞对价格',
    smsSent: '短信验证码已发送，请输入验证码',
    smsFailed: '短信验证码发送失败，请重新发送',
    verifyFailed: '短信验证码验证失败，请重新输入验证码后登录',
    loginFailed: '携程登录验证失败，请重新发送验证码后登录',
    deviceVerify: '携程账号需要完成设备验证，完成后可重新发送验证码登录',
    loginRequired: '请发送短信验证码，重新登录携程账号',
    expired: '携程账号失效，请登录',
    sending: '正在发送短信验证码…',
    collecting: '登录完成，正在采集携程竞对价格…',
    today: '今天 {time}',
    daysAgo: '{days}天前',
    crawlSubmitted: '已提交携程收藏酒店采集任务',
    smsSubmitted: '短信验证码发送请求已提交',
    unbindConfirm: '确定解绑当前携程账号吗？历史价格数据将保留。',
    unbindTitle: '解绑携程账号',
    unbound: '携程账号已解绑',
  },
};
